import Quill from 'quill';
var o = {
  d: (e, r) => {
    for (var a in r) o.o(r, a) && !o.o(e, a) && Object.defineProperty(e, a, { enumerable: !0, get: r[a] });
  },
  o: (e, o) => Object.prototype.hasOwnProperty.call(e, o),
};
const r = [
  { name: '100', unicode: '💯', shortname: ':100:', category: 's', emoji_order: '2119' },
  { name: '1234', unicode: '🔢', shortname: ':1234:', category: 's', emoji_order: '2122' },
  { name: 'grinning', unicode: '😀', shortname: ':grinning:', category: 'p', emoji_order: '1' },
  { name: 'grin', unicode: '😁', shortname: ':grin:', category: 'p', emoji_order: '2' },
  { name: 'joy', unicode: '😂', shortname: ':joy:', category: 'p', emoji_order: '3' },
  { name: 'rolling_on_the_floor_laughing', unicode: '🤣', shortname: ':rofl:', category: 'p', emoji_order: '4' },
  { name: 'smiley', unicode: '😃', shortname: ':smiley:', category: 'p', emoji_order: '5' },
  { name: 'smile', unicode: '😄', shortname: ':smile:', category: 'p', emoji_order: '6' },
  { name: 'sweat_smile', unicode: '😅', shortname: ':sweat_smile:', category: 'p', emoji_order: '7' },
  { name: 'laughing', unicode: '😆', shortname: ':laughing:', category: 'p', emoji_order: '8' },
  { name: 'wink', unicode: '😉', shortname: ':wink:', category: 'p', emoji_order: '9' },
  { name: 'blush', unicode: '😊', shortname: ':blush:', category: 'p', emoji_order: '10' },
  { name: 'yum', unicode: '😋', shortname: ':yum:', category: 'p', emoji_order: '11' },
  { name: 'sunglasses', unicode: '😎', shortname: ':sunglasses:', category: 'p', emoji_order: '12' },
  { name: 'heart_eyes', unicode: '😍', shortname: ':heart_eyes:', category: 'p', emoji_order: '13' },
  { name: 'kissing_heart', unicode: '😘', shortname: ':kissing_heart:', category: 'p', emoji_order: '14' },
  { name: 'kissing', unicode: '😗', shortname: ':kissing:', category: 'p', emoji_order: '15' },
  {
    name: 'kissing_smiling_eyes',
    unicode: '😙',
    shortname: ':kissing_smiling_eyes:',
    category: 'p',
    emoji_order: '16',
  },
  { name: 'kissing_closed_eyes', unicode: '😚', shortname: ':kissing_closed_eyes:', category: 'p', emoji_order: '17' },
  { name: 'slightly_smiling_face', unicode: '🙂', shortname: ':slight_smile:', category: 'p', emoji_order: '19' },
  { name: 'hugging_face', unicode: '🤗', shortname: ':hugging:', category: 'p', emoji_order: '20' },
  { name: 'thinking_face', unicode: '🤔', shortname: ':thinking:', category: 'p', emoji_order: '21' },
  { name: 'neutral_face', unicode: '😐', shortname: ':neutral_face:', category: 'p', emoji_order: '22' },
  { name: 'expressionless', unicode: '😑', shortname: ':expressionless:', category: 'p', emoji_order: '23' },
  { name: 'no_mouth', unicode: '😶', shortname: ':no_mouth:', category: 'p', emoji_order: '24' },
  { name: 'face_with_rolling_eyes', unicode: '🙄', shortname: ':rolling_eyes:', category: 'p', emoji_order: '25' },
  { name: 'smirk', unicode: '😏', shortname: ':smirk:', category: 'p', emoji_order: '26' },
  { name: 'persevere', unicode: '😣', shortname: ':persevere:', category: 'p', emoji_order: '27' },
  {
    name: 'disappointed_relieved',
    unicode: '😥',
    shortname: ':disappointed_relieved:',
    category: 'p',
    emoji_order: '28',
  },
  { name: 'open_mouth', unicode: '😮', shortname: ':open_mouth:', category: 'p', emoji_order: '29' },
  { name: 'zipper_mouth_face', unicode: '🤐', shortname: ':zipper_mouth:', category: 'p', emoji_order: '30' },
  { name: 'hushed', unicode: '😯', shortname: ':hushed:', category: 'p', emoji_order: '31' },
  { name: 'sleepy', unicode: '😪', shortname: ':sleepy:', category: 'p', emoji_order: '32' },
  { name: 'tired_face', unicode: '😫', shortname: ':tired_face:', category: 'p', emoji_order: '33' },
  { name: 'sleeping', unicode: '😴', shortname: ':sleeping:', category: 'p', emoji_order: '34' },
  { name: 'relieved', unicode: '😌', shortname: ':relieved:', category: 'p', emoji_order: '35' },
  { name: 'nerd_face', unicode: '🤓', shortname: ':nerd:', category: 'p', emoji_order: '36' },
  { name: 'stuck_out_tongue', unicode: '😛', shortname: ':stuck_out_tongue:', category: 'p', emoji_order: '37' },
  {
    name: 'stuck_out_tongue_winking_eye',
    unicode: '😜',
    shortname: ':stuck_out_tongue_winking_eye:',
    category: 'p',
    emoji_order: '38',
  },
  {
    name: 'stuck_out_tongue_closed_eyes',
    unicode: '😝',
    shortname: ':stuck_out_tongue_closed_eyes:',
    category: 'p',
    emoji_order: '39',
  },
  { name: 'drooling_face', unicode: '🤤', shortname: ':drooling_face:', category: 'p', emoji_order: '40' },
  { name: 'unamused', unicode: '😒', shortname: ':unamused:', category: 'p', emoji_order: '41' },
  { name: 'sweat', unicode: '😓', shortname: ':sweat:', category: 'p', emoji_order: '42' },
  { name: 'pensive', unicode: '😔', shortname: ':pensive:', category: 'p', emoji_order: '43' },
  { name: 'confused', unicode: '😕', shortname: ':confused:', category: 'p', emoji_order: '44' },
  { name: 'upside_down_face', unicode: '🙃', shortname: ':upside_down:', category: 'p', emoji_order: '45' },
  { name: 'money_mouth_face', unicode: '🤑', shortname: ':money_mouth:', category: 'p', emoji_order: '46' },
  { name: 'astonished', unicode: '😲', shortname: ':astonished:', category: 'p', emoji_order: '47' },
  { name: 'slightly_frowning_face', unicode: '🙁', shortname: ':slight_frown:', category: 'p', emoji_order: '49' },
  { name: 'confounded', unicode: '😖', shortname: ':confounded:', category: 'p', emoji_order: '50' },
  { name: 'disappointed', unicode: '😞', shortname: ':disappointed:', category: 'p', emoji_order: '51' },
  { name: 'worried', unicode: '😟', shortname: ':worried:', category: 'p', emoji_order: '52' },
  { name: 'triumph', unicode: '😤', shortname: ':triumph:', category: 'p', emoji_order: '53' },
  { name: 'cry', unicode: '😢', shortname: ':cry:', category: 'p', emoji_order: '54' },
  { name: 'sob', unicode: '😭', shortname: ':sob:', category: 'p', emoji_order: '55' },
  { name: 'frowning', unicode: '😦', shortname: ':frowning:', category: 'p', emoji_order: '56' },
  { name: 'anguished', unicode: '😧', shortname: ':anguished:', category: 'p', emoji_order: '57' },
  { name: 'fearful', unicode: '😨', shortname: ':fearful:', category: 'p', emoji_order: '58' },
  { name: 'weary', unicode: '😩', shortname: ':weary:', category: 'p', emoji_order: '59' },
  { name: 'grimacing', unicode: '😬', shortname: ':grimacing:', category: 'p', emoji_order: '60' },
  { name: 'cold_sweat', unicode: '😰', shortname: ':cold_sweat:', category: 'p', emoji_order: '61' },
  { name: 'scream', unicode: '😱', shortname: ':scream:', category: 'p', emoji_order: '62' },
  { name: 'flushed', unicode: '😳', shortname: ':flushed:', category: 'p', emoji_order: '63' },
  { name: 'dizzy_face', unicode: '😵', shortname: ':dizzy_face:', category: 'p', emoji_order: '64' },
  { name: 'rage', unicode: '😡', shortname: ':rage:', category: 'p', emoji_order: '65' },
  { name: 'angry', unicode: '😠', shortname: ':angry:', category: 'p', emoji_order: '66' },
  { name: 'innocent', unicode: '😇', shortname: ':innocent:', category: 'p', emoji_order: '67' },
  { name: 'face_with_cowboy_hat', unicode: '🤠', shortname: ':cowboy:', category: 'p', emoji_order: '68' },
  { name: 'clown_face', unicode: '🤡', shortname: ':clown:', category: 'p', emoji_order: '69' },
  { name: 'lying_face', unicode: '🤥', shortname: ':lying_face:', category: 'p', emoji_order: '70' },
  { name: 'mask', unicode: '😷', shortname: ':mask:', category: 'p', emoji_order: '71' },
  { name: 'face_with_thermometer', unicode: '🤒', shortname: ':thermometer_face:', category: 'p', emoji_order: '72' },
  { name: 'face_with_head_bandage', unicode: '🤕', shortname: ':head_bandage:', category: 'p', emoji_order: '73' },
  { name: 'nauseated_face', unicode: '🤢', shortname: ':nauseated_face:', category: 'p', emoji_order: '74' },
  { name: 'sneezing_face', unicode: '🤧', shortname: ':sneezing_face:', category: 'p', emoji_order: '75' },
  { name: 'smiling_imp', unicode: '😈', shortname: ':smiling_imp:', category: 'p', emoji_order: '76' },
  { name: 'imp', unicode: '👿', shortname: ':imp:', category: 'p', emoji_order: '77' },
  { name: 'japanese_ogre', unicode: '👹', shortname: ':japanese_ogre:', category: 'p', emoji_order: '78' },
  { name: 'japanese_goblin', unicode: '👺', shortname: ':japanese_goblin:', category: 'p', emoji_order: '79' },
  { name: 'skull', unicode: '💀', shortname: ':skull:', category: 'p', emoji_order: '80' },
  { name: 'skull_and_crossbones', unicode: '☠', shortname: ':skull_crossbones:', category: 'o', emoji_order: '81' },
  { name: 'ghost', unicode: '👻', shortname: ':ghost:', category: 'p', emoji_order: '82' },
  { name: 'alien', unicode: '👽', shortname: ':alien:', category: 'p', emoji_order: '83' },
  { name: 'space_invader', unicode: '👾', shortname: ':space_invader:', category: 'a', emoji_order: '84' },
  { name: 'robot_face', unicode: '🤖', shortname: ':robot:', category: 'p', emoji_order: '85' },
  { name: 'hankey', unicode: '💩', shortname: ':poop:', category: 'p', emoji_order: '86' },
  { name: 'smiley_cat', unicode: '😺', shortname: ':smiley_cat:', category: 'p', emoji_order: '87' },
  { name: 'smile_cat', unicode: '😸', shortname: ':smile_cat:', category: 'p', emoji_order: '88' },
  { name: 'joy_cat', unicode: '😹', shortname: ':joy_cat:', category: 'p', emoji_order: '89' },
  { name: 'heart_eyes_cat', unicode: '😻', shortname: ':heart_eyes_cat:', category: 'p', emoji_order: '90' },
  { name: 'smirk_cat', unicode: '😼', shortname: ':smirk_cat:', category: 'p', emoji_order: '91' },
  { name: 'kissing_cat', unicode: '😽', shortname: ':kissing_cat:', category: 'p', emoji_order: '92' },
  { name: 'scream_cat', unicode: '🙀', shortname: ':scream_cat:', category: 'p', emoji_order: '93' },
  { name: 'crying_cat_face', unicode: '😿', shortname: ':crying_cat_face:', category: 'p', emoji_order: '94' },
  { name: 'pouting_cat', unicode: '😾', shortname: ':pouting_cat:', category: 'p', emoji_order: '95' },
  { name: 'see_no_evil', unicode: '🙈', shortname: ':see_no_evil:', category: 'n', emoji_order: '96' },
  { name: 'hear_no_evil', unicode: '🙉', shortname: ':hear_no_evil:', category: 'n', emoji_order: '97' },
  { name: 'speak_no_evil', unicode: '🙊', shortname: ':speak_no_evil:', category: 'n', emoji_order: '98' },
  { name: 'boy', unicode: '👦', shortname: ':boy:', category: 'p', emoji_order: '99' },
  { name: 'girl', unicode: '👧', shortname: ':girl:', category: 'p', emoji_order: '105' },
  { name: 'man', unicode: '👨', shortname: ':man:', category: 'p', emoji_order: '111' },
  { name: 'woman', unicode: '👩', shortname: ':woman:', category: 'p', emoji_order: '117' },
  { name: 'older_man', unicode: '👴', shortname: ':older_man:', category: 'p', emoji_order: '123' },
  { name: 'older_woman', unicode: '👵', shortname: ':older_woman:', category: 'p', emoji_order: '129' },
  { name: 'baby', unicode: '👶', shortname: ':baby:', category: 'p', emoji_order: '135' },
  { name: 'angel', unicode: '👼', shortname: ':angel:', category: 'p', emoji_order: '141' },
  { name: 'cop', unicode: '👮', shortname: ':cop:', category: 'p', emoji_order: '339' },
  { name: 'sleuth_or_spy', unicode: '🕵', shortname: ':spy:', category: 'p', emoji_order: '357' },
  { name: 'guardsman', unicode: '💂', shortname: ':guardsman:', category: 'p', emoji_order: '375' },
  { name: 'construction_worker', unicode: '👷', shortname: ':construction_worker:', category: 'p', emoji_order: '393' },
  { name: 'man_with_turban', unicode: '👳', shortname: ':man_with_turban:', category: 'p', emoji_order: '411' },
  {
    name: 'person_with_blond_hair',
    unicode: '👱',
    shortname: ':person_with_blond_hair:',
    category: 'p',
    emoji_order: '429',
  },
  { name: 'santa', unicode: '🎅', shortname: ':santa:', category: 'p', emoji_order: '447' },
  { name: 'mrs_claus', unicode: '🤶', shortname: ':mrs_claus:', category: 'p', emoji_order: '453' },
  { name: 'princess', unicode: '👸', shortname: ':princess:', category: 'p', emoji_order: '459' },
  { name: 'prince', unicode: '🤴', shortname: ':prince:', category: 'p', emoji_order: '465' },
  { name: 'bride_with_veil', unicode: '👰', shortname: ':bride_with_veil:', category: 'p', emoji_order: '471' },
  { name: 'man_in_tuxedo', unicode: '🤵', shortname: ':man_in_tuxedo:', category: 'p', emoji_order: '477' },
  { name: 'pregnant_woman', unicode: '🤰', shortname: ':pregnant_woman:', category: 'p', emoji_order: '483' },
  { name: 'man_with_gua_pi_mao', unicode: '👲', shortname: ':man_with_gua_pi_mao:', category: 'p', emoji_order: '489' },
  { name: 'person_frowning', unicode: '🙍', shortname: ':person_frowning:', category: 'p', emoji_order: '495' },
  {
    name: 'person_with_pouting_face',
    unicode: '🙎',
    shortname: ':person_with_pouting_face:',
    category: 'p',
    emoji_order: '513',
  },
  { name: 'no_good', unicode: '🙅', shortname: ':no_good:', category: 'p', emoji_order: '531' },
  { name: 'ok_woman', unicode: '🙆', shortname: ':ok_woman:', category: 'p', emoji_order: '549' },
  {
    name: 'information_desk_person',
    unicode: '💁',
    shortname: ':information_desk_person:',
    category: 'p',
    emoji_order: '567',
  },
  { name: 'raising_hand', unicode: '🙋', shortname: ':raising_hand:', category: 'p', emoji_order: '585' },
  { name: 'bow', unicode: '🙇', shortname: ':bow:', category: 'p', emoji_order: '603' },
  { name: 'face_palm', unicode: '🤦', shortname: ':face_palm:', category: 'p', emoji_order: '621' },
  { name: 'shrug', unicode: '🤷', shortname: ':shrug:', category: 'p', emoji_order: '639' },
  { name: 'massage', unicode: '💆', shortname: ':massage:', category: 'p', emoji_order: '657' },
  { name: 'haircut', unicode: '💇', shortname: ':haircut:', category: 'p', emoji_order: '675' },
  { name: 'walking', unicode: '🚶', shortname: ':walking:', category: 'p', emoji_order: '693' },
  { name: 'runner', unicode: '🏃', shortname: ':runner:', category: 'p', emoji_order: '711' },
  { name: 'dancer', unicode: '💃', shortname: ':dancer:', category: 'p', emoji_order: '729' },
  { name: 'man_dancing', unicode: '🕺', shortname: ':man_dancing:', category: 'p', emoji_order: '735' },
  { name: 'dancers', unicode: '👯', shortname: ':dancers:', category: 'p', emoji_order: '741' },
  {
    name: 'man_in_business_suit_levitating',
    unicode: '🕴',
    shortname: ':levitate:',
    category: 'a',
    emoji_order: '759',
  },
  {
    name: 'speaking_head_in_silhouette',
    unicode: '🗣',
    shortname: ':speaking_head:',
    category: 'p',
    emoji_order: '765',
  },
  { name: 'bust_in_silhouette', unicode: '👤', shortname: ':bust_in_silhouette:', category: 'p', emoji_order: '766' },
  { name: 'busts_in_silhouette', unicode: '👥', shortname: ':busts_in_silhouette:', category: 'p', emoji_order: '767' },
  { name: 'fencer', unicode: '🤺', shortname: ':fencer:', category: 'a', emoji_order: '768' },
  { name: 'horse_racing', unicode: '🏇', shortname: ':horse_racing:', category: 'a', emoji_order: '769' },
  { name: 'skier', unicode: '⛷', shortname: ':skier:', category: 'a', emoji_order: '775' },
  { name: 'snowboarder', unicode: '🏂', shortname: ':snowboarder:', category: 'a', emoji_order: '776' },
  { name: 'golfer', unicode: '🏌', shortname: ':golfer:', category: 'a', emoji_order: '782' },
  { name: 'surfer', unicode: '🏄', shortname: ':surfer:', category: 'a', emoji_order: '800' },
  { name: 'rowboat', unicode: '🚣', shortname: ':rowboat:', category: 'a', emoji_order: '818' },
  { name: 'swimmer', unicode: '🏊', shortname: ':swimmer:', category: 'a', emoji_order: '836' },
  { name: 'person_with_ball', unicode: '⛹', shortname: ':basketball_player:', category: 'a', emoji_order: '854' },
  { name: 'weight_lifter', unicode: '🏋', shortname: ':lifter:', category: 'a', emoji_order: '872' },
  { name: 'bicyclist', unicode: '🚴', shortname: ':bicyclist:', category: 'a', emoji_order: '890' },
  { name: 'mountain_bicyclist', unicode: '🚵', shortname: ':mountain_bicyclist:', category: 'a', emoji_order: '908' },
  { name: 'racing_car', unicode: '🏎', shortname: ':race_car:', category: 't', emoji_order: '926' },
  { name: 'racing_motorcycle', unicode: '🏍', shortname: ':motorcycle:', category: 't', emoji_order: '927' },
  { name: 'cartwheel', unicode: '🤸', shortname: ':cartwheel:', category: 'a', emoji_order: '928' },
  { name: 'wrestlers', unicode: '🤼', shortname: ':wrestlers:', category: 'a', emoji_order: '946' },
  { name: 'water_polo', unicode: '🤽', shortname: ':water_polo:', category: 'a', emoji_order: '964' },
  { name: 'handball', unicode: '🤾', shortname: ':handball:', category: 'a', emoji_order: '982' },
  { name: 'juggling', unicode: '🤹', shortname: ':juggling:', category: 'a', emoji_order: '1000' },
  { name: 'couple', unicode: '👫', shortname: ':couple:', category: 'p', emoji_order: '1018' },
  {
    name: 'two_men_holding_hands',
    unicode: '👬',
    shortname: ':two_men_holding_hands:',
    category: 'p',
    emoji_order: '1024',
  },
  {
    name: 'two_women_holding_hands',
    unicode: '👭',
    shortname: ':two_women_holding_hands:',
    category: 'p',
    emoji_order: '1030',
  },
  { name: 'couplekiss', unicode: '💏', shortname: ':couplekiss:', category: 'p', emoji_order: '1036' },
  { name: 'couple_with_heart', unicode: '💑', shortname: ':couple_with_heart:', category: 'p', emoji_order: '1040' },
  { name: 'family', unicode: '👪', shortname: ':family:', category: 'p', emoji_order: '1044' },
  { name: 'muscle', unicode: '💪', shortname: ':muscle:', category: 'p', emoji_order: '1080' },
  { name: 'selfie', unicode: '🤳', shortname: ':selfie:', category: 'p', emoji_order: '1086' },
  { name: 'point_left', unicode: '👈', shortname: ':point_left:', category: 'p', emoji_order: '1092' },
  { name: 'point_right', unicode: '👉', shortname: ':point_right:', category: 'p', emoji_order: '1098' },
  { name: 'point_up', unicode: '☝', shortname: ':point_up:', category: 'p', emoji_order: '1104' },
  { name: 'point_up_2', unicode: '👆', shortname: ':point_up_2:', category: 'p', emoji_order: '1110' },
  { name: 'middle_finger', unicode: '🖕', shortname: ':middle_finger:', category: 'p', emoji_order: '1116' },
  { name: 'point_down', unicode: '👇', shortname: ':point_down:', category: 'p', emoji_order: '1122' },
  { name: 'v', unicode: '✌', shortname: ':v:', category: 'p', emoji_order: '1128' },
  { name: 'fingers_crossed', unicode: '🤞', shortname: ':fingers_crossed:', category: 'p', emoji_order: '1134' },
  { name: 'vulcan', unicode: '🖖', shortname: ':vulcan:', category: 'p', emoji_order: '1140' },
  { name: 'the_horns', unicode: '🤘', shortname: ':metal_tone2:', category: 'p', emoji_order: '1146' },
  { name: 'call_me', unicode: '🤙', shortname: ':call_me:', category: 'p', emoji_order: '1152' },
  {
    name: 'raised_hand_with_fingers_splayed',
    unicode: '🖐',
    shortname: ':hand_splayed:',
    category: 'p',
    emoji_order: '1158',
  },
  { name: 'raised_hand', unicode: '✋', shortname: ':raised_hand:', category: 'p', emoji_order: '1164' },
  { name: 'ok_hand', unicode: '👌', shortname: ':ok_hand:', category: 'p', emoji_order: '1170' },
  { name: 'thumbsup', unicode: '👍', shortname: ':thumbsup:', category: 'p', emoji_order: '1176' },
  { name: 'thumbsdown', unicode: '👎', shortname: ':thumbsdown:', category: 'p', emoji_order: '1182' },
  { name: 'fist', unicode: '✊', shortname: ':fist:', category: 'p', emoji_order: '1188' },
  { name: 'facepunch', unicode: '👊', shortname: ':punch:', category: 'p', emoji_order: '1194' },
  { name: 'left_facing_fist', unicode: '🤛', shortname: ':left_facing_fist:', category: 'p', emoji_order: '1200' },
  { name: 'right_facing_fist', unicode: '🤜', shortname: ':right_facing_fist:', category: 'p', emoji_order: '1206' },
  {
    name: 'raised_back_of_hand',
    unicode: '🤚',
    shortname: ':raised_back_of_hand:',
    category: 'p',
    emoji_order: '1212',
  },
  { name: 'wave', unicode: '👋', shortname: ':wave:', category: 'p', emoji_order: '1218' },
  { name: 'clap', unicode: '👏', shortname: ':clap:', category: 'p', emoji_order: '1224' },
  { name: 'writing_hand', unicode: '✍', shortname: ':writing_hand:', category: 'p', emoji_order: '1230' },
  { name: 'open_hands', unicode: '👐', shortname: ':open_hands:', category: 'p', emoji_order: '1236' },
  { name: 'raised_hands', unicode: '🙌', shortname: ':raised_hands:', category: 'p', emoji_order: '1242' },
  { name: 'pray', unicode: '🙏', shortname: ':pray:', category: 'p', emoji_order: '1248' },
  { name: 'handshake', unicode: '🤝', shortname: ':handshake:', category: 'p', emoji_order: '1254' },
  { name: 'nail_care', unicode: '💅', shortname: ':nail_care:', category: 'p', emoji_order: '1260' },
  { name: 'ear', unicode: '👂', shortname: ':ear:', category: 'p', emoji_order: '1266' },
  { name: 'nose', unicode: '👃', shortname: ':nose:', category: 'p', emoji_order: '1272' },
  { name: 'footprints', unicode: '👣', shortname: ':footprints:', category: 'p', emoji_order: '1278' },
  { name: 'eyes', unicode: '👀', shortname: ':eyes:', category: 'p', emoji_order: '1279' },
  { name: 'eye', unicode: '👁', shortname: ':eye:', category: 'p', emoji_order: '1280' },
  { name: 'tongue', unicode: '👅', shortname: ':tongue:', category: 'p', emoji_order: '1282' },
  { name: 'lips', unicode: '👄', shortname: ':lips:', category: 'p', emoji_order: '1283' },
  { name: 'kiss', unicode: '💋', shortname: ':kiss:', category: 'p', emoji_order: '1284' },
  { name: 'cupid', unicode: '💘', shortname: ':cupid:', category: 's', emoji_order: '1285' },
  { name: 'heart', unicode: '❤', shortname: ':heart:', category: 's', emoji_order: '1286' },
  { name: 'heartbeat', unicode: '💓', shortname: ':heartbeat:', category: 's', emoji_order: '1287' },
  { name: 'broken_heart', unicode: '💔', shortname: ':broken_heart:', category: 's', emoji_order: '1288' },
  { name: 'two_hearts', unicode: '💕', shortname: ':two_hearts:', category: 's', emoji_order: '1289' },
  { name: 'sparkling_heart', unicode: '💖', shortname: ':sparkling_heart:', category: 's', emoji_order: '1290' },
  { name: 'heartpulse', unicode: '💗', shortname: ':heartpulse:', category: 's', emoji_order: '1291' },
  { name: 'blue_heart', unicode: '💙', shortname: ':blue_heart:', category: 's', emoji_order: '1292' },
  { name: 'green_heart', unicode: '💚', shortname: ':green_heart:', category: 's', emoji_order: '1293' },
  { name: 'yellow_heart', unicode: '💛', shortname: ':yellow_heart:', category: 's', emoji_order: '1294' },
  { name: 'purple_heart', unicode: '💜', shortname: ':purple_heart:', category: 's', emoji_order: '1295' },
  { name: 'black_heart', unicode: '🖤', shortname: ':black_heart:', category: 's', emoji_order: '1296' },
  { name: 'gift_heart', unicode: '💝', shortname: ':gift_heart:', category: 's', emoji_order: '1297' },
  { name: 'revolving_hearts', unicode: '💞', shortname: ':revolving_hearts:', category: 's', emoji_order: '1298' },
  { name: 'heart_decoration', unicode: '💟', shortname: ':heart_decoration:', category: 's', emoji_order: '1299' },
  { name: 'heart_exclamation', unicode: '❣', shortname: ':heart_exclamation:', category: 's', emoji_order: '1300' },
  { name: 'love_letter', unicode: '💌', shortname: ':love_letter:', category: 'o', emoji_order: '1301' },
  { name: 'zzz', unicode: '💤', shortname: ':zzz:', category: 'p', emoji_order: '1302' },
  { name: 'anger', unicode: '💢', shortname: ':anger:', category: 's', emoji_order: '1303' },
  { name: 'bomb', unicode: '💣', shortname: ':bomb:', category: 'o', emoji_order: '1304' },
  { name: 'boom', unicode: '💥', shortname: ':boom:', category: 's', emoji_order: '1305' },
  { name: 'sweat_drops', unicode: '💦', shortname: ':sweat_drops:', category: 'n', emoji_order: '1306' },
  { name: 'dash', unicode: '💨', shortname: ':dash:', category: 'n', emoji_order: '1307' },
  { name: 'dizzy', unicode: '💫', shortname: ':dizzy:', category: 's', emoji_order: '1308' },
  { name: 'speech_balloon', unicode: '💬', shortname: ':speech_balloon:', category: 's', emoji_order: '1309' },
  { name: 'left_speech_bubble', unicode: '🗨', shortname: ':speech_left:', category: 's', emoji_order: '1310' },
  { name: 'right_anger_bubble', unicode: '🗯', shortname: ':anger_right:', category: 's', emoji_order: '1311' },
  { name: 'thought_balloon', unicode: '💭', shortname: ':thought_balloon:', category: 's', emoji_order: '1312' },
  { name: 'hole', unicode: '🕳', shortname: ':hole:', category: 'o', emoji_order: '1313' },
  { name: 'eyeglasses', unicode: '👓', shortname: ':eyeglasses:', category: 'p', emoji_order: '1314' },
  { name: 'dark_sunglasses', unicode: '🕶', shortname: ':dark_sunglasses:', category: 'p', emoji_order: '1315' },
  { name: 'necktie', unicode: '👔', shortname: ':necktie:', category: 'p', emoji_order: '1316' },
  { name: 'shirt', unicode: '👕', shortname: ':shirt:', category: 'p', emoji_order: '1317' },
  { name: 'jeans', unicode: '👖', shortname: ':jeans:', category: 'p', emoji_order: '1318' },
  { name: 'dress', unicode: '👗', shortname: ':dress:', category: 'p', emoji_order: '1319' },
  { name: 'kimono', unicode: '👘', shortname: ':kimono:', category: 'p', emoji_order: '1320' },
  { name: 'bikini', unicode: '👙', shortname: ':bikini:', category: 'p', emoji_order: '1321' },
  { name: 'womans_clothes', unicode: '👚', shortname: ':womans_clothes:', category: 'p', emoji_order: '1322' },
  { name: 'purse', unicode: '👛', shortname: ':purse:', category: 'p', emoji_order: '1323' },
  { name: 'handbag', unicode: '👜', shortname: ':handbag:', category: 'p', emoji_order: '1324' },
  { name: 'pouch', unicode: '👝', shortname: ':pouch:', category: 'p', emoji_order: '1325' },
  { name: 'shopping_bags', unicode: '🛍', shortname: ':shopping_bags:', category: 'o', emoji_order: '1326' },
  { name: 'school_satchel', unicode: '🎒', shortname: ':school_satchel:', category: 'p', emoji_order: '1327' },
  { name: 'mans_shoe', unicode: '👞', shortname: ':mans_shoe:', category: 'p', emoji_order: '1328' },
  { name: 'athletic_shoe', unicode: '👟', shortname: ':athletic_shoe:', category: 'p', emoji_order: '1329' },
  { name: 'high_heel', unicode: '👠', shortname: ':high_heel:', category: 'p', emoji_order: '1330' },
  { name: 'sandal', unicode: '👡', shortname: ':sandal:', category: 'p', emoji_order: '1331' },
  { name: 'boot', unicode: '👢', shortname: ':boot:', category: 'p', emoji_order: '1332' },
  { name: 'crown', unicode: '👑', shortname: ':crown:', category: 'p', emoji_order: '1333' },
  { name: 'womans_hat', unicode: '👒', shortname: ':womans_hat:', category: 'p', emoji_order: '1334' },
  { name: 'tophat', unicode: '🎩', shortname: ':tophat:', category: 'p', emoji_order: '1335' },
  { name: 'mortar_board', unicode: '🎓', shortname: ':mortar_board:', category: 'p', emoji_order: '1336' },
  {
    name: 'helmet_with_white_cross',
    unicode: '⛑',
    shortname: ':helmet_with_cross:',
    category: 'p',
    emoji_order: '1337',
  },
  { name: 'prayer_beads', unicode: '📿', shortname: ':prayer_beads:', category: 'o', emoji_order: '1338' },
  { name: 'lipstick', unicode: '💄', shortname: ':lipstick:', category: 'p', emoji_order: '1339' },
  { name: 'ring', unicode: '💍', shortname: ':ring:', category: 'p', emoji_order: '1340' },
  { name: 'gem', unicode: '💎', shortname: ':gem:', category: 'o', emoji_order: '1341' },
  { name: 'monkey_face', unicode: '🐵', shortname: ':monkey_face:', category: 'n', emoji_order: '1342' },
  { name: 'monkey', unicode: '🐒', shortname: ':monkey:', category: 'n', emoji_order: '1343' },
  { name: 'gorilla', unicode: '🦍', shortname: ':gorilla:', category: 'n', emoji_order: '1344' },
  { name: 'dog', unicode: '🐶', shortname: ':dog:', category: 'n', emoji_order: '1345' },
  { name: 'dog2', unicode: '🐕', shortname: ':dog2:', category: 'n', emoji_order: '1346' },
  { name: 'poodle', unicode: '🐩', shortname: ':poodle:', category: 'n', emoji_order: '1347' },
  { name: 'wolf', unicode: '🐺', shortname: ':wolf:', category: 'n', emoji_order: '1348' },
  { name: 'fox', unicode: '🦊', shortname: ':fox:', category: 'n', emoji_order: '1349' },
  { name: 'cat', unicode: '🐱', shortname: ':cat:', category: 'n', emoji_order: '1350' },
  { name: 'cat2', unicode: '🐈', shortname: ':cat2:', category: 'n', emoji_order: '1351' },
  { name: 'lion_face', unicode: '🦁', shortname: ':lion_face:', category: 'n', emoji_order: '1352' },
  { name: 'tiger', unicode: '🐯', shortname: ':tiger:', category: 'n', emoji_order: '1353' },
  { name: 'tiger2', unicode: '🐅', shortname: ':tiger2:', category: 'n', emoji_order: '1354' },
  { name: 'leopard', unicode: '🐆', shortname: ':leopard:', category: 'n', emoji_order: '1355' },
  { name: 'horse', unicode: '🐴', shortname: ':horse:', category: 'n', emoji_order: '1356' },
  { name: 'racehorse', unicode: '🐎', shortname: ':racehorse:', category: 'n', emoji_order: '1357' },
  { name: 'deer', unicode: '🦌', shortname: ':deer:', category: 'n', emoji_order: '1358' },
  { name: 'unicorn_face', unicode: '🦄', shortname: ':unicorn:', category: 'n', emoji_order: '1359' },
  { name: 'cow', unicode: '🐮', shortname: ':cow:', category: 'n', emoji_order: '1360' },
  { name: 'ox', unicode: '🐂', shortname: ':ox:', category: 'n', emoji_order: '1361' },
  { name: 'water_buffalo', unicode: '🐃', shortname: ':water_buffalo:', category: 'n', emoji_order: '1362' },
  { name: 'cow2', unicode: '🐄', shortname: ':cow2:', category: 'n', emoji_order: '1363' },
  { name: 'pig', unicode: '🐷', shortname: ':pig:', category: 'n', emoji_order: '1364' },
  { name: 'pig2', unicode: '🐖', shortname: ':pig2:', category: 'n', emoji_order: '1365' },
  { name: 'boar', unicode: '🐗', shortname: ':boar:', category: 'n', emoji_order: '1366' },
  { name: 'pig_nose', unicode: '🐽', shortname: ':pig_nose:', category: 'n', emoji_order: '1367' },
  { name: 'ram', unicode: '🐏', shortname: ':ram:', category: 'n', emoji_order: '1368' },
  { name: 'sheep', unicode: '🐑', shortname: ':sheep:', category: 'n', emoji_order: '1369' },
  { name: 'goat', unicode: '🐐', shortname: ':goat:', category: 'n', emoji_order: '1370' },
  { name: 'dromedary_camel', unicode: '🐪', shortname: ':dromedary_camel:', category: 'n', emoji_order: '1371' },
  { name: 'camel', unicode: '🐫', shortname: ':camel:', category: 'n', emoji_order: '1372' },
  { name: 'elephant', unicode: '🐘', shortname: ':elephant:', category: 'n', emoji_order: '1373' },
  { name: 'rhino', unicode: '🦏', shortname: ':rhino:', category: 'n', emoji_order: '1374' },
  { name: 'mouse', unicode: '🐭', shortname: ':mouse:', category: 'n', emoji_order: '1375' },
  { name: 'mouse2', unicode: '🐁', shortname: ':mouse2:', category: 'n', emoji_order: '1376' },
  { name: 'rat', unicode: '🐀', shortname: ':rat:', category: 'n', emoji_order: '1377' },
  { name: 'hamster', unicode: '🐹', shortname: ':hamster:', category: 'n', emoji_order: '1378' },
  { name: 'rabbit', unicode: '🐰', shortname: ':rabbit:', category: 'n', emoji_order: '1379' },
  { name: 'rabbit2', unicode: '🐇', shortname: ':rabbit2:', category: 'n', emoji_order: '1380' },
  { name: 'chipmunk', unicode: '🐿', shortname: ':chipmunk:', category: 'n', emoji_order: '1381' },
  { name: 'bat', unicode: '🦇', shortname: ':bat:', category: 'n', emoji_order: '1382' },
  { name: 'bear', unicode: '🐻', shortname: ':bear:', category: 'n', emoji_order: '1383' },
  { name: 'koala', unicode: '🐨', shortname: ':koala:', category: 'n', emoji_order: '1384' },
  { name: 'panda_face', unicode: '🐼', shortname: ':panda_face:', category: 'n', emoji_order: '1385' },
  { name: 'feet', unicode: '🐾', shortname: ':feet:', category: 'n', emoji_order: '1386' },
  { name: 'turkey', unicode: '🦃', shortname: ':turkey:', category: 'n', emoji_order: '1387' },
  { name: 'chicken', unicode: '🐔', shortname: ':chicken:', category: 'n', emoji_order: '1388' },
  { name: 'rooster', unicode: '🐓', shortname: ':rooster:', category: 'n', emoji_order: '1389' },
  { name: 'hatching_chick', unicode: '🐣', shortname: ':hatching_chick:', category: 'n', emoji_order: '1390' },
  { name: 'baby_chick', unicode: '🐤', shortname: ':baby_chick:', category: 'n', emoji_order: '1391' },
  { name: 'hatched_chick', unicode: '🐥', shortname: ':hatched_chick:', category: 'n', emoji_order: '1392' },
  { name: 'bird', unicode: '🐦', shortname: ':bird:', category: 'n', emoji_order: '1393' },
  { name: 'penguin', unicode: '🐧', shortname: ':penguin:', category: 'n', emoji_order: '1394' },
  { name: 'dove_of_peace', unicode: '🕊', shortname: ':dove:', category: 'n', emoji_order: '1395' },
  { name: 'eagle', unicode: '🦅', shortname: ':eagle:', category: 'n', emoji_order: '1396' },
  { name: 'duck', unicode: '🦆', shortname: ':duck:', category: 'n', emoji_order: '1397' },
  { name: 'owl', unicode: '🦉', shortname: ':owl:', category: 'n', emoji_order: '1398' },
  { name: 'frog', unicode: '🐸', shortname: ':frog:', category: 'n', emoji_order: '1399' },
  { name: 'crocodile', unicode: '🐊', shortname: ':crocodile:', category: 'n', emoji_order: '1400' },
  { name: 'turtle', unicode: '🐢', shortname: ':turtle:', category: 'n', emoji_order: '1401' },
  { name: 'lizard', unicode: '🦎', shortname: ':lizard:', category: 'n', emoji_order: '1402' },
  { name: 'snake', unicode: '🐍', shortname: ':snake:', category: 'n', emoji_order: '1403' },
  { name: 'dragon_face', unicode: '🐲', shortname: ':dragon_face:', category: 'n', emoji_order: '1404' },
  { name: 'dragon', unicode: '🐉', shortname: ':dragon:', category: 'n', emoji_order: '1405' },
  { name: 'whale', unicode: '🐳', shortname: ':whale:', category: 'n', emoji_order: '1406' },
  { name: 'whale2', unicode: '🐋', shortname: ':whale2:', category: 'n', emoji_order: '1407' },
  { name: 'dolphin', unicode: '🐬', shortname: ':dolphin:', category: 'n', emoji_order: '1408' },
  { name: 'fish', unicode: '🐟', shortname: ':fish:', category: 'n', emoji_order: '1409' },
  { name: 'tropical_fish', unicode: '🐠', shortname: ':tropical_fish:', category: 'n', emoji_order: '1410' },
  { name: 'blowfish', unicode: '🐡', shortname: ':blowfish:', category: 'n', emoji_order: '1411' },
  { name: 'shark', unicode: '🦈', shortname: ':shark:', category: 'n', emoji_order: '1412' },
  { name: 'octopus', unicode: '🐙', shortname: ':octopus:', category: 'n', emoji_order: '1413' },
  { name: 'shell', unicode: '🐚', shortname: ':shell:', category: 'n', emoji_order: '1414' },
  { name: 'crab', unicode: '🦀', shortname: ':crab:', category: 'n', emoji_order: '1415' },
  { name: 'shrimp', unicode: '🦐', shortname: ':shrimp:', category: 'n', emoji_order: '1416' },
  { name: 'squid', unicode: '🦑', shortname: ':squid:', category: 'n', emoji_order: '1417' },
  { name: 'butterfly', unicode: '🦋', shortname: ':butterfly:', category: 'n', emoji_order: '1418' },
  { name: 'snail', unicode: '🐌', shortname: ':snail:', category: 'n', emoji_order: '1419' },
  { name: 'bug', unicode: '🐛', shortname: ':bug:', category: 'n', emoji_order: '1420' },
  { name: 'ant', unicode: '🐜', shortname: ':ant:', category: 'n', emoji_order: '1421' },
  { name: 'bee', unicode: '🐝', shortname: ':bee:', category: 'n', emoji_order: '1422' },
  { name: 'beetle', unicode: '🐞', shortname: ':beetle:', category: 'n', emoji_order: '1423' },
  { name: 'spider', unicode: '🕷', shortname: ':spider:', category: 'n', emoji_order: '1424' },
  { name: 'spider_web', unicode: '🕸', shortname: ':spider_web:', category: 'n', emoji_order: '1425' },
  { name: 'scorpion', unicode: '🦂', shortname: ':scorpion:', category: 'n', emoji_order: '1426' },
  { name: 'bouquet', unicode: '💐', shortname: ':bouquet:', category: 'n', emoji_order: '1427' },
  { name: 'cherry_blossom', unicode: '🌸', shortname: ':cherry_blossom:', category: 'n', emoji_order: '1428' },
  { name: 'white_flower', unicode: '💮', shortname: ':white_flower:', category: 's', emoji_order: '1429' },
  { name: 'rosette', unicode: '🏵', shortname: ':rosette:', category: 'n', emoji_order: '1430' },
  { name: 'rose', unicode: '🌹', shortname: ':rose:', category: 'n', emoji_order: '1431' },
  { name: 'wilted_rose', unicode: '🥀', shortname: ':wilted_rose:', category: 'n', emoji_order: '1432' },
  { name: 'hibiscus', unicode: '🌺', shortname: ':hibiscus:', category: 'n', emoji_order: '1433' },
  { name: 'sunflower', unicode: '🌻', shortname: ':sunflower:', category: 'n', emoji_order: '1434' },
  { name: 'blossom', unicode: '🌼', shortname: ':blossom:', category: 'n', emoji_order: '1435' },
  { name: 'tulip', unicode: '🌷', shortname: ':tulip:', category: 'n', emoji_order: '1436' },
  { name: 'seedling', unicode: '🌱', shortname: ':seedling:', category: 'n', emoji_order: '1437' },
  { name: 'evergreen_tree', unicode: '🌲', shortname: ':evergreen_tree:', category: 'n', emoji_order: '1438' },
  { name: 'deciduous_tree', unicode: '🌳', shortname: ':deciduous_tree:', category: 'n', emoji_order: '1439' },
  { name: 'palm_tree', unicode: '🌴', shortname: ':palm_tree:', category: 'n', emoji_order: '1440' },
  { name: 'cactus', unicode: '🌵', shortname: ':cactus:', category: 'n', emoji_order: '1441' },
  { name: 'ear_of_rice', unicode: '🌾', shortname: ':ear_of_rice:', category: 'n', emoji_order: '1442' },
  { name: 'herb', unicode: '🌿', shortname: ':herb:', category: 'n', emoji_order: '1443' },
  { name: 'shamrock', unicode: '☘', shortname: ':shamrock:', category: 'n', emoji_order: '1444' },
  { name: 'four_leaf_clover', unicode: '🍀', shortname: ':four_leaf_clover:', category: 'n', emoji_order: '1445' },
  { name: 'maple_leaf', unicode: '🍁', shortname: ':maple_leaf:', category: 'n', emoji_order: '1446' },
  { name: 'fallen_leaf', unicode: '🍂', shortname: ':fallen_leaf:', category: 'n', emoji_order: '1447' },
  { name: 'leaves', unicode: '🍃', shortname: ':leaves:', category: 'n', emoji_order: '1448' },
  { name: 'grapes', unicode: '🍇', shortname: ':grapes:', category: 'd', emoji_order: '1449' },
  { name: 'melon', unicode: '🍈', shortname: ':melon:', category: 'd', emoji_order: '1450' },
  { name: 'watermelon', unicode: '🍉', shortname: ':watermelon:', category: 'd', emoji_order: '1451' },
  { name: 'tangerine', unicode: '🍊', shortname: ':tangerine:', category: 'd', emoji_order: '1452' },
  { name: 'lemon', unicode: '🍋', shortname: ':lemon:', category: 'd', emoji_order: '1453' },
  { name: 'banana', unicode: '🍌', shortname: ':banana:', category: 'd', emoji_order: '1454' },
  { name: 'pineapple', unicode: '🍍', shortname: ':pineapple:', category: 'd', emoji_order: '1455' },
  { name: 'apple', unicode: '🍎', shortname: ':apple:', category: 'd', emoji_order: '1456' },
  { name: 'green_apple', unicode: '🍏', shortname: ':green_apple:', category: 'd', emoji_order: '1457' },
  { name: 'pear', unicode: '🍐', shortname: ':pear:', category: 'd', emoji_order: '1458' },
  { name: 'peach', unicode: '🍑', shortname: ':peach:', category: 'd', emoji_order: '1459' },
  { name: 'cherries', unicode: '🍒', shortname: ':cherries:', category: 'd', emoji_order: '1460' },
  { name: 'strawberry', unicode: '🍓', shortname: ':strawberry:', category: 'd', emoji_order: '1461' },
  { name: 'kiwi', unicode: '🥝', shortname: ':kiwi:', category: 'd', emoji_order: '1462' },
  { name: 'tomato', unicode: '🍅', shortname: ':tomato:', category: 'd', emoji_order: '1463' },
  { name: 'avocado', unicode: '🥑', shortname: ':avocado:', category: 'd', emoji_order: '1464' },
  { name: 'eggplant', unicode: '🍆', shortname: ':eggplant:', category: 'd', emoji_order: '1465' },
  { name: 'potato', unicode: '🥔', shortname: ':potato:', category: 'd', emoji_order: '1466' },
  { name: 'carrot', unicode: '🥕', shortname: ':carrot:', category: 'd', emoji_order: '1467' },
  { name: 'corn', unicode: '🌽', shortname: ':corn:', category: 'd', emoji_order: '1468' },
  { name: 'hot_pepper', unicode: '🌶', shortname: ':hot_pepper:', category: 'd', emoji_order: '1469' },
  { name: 'cucumber', unicode: '🥒', shortname: ':cucumber:', category: 'd', emoji_order: '1470' },
  { name: 'mushroom', unicode: '🍄', shortname: ':mushroom:', category: 'n', emoji_order: '1471' },
  { name: 'peanuts', unicode: '🥜', shortname: ':peanuts:', category: 'd', emoji_order: '1472' },
  { name: 'chestnut', unicode: '🌰', shortname: ':chestnut:', category: 'n', emoji_order: '1473' },
  { name: 'bread', unicode: '🍞', shortname: ':bread:', category: 'd', emoji_order: '1474' },
  { name: 'croissant', unicode: '🥐', shortname: ':croissant:', category: 'd', emoji_order: '1475' },
  { name: 'french_bread', unicode: '🥖', shortname: ':french_bread:', category: 'd', emoji_order: '1476' },
  { name: 'pancakes', unicode: '🥞', shortname: ':pancakes:', category: 'd', emoji_order: '1477' },
  { name: 'cheese_wedge', unicode: '🧀', shortname: ':cheese:', category: 'd', emoji_order: '1478' },
  { name: 'meat_on_bone', unicode: '🍖', shortname: ':meat_on_bone:', category: 'd', emoji_order: '1479' },
  { name: 'poultry_leg', unicode: '🍗', shortname: ':poultry_leg:', category: 'd', emoji_order: '1480' },
  { name: 'bacon', unicode: '🥓', shortname: ':bacon:', category: 'd', emoji_order: '1481' },
  { name: 'hamburger', unicode: '🍔', shortname: ':hamburger:', category: 'd', emoji_order: '1482' },
  { name: 'fries', unicode: '🍟', shortname: ':fries:', category: 'd', emoji_order: '1483' },
  { name: 'pizza', unicode: '🍕', shortname: ':pizza:', category: 'd', emoji_order: '1484' },
  { name: 'hotdog', unicode: '🌭', shortname: ':hotdog:', category: 'd', emoji_order: '1485' },
  { name: 'taco', unicode: '🌮', shortname: ':taco:', category: 'd', emoji_order: '1486' },
  { name: 'burrito', unicode: '🌯', shortname: ':burrito:', category: 'd', emoji_order: '1487' },
  { name: 'stuffed_flatbread', unicode: '🥙', shortname: ':stuffed_flatbread:', category: 'd', emoji_order: '1488' },
  { name: 'egg', unicode: '🥚', shortname: ':egg:', category: 'd', emoji_order: '1489' },
  { name: 'cooking', unicode: '🍳', shortname: ':cooking:', category: 'd', emoji_order: '1490' },
  { name: 'shallow_pan_of_f', unicode: '🥘', shortname: ':shallow_pan_of_f:', category: 'd', emoji_order: '1491' },
  { name: 'stew', unicode: '🍲', shortname: ':stew:', category: 'd', emoji_order: '1492' },
  { name: 'salad', unicode: '🥗', shortname: ':salad:', category: 'd', emoji_order: '1493' },
  { name: 'popcorn', unicode: '🍿', shortname: ':popcorn:', category: 'd', emoji_order: '1494' },
  { name: 'bento', unicode: '🍱', shortname: ':bento:', category: 'd', emoji_order: '1495' },
  { name: 'rice_cracker', unicode: '🍘', shortname: ':rice_cracker:', category: 'd', emoji_order: '1496' },
  { name: 'rice_ball', unicode: '🍙', shortname: ':rice_ball:', category: 'd', emoji_order: '1497' },
  { name: 'rice', unicode: '🍚', shortname: ':rice:', category: 'd', emoji_order: '1498' },
  { name: 'curry', unicode: '🍛', shortname: ':curry:', category: 'd', emoji_order: '1499' },
  { name: 'ramen', unicode: '🍜', shortname: ':ramen:', category: 'd', emoji_order: '1500' },
  { name: 'spaghetti', unicode: '🍝', shortname: ':spaghetti:', category: 'd', emoji_order: '1501' },
  { name: 'sweet_potato', unicode: '🍠', shortname: ':sweet_potato:', category: 'd', emoji_order: '1502' },
  { name: 'oden', unicode: '🍢', shortname: ':oden:', category: 'd', emoji_order: '1503' },
  { name: 'sushi', unicode: '🍣', shortname: ':sushi:', category: 'd', emoji_order: '1504' },
  { name: 'fried_shrimp', unicode: '🍤', shortname: ':fried_shrimp:', category: 'd', emoji_order: '1505' },
  { name: 'fish_cake', unicode: '🍥', shortname: ':fish_cake:', category: 'd', emoji_order: '1506' },
  { name: 'dango', unicode: '🍡', shortname: ':dango:', category: 'd', emoji_order: '1507' },
  { name: 'icecream', unicode: '🍦', shortname: ':icecream:', category: 'd', emoji_order: '1508' },
  { name: 'shaved_ice', unicode: '🍧', shortname: ':shaved_ice:', category: 'd', emoji_order: '1509' },
  { name: 'ice_cream', unicode: '🍨', shortname: ':ice_cream:', category: 'd', emoji_order: '1510' },
  { name: 'doughnut', unicode: '🍩', shortname: ':doughnut:', category: 'd', emoji_order: '1511' },
  { name: 'cookie', unicode: '🍪', shortname: ':cookie:', category: 'd', emoji_order: '1512' },
  { name: 'birthday', unicode: '🎂', shortname: ':birthday:', category: 'd', emoji_order: '1513' },
  { name: 'cake', unicode: '🍰', shortname: ':cake:', category: 'd', emoji_order: '1514' },
  { name: 'chocolate_bar', unicode: '🍫', shortname: ':chocolate_bar:', category: 'd', emoji_order: '1515' },
  { name: 'candy', unicode: '🍬', shortname: ':candy:', category: 'd', emoji_order: '1516' },
  { name: 'lollipop', unicode: '🍭', shortname: ':lollipop:', category: 'd', emoji_order: '1517' },
  { name: 'custard', unicode: '🍮', shortname: ':custard:', category: 'd', emoji_order: '1518' },
  { name: 'honey_pot', unicode: '🍯', shortname: ':honey_pot:', category: 'd', emoji_order: '1519' },
  { name: 'baby_bottle', unicode: '🍼', shortname: ':baby_bottle:', category: 'd', emoji_order: '1520' },
  { name: 'milk', unicode: '🥛', shortname: ':milk:', category: 'd', emoji_order: '1521' },
  { name: 'coffee', unicode: '☕', shortname: ':coffee:', category: 'd', emoji_order: '1522' },
  { name: 'tea', unicode: '🍵', shortname: ':tea:', category: 'd', emoji_order: '1523' },
  { name: 'sake', unicode: '🍶', shortname: ':sake:', category: 'd', emoji_order: '1524' },
  { name: 'champagne', unicode: '🍾', shortname: ':champagne:', category: 'd', emoji_order: '1525' },
  { name: 'wine_glass', unicode: '🍷', shortname: ':wine_glass:', category: 'd', emoji_order: '1526' },
  { name: 'cocktail', unicode: '🍸', shortname: ':cocktail:', category: 'd', emoji_order: '1527' },
  { name: 'tropical_drink', unicode: '🍹', shortname: ':tropical_drink:', category: 'd', emoji_order: '1528' },
  { name: 'beer', unicode: '🍺', shortname: ':beer:', category: 'd', emoji_order: '1529' },
  { name: 'beers', unicode: '🍻', shortname: ':beers:', category: 'd', emoji_order: '1530' },
  { name: 'champagne_glass', unicode: '🥂', shortname: ':champagne_glass:', category: 'd', emoji_order: '1531' },
  { name: 'tumbler_glass', unicode: '🥃', shortname: ':tumbler_glass:', category: 'd', emoji_order: '1532' },
  { name: 'knife_fork_plate', unicode: '🍽', shortname: ':fork_knife_plate:', category: 'd', emoji_order: '1533' },
  { name: 'fork_and_knife', unicode: '🍴', shortname: ':fork_and_knife:', category: 'd', emoji_order: '1534' },
  { name: 'spoon', unicode: '🥄', shortname: ':spoon:', category: 'd', emoji_order: '1535' },
  { name: 'knife', unicode: '🔪', shortname: ':knife:', category: 'o', emoji_order: '1536' },
  { name: 'amphora', unicode: '🏺', shortname: ':amphora:', category: 'o', emoji_order: '1537' },
  { name: 'earth_africa', unicode: '🌍', shortname: ':earth_africa:', category: 'n', emoji_order: '1538' },
  { name: 'earth_americas', unicode: '🌎', shortname: ':earth_americas:', category: 'n', emoji_order: '1539' },
  { name: 'earth_asia', unicode: '🌏', shortname: ':earth_asia:', category: 'n', emoji_order: '1540' },
  {
    name: 'globe_with_meridians',
    unicode: '🌐',
    shortname: ':globe_with_meridians:',
    category: 's',
    emoji_order: '1541',
  },
  { name: 'world_map', unicode: '🗺', shortname: ':map:', category: 'o', emoji_order: '1542' },
  { name: 'japan', unicode: '🗾', shortname: ':japan:', category: 't', emoji_order: '1543' },
  { name: 'snow_capped_mountain', unicode: '🏔', shortname: ':mountain_snow:', category: 't', emoji_order: '1544' },
  { name: 'mountain', unicode: '⛰', shortname: ':mountain:', category: 't', emoji_order: '1545' },
  { name: 'volcano', unicode: '🌋', shortname: ':volcano:', category: 't', emoji_order: '1546' },
  { name: 'mount_fuji', unicode: '🗻', shortname: ':mount_fuji:', category: 't', emoji_order: '1547' },
  { name: 'camping', unicode: '🏕', shortname: ':camping:', category: 't', emoji_order: '1548' },
  { name: 'beach_with_umbrella', unicode: '🏖', shortname: ':beach:', category: 't', emoji_order: '1549' },
  { name: 'desert', unicode: '🏜', shortname: ':desert:', category: 't', emoji_order: '1550' },
  { name: 'desert_island', unicode: '🏝', shortname: ':island:', category: 't', emoji_order: '1551' },
  { name: 'national_park', unicode: '🏞', shortname: ':park:', category: 't', emoji_order: '1552' },
  { name: 'stadium', unicode: '🏟', shortname: ':stadium:', category: 't', emoji_order: '1553' },
  { name: 'classical_building', unicode: '🏛', shortname: ':classical_building:', category: 't', emoji_order: '1554' },
  {
    name: 'building_construction',
    unicode: '🏗',
    shortname: ':construction_site:',
    category: 't',
    emoji_order: '1555',
  },
  { name: 'house_buildings', unicode: '🏘', shortname: ':homes:', category: 't', emoji_order: '1556' },
  { name: 'cityscape', unicode: '🏙', shortname: ':cityscape:', category: 't', emoji_order: '1557' },
  {
    name: 'derelict_house_building',
    unicode: '🏚',
    shortname: ':house_abandoned:',
    category: 't',
    emoji_order: '1558',
  },
  { name: 'house', unicode: '🏠', shortname: ':house:', category: 't', emoji_order: '1559' },
  { name: 'house_with_garden', unicode: '🏡', shortname: ':house_with_garden:', category: 't', emoji_order: '1560' },
  { name: 'office', unicode: '🏢', shortname: ':office:', category: 't', emoji_order: '1561' },
  { name: 'post_office', unicode: '🏣', shortname: ':post_office:', category: 't', emoji_order: '1562' },
  {
    name: 'european_post_office',
    unicode: '🏤',
    shortname: ':european_post_office:',
    category: 't',
    emoji_order: '1563',
  },
  { name: 'hospital', unicode: '🏥', shortname: ':hospital:', category: 't', emoji_order: '1564' },
  { name: 'bank', unicode: '🏦', shortname: ':bank:', category: 't', emoji_order: '1565' },
  { name: 'hotel', unicode: '🏨', shortname: ':hotel:', category: 't', emoji_order: '1566' },
  { name: 'love_hotel', unicode: '🏩', shortname: ':love_hotel:', category: 't', emoji_order: '1567' },
  { name: 'convenience_store', unicode: '🏪', shortname: ':convenience_store:', category: 't', emoji_order: '1568' },
  { name: 'school', unicode: '🏫', shortname: ':school:', category: 't', emoji_order: '1569' },
  { name: 'department_store', unicode: '🏬', shortname: ':department_store:', category: 't', emoji_order: '1570' },
  { name: 'factory', unicode: '🏭', shortname: ':factory:', category: 't', emoji_order: '1571' },
  { name: 'japanese_castle', unicode: '🏯', shortname: ':japanese_castle:', category: 't', emoji_order: '1572' },
  { name: 'european_castle', unicode: '🏰', shortname: ':european_castle:', category: 't', emoji_order: '1573' },
  { name: 'wedding', unicode: '💒', shortname: ':wedding:', category: 't', emoji_order: '1574' },
  { name: 'tokyo_tower', unicode: '🗼', shortname: ':tokyo_tower:', category: 't', emoji_order: '1575' },
  { name: 'statue_of_liberty', unicode: '🗽', shortname: ':statue_of_liberty:', category: 't', emoji_order: '1576' },
  { name: 'church', unicode: '⛪', shortname: ':church:', category: 't', emoji_order: '1577' },
  { name: 'mosque', unicode: '🕌', shortname: ':mosque:', category: 't', emoji_order: '1578' },
  { name: 'synagogue', unicode: '🕍', shortname: ':synagogue:', category: 't', emoji_order: '1579' },
  { name: 'shinto_shrine', unicode: '⛩', shortname: ':shinto_shrine:', category: 't', emoji_order: '1580' },
  { name: 'kaaba', unicode: '🕋', shortname: ':kaaba:', category: 't', emoji_order: '1581' },
  { name: 'fountain', unicode: '⛲', shortname: ':fountain:', category: 't', emoji_order: '1582' },
  { name: 'tent', unicode: '⛺', shortname: ':tent:', category: 't', emoji_order: '1583' },
  { name: 'foggy', unicode: '🌁', shortname: ':foggy:', category: 't', emoji_order: '1584' },
  { name: 'night_with_stars', unicode: '🌃', shortname: ':night_with_stars:', category: 't', emoji_order: '1585' },
  {
    name: 'sunrise_over_mountains',
    unicode: '🌄',
    shortname: ':sunrise_over_mountains:',
    category: 't',
    emoji_order: '1586',
  },
  { name: 'sunrise', unicode: '🌅', shortname: ':sunrise:', category: 't', emoji_order: '1587' },
  { name: 'city_dusk', unicode: '🌆', shortname: ':city_dusk:', category: 't', emoji_order: '1588' },
  { name: 'city_sunset', unicode: '🌇', shortname: ':city_sunset:', category: 't', emoji_order: '1589' },
  { name: 'bridge_at_night', unicode: '🌉', shortname: ':bridge_at_night:', category: 't', emoji_order: '1590' },
  { name: 'hotsprings', unicode: '♨', shortname: ':hotsprings:', category: 's', emoji_order: '1591' },
  { name: 'milky_way', unicode: '🌌', shortname: ':milky_way:', category: 't', emoji_order: '1592' },
  { name: 'carousel_horse', unicode: '🎠', shortname: ':carousel_horse:', category: 't', emoji_order: '1593' },
  { name: 'ferris_wheel', unicode: '🎡', shortname: ':ferris_wheel:', category: 't', emoji_order: '1594' },
  { name: 'roller_coaster', unicode: '🎢', shortname: ':roller_coaster:', category: 't', emoji_order: '1595' },
  { name: 'barber', unicode: '💈', shortname: ':barber:', category: 'o', emoji_order: '1596' },
  { name: 'circus_tent', unicode: '🎪', shortname: ':circus_tent:', category: 'a', emoji_order: '1597' },
  { name: 'performing_arts', unicode: '🎭', shortname: ':performing_arts:', category: 'a', emoji_order: '1598' },
  { name: 'frame_with_picture', unicode: '🖼', shortname: ':frame_photo:', category: 'o', emoji_order: '1599' },
  { name: 'art', unicode: '🎨', shortname: ':art:', category: 'a', emoji_order: '1600' },
  { name: 'slot_machine', unicode: '🎰', shortname: ':slot_machine:', category: 'a', emoji_order: '1601' },
  { name: 'steam_locomotive', unicode: '🚂', shortname: ':steam_locomotive:', category: 't', emoji_order: '1602' },
  { name: 'railway_car', unicode: '🚃', shortname: ':railway_car:', category: 't', emoji_order: '1603' },
  { name: 'bullettrain_side', unicode: '🚄', shortname: ':bullettrain_side:', category: 't', emoji_order: '1604' },
  { name: 'bullettrain_front', unicode: '🚅', shortname: ':bullettrain_front:', category: 't', emoji_order: '1605' },
  { name: 'train2', unicode: '🚆', shortname: ':train2:', category: 't', emoji_order: '1606' },
  { name: 'metro', unicode: '🚇', shortname: ':metro:', category: 't', emoji_order: '1607' },
  { name: 'light_rail', unicode: '🚈', shortname: ':light_rail:', category: 't', emoji_order: '1608' },
  { name: 'station', unicode: '🚉', shortname: ':station:', category: 't', emoji_order: '1609' },
  { name: 'tram', unicode: '🚊', shortname: ':tram:', category: 't', emoji_order: '1610' },
  { name: 'monorail', unicode: '🚝', shortname: ':monorail:', category: 't', emoji_order: '1611' },
  { name: 'mountain_railway', unicode: '🚞', shortname: ':mountain_railway:', category: 't', emoji_order: '1612' },
  { name: 'train', unicode: '🚋', shortname: ':train:', category: 't', emoji_order: '1613' },
  { name: 'bus', unicode: '🚌', shortname: ':bus:', category: 't', emoji_order: '1614' },
  { name: 'oncoming_bus', unicode: '🚍', shortname: ':oncoming_bus:', category: 't', emoji_order: '1615' },
  { name: 'trolleybus', unicode: '🚎', shortname: ':trolleybus:', category: 't', emoji_order: '1616' },
  { name: 'minibus', unicode: '🚐', shortname: ':minibus:', category: 't', emoji_order: '1617' },
  { name: 'ambulance', unicode: '🚑', shortname: ':ambulance:', category: 't', emoji_order: '1618' },
  { name: 'fire_engine', unicode: '🚒', shortname: ':fire_engine:', category: 't', emoji_order: '1619' },
  { name: 'police_car', unicode: '🚓', shortname: ':police_car:', category: 't', emoji_order: '1620' },
  {
    name: 'oncoming_police_car',
    unicode: '🚔',
    shortname: ':oncoming_police_car:',
    category: 't',
    emoji_order: '1621',
  },
  { name: 'taxi', unicode: '🚕', shortname: ':taxi:', category: 't', emoji_order: '1622' },
  { name: 'oncoming_taxi', unicode: '🚖', shortname: ':oncoming_taxi:', category: 't', emoji_order: '1623' },
  { name: 'car', unicode: '🚗', shortname: ':red_car:', category: 't', emoji_order: '1624' },
  {
    name: 'oncoming_automobile',
    unicode: '🚘',
    shortname: ':oncoming_automobile:',
    category: 't',
    emoji_order: '1625',
  },
  { name: 'blue_car', unicode: '🚙', shortname: ':blue_car:', category: 't', emoji_order: '1626' },
  { name: 'truck', unicode: '🚚', shortname: ':truck:', category: 't', emoji_order: '1627' },
  { name: 'articulated_lorry', unicode: '🚛', shortname: ':articulated_lorry:', category: 't', emoji_order: '1628' },
  { name: 'tractor', unicode: '🚜', shortname: ':tractor:', category: 't', emoji_order: '1629' },
  { name: 'bike', unicode: '🚲', shortname: ':bike:', category: 't', emoji_order: '1630' },
  { name: 'scooter', unicode: '🛴', shortname: ':scooter:', category: 't', emoji_order: '1631' },
  { name: 'motor_scooter', unicode: '🛵', shortname: ':motor_scooter:', category: 't', emoji_order: '1632' },
  { name: 'busstop', unicode: '🚏', shortname: ':busstop:', category: 't', emoji_order: '1633' },
  { name: 'motorway', unicode: '🛣', shortname: ':motorway:', category: 't', emoji_order: '1634' },
  { name: 'railway_track', unicode: '🛤', shortname: ':railway_track:', category: 't', emoji_order: '1635' },
  { name: 'fuelpump', unicode: '⛽', shortname: ':fuelpump:', category: 't', emoji_order: '1636' },
  { name: 'rotating_light', unicode: '🚨', shortname: ':rotating_light:', category: 't', emoji_order: '1637' },
  { name: 'traffic_light', unicode: '🚥', shortname: ':traffic_light:', category: 't', emoji_order: '1638' },
  {
    name: 'vertical_traffic_light',
    unicode: '🚦',
    shortname: ':vertical_traffic_light:',
    category: 't',
    emoji_order: '1639',
  },
  { name: 'construction', unicode: '🚧', shortname: ':construction:', category: 't', emoji_order: '1640' },
  { name: 'octagonal_sign', unicode: '🛑', shortname: ':octagonal_sign:', category: 's', emoji_order: '1641' },
  { name: 'anchor', unicode: '⚓', shortname: ':anchor:', category: 't', emoji_order: '1642' },
  { name: 'boat', unicode: '⛵', shortname: ':sailboat:', category: 't', emoji_order: '1643' },
  { name: 'canoe', unicode: '🛶', shortname: ':canoe:', category: 't', emoji_order: '1644' },
  { name: 'speedboat', unicode: '🚤', shortname: ':speedboat:', category: 't', emoji_order: '1645' },
  { name: 'passenger_ship', unicode: '🛳', shortname: ':cruise_ship:', category: 't', emoji_order: '1646' },
  { name: 'ferry', unicode: '⛴', shortname: ':ferry:', category: 't', emoji_order: '1647' },
  { name: 'motor_boat', unicode: '🛥', shortname: ':motorboat:', category: 't', emoji_order: '1648' },
  { name: 'ship', unicode: '🚢', shortname: ':ship:', category: 't', emoji_order: '1649' },
  { name: 'airplane', unicode: '✈', shortname: ':airplane:', category: 't', emoji_order: '1650' },
  { name: 'small_airplane', unicode: '🛩', shortname: ':airplane_small:', category: 't', emoji_order: '1651' },
  { name: 'airplane_departure', unicode: '🛫', shortname: ':airplane_departure:', category: 't', emoji_order: '1652' },
  { name: 'airplane_arriving', unicode: '🛬', shortname: ':airplane_arriving:', category: 't', emoji_order: '1653' },
  { name: 'seat', unicode: '💺', shortname: ':seat:', category: 't', emoji_order: '1654' },
  { name: 'helicopter', unicode: '🚁', shortname: ':helicopter:', category: 't', emoji_order: '1655' },
  { name: 'suspension_railway', unicode: '🚟', shortname: ':suspension_railway:', category: 't', emoji_order: '1656' },
  { name: 'mountain_cableway', unicode: '🚠', shortname: ':mountain_cableway:', category: 't', emoji_order: '1657' },
  { name: 'aerial_tramway', unicode: '🚡', shortname: ':aerial_tramway:', category: 't', emoji_order: '1658' },
  { name: 'rocket', unicode: '🚀', shortname: ':rocket:', category: 't', emoji_order: '1659' },
  { name: 'satellite', unicode: '🛰', shortname: ':satellite_orbital:', category: 't', emoji_order: '1660' },
  { name: 'bellhop_bell', unicode: '🛎', shortname: ':bellhop:', category: 'o', emoji_order: '1661' },
  { name: 'door', unicode: '🚪', shortname: ':door:', category: 'o', emoji_order: '1662' },
  {
    name: 'sleeping_accommodation',
    unicode: '🛌',
    shortname: ':sleeping_accommodation:',
    category: 'o',
    emoji_order: '1663',
  },
  { name: 'bed', unicode: '🛏', shortname: ':bed:', category: 'o', emoji_order: '1669' },
  { name: 'couch_and_lamp', unicode: '🛋', shortname: ':couch:', category: 'o', emoji_order: '1670' },
  { name: 'toilet', unicode: '🚽', shortname: ':toilet:', category: 'o', emoji_order: '1671' },
  { name: 'shower', unicode: '🚿', shortname: ':shower:', category: 'o', emoji_order: '1672' },
  { name: 'bath', unicode: '🛀', shortname: ':bath:', category: 'a', emoji_order: '1673' },
  { name: 'bathtub', unicode: '🛁', shortname: ':bathtub:', category: 'o', emoji_order: '1679' },
  { name: 'hourglass', unicode: '⌛', shortname: ':hourglass:', category: 'o', emoji_order: '1680' },
  {
    name: 'hourglass_flowing_sand',
    unicode: '⏳',
    shortname: ':hourglass_flowing_sand:',
    category: 'o',
    emoji_order: '1681',
  },
  { name: 'watch', unicode: '⌚', shortname: ':watch:', category: 'o', emoji_order: '1682' },
  { name: 'alarm_clock', unicode: '⏰', shortname: ':alarm_clock:', category: 'o', emoji_order: '1683' },
  { name: 'stopwatch', unicode: '⏱', shortname: ':stopwatch:', category: 'o', emoji_order: '1684' },
  { name: 'timer_clock', unicode: '⏲', shortname: ':timer:', category: 'o', emoji_order: '1685' },
  { name: 'mantelpiece_clock', unicode: '🕰', shortname: ':clock:', category: 'o', emoji_order: '1686' },
  { name: 'clock12', unicode: '🕛', shortname: ':clock12:', category: 's', emoji_order: '1687' },
  { name: 'clock1230', unicode: '🕧', shortname: ':clock1230:', category: 's', emoji_order: '1688' },
  { name: 'clock1', unicode: '🕐', shortname: ':clock1:', category: 's', emoji_order: '1689' },
  { name: 'clock130', unicode: '🕜', shortname: ':clock130:', category: 's', emoji_order: '1690' },
  { name: 'clock2', unicode: '🕑', shortname: ':clock2:', category: 's', emoji_order: '1691' },
  { name: 'clock230', unicode: '🕝', shortname: ':clock230:', category: 's', emoji_order: '1692' },
  { name: 'clock3', unicode: '🕒', shortname: ':clock3:', category: 's', emoji_order: '1693' },
  { name: 'clock330', unicode: '🕞', shortname: ':clock330:', category: 's', emoji_order: '1694' },
  { name: 'clock4', unicode: '🕓', shortname: ':clock4:', category: 's', emoji_order: '1695' },
  { name: 'clock430', unicode: '🕟', shortname: ':clock430:', category: 's', emoji_order: '1696' },
  { name: 'clock5', unicode: '🕔', shortname: ':clock5:', category: 's', emoji_order: '1697' },
  { name: 'clock530', unicode: '🕠', shortname: ':clock530:', category: 's', emoji_order: '1698' },
  { name: 'clock6', unicode: '🕕', shortname: ':clock6:', category: 's', emoji_order: '1699' },
  { name: 'clock630', unicode: '🕡', shortname: ':clock630:', category: 's', emoji_order: '1700' },
  { name: 'clock7', unicode: '🕖', shortname: ':clock7:', category: 's', emoji_order: '1701' },
  { name: 'clock730', unicode: '🕢', shortname: ':clock730:', category: 's', emoji_order: '1702' },
  { name: 'clock8', unicode: '🕗', shortname: ':clock8:', category: 's', emoji_order: '1703' },
  { name: 'clock830', unicode: '🕣', shortname: ':clock830:', category: 's', emoji_order: '1704' },
  { name: 'clock9', unicode: '🕘', shortname: ':clock9:', category: 's', emoji_order: '1705' },
  { name: 'clock930', unicode: '🕤', shortname: ':clock930:', category: 's', emoji_order: '1706' },
  { name: 'clock10', unicode: '🕙', shortname: ':clock10:', category: 's', emoji_order: '1707' },
  { name: 'clock1030', unicode: '🕥', shortname: ':clock1030:', category: 's', emoji_order: '1708' },
  { name: 'clock11', unicode: '🕚', shortname: ':clock11:', category: 's', emoji_order: '1709' },
  { name: 'clock1130', unicode: '🕦', shortname: ':clock1130:', category: 's', emoji_order: '1710' },
  { name: 'new_moon', unicode: '🌑', shortname: ':new_moon:', category: 'n', emoji_order: '1711' },
  {
    name: 'waxing_crescent_moon',
    unicode: '🌒',
    shortname: ':waxing_crescent_moon:',
    category: 'n',
    emoji_order: '1712',
  },
  { name: 'first_quarter_moon', unicode: '🌓', shortname: ':first_quarter_moon:', category: 'n', emoji_order: '1713' },
  {
    name: 'waxing_gibbous_moon',
    unicode: '🌔',
    shortname: ':waxing_gibbous_moon:',
    category: 'n',
    emoji_order: '1714',
  },
  { name: 'full_moon', unicode: '🌕', shortname: ':full_moon:', category: 'n', emoji_order: '1715' },
  {
    name: 'waning_gibbous_moon',
    unicode: '🌖',
    shortname: ':waning_gibbous_moon:',
    category: 'n',
    emoji_order: '1716',
  },
  { name: 'last_quarter_moon', unicode: '🌗', shortname: ':last_quarter_moon:', category: 'n', emoji_order: '1717' },
  {
    name: 'waning_crescent_moon',
    unicode: '🌘',
    shortname: ':waning_crescent_moon:',
    category: 'n',
    emoji_order: '1718',
  },
  { name: 'crescent_moon', unicode: '🌙', shortname: ':crescent_moon:', category: 'n', emoji_order: '1719' },
  { name: 'new_moon_with_face', unicode: '🌚', shortname: ':new_moon_with_face:', category: 'n', emoji_order: '1720' },
  {
    name: 'first_quarter_moon_with_face',
    unicode: '🌛',
    shortname: ':first_quarter_moon_with_face:',
    category: 'n',
    emoji_order: '1721',
  },
  {
    name: 'last_quarter_moon_with_face',
    unicode: '🌜',
    shortname: ':last_quarter_moon_with_face:',
    category: 'n',
    emoji_order: '1722',
  },
  { name: 'thermometer', unicode: '🌡', shortname: ':thermometer:', category: 'o', emoji_order: '1723' },
  { name: 'sunny', unicode: '☀', shortname: ':sunny:', category: 'n', emoji_order: '1724' },
  {
    name: 'full_moon_with_face',
    unicode: '🌝',
    shortname: ':full_moon_with_face:',
    category: 'n',
    emoji_order: '1725',
  },
  { name: 'sun_with_face', unicode: '🌞', shortname: ':sun_with_face:', category: 'n', emoji_order: '1726' },
  { name: 'star', unicode: '⭐', shortname: ':star:', category: 'n', emoji_order: '1727' },
  { name: 'star2', unicode: '🌟', shortname: ':star2:', category: 'n', emoji_order: '1728' },
  { name: 'stars', unicode: '🌠', shortname: ':stars:', category: 't', emoji_order: '1729' },
  { name: 'cloud', unicode: '☁', shortname: ':cloud:', category: 'n', emoji_order: '1730' },
  { name: 'partly_sunny', unicode: '⛅', shortname: ':partly_sunny:', category: 'n', emoji_order: '1731' },
  {
    name: 'thunder_cloud_and_rain',
    unicode: '⛈',
    shortname: ':thunder_cloud_rain:',
    category: 'n',
    emoji_order: '1732',
  },
  {
    name: 'white_sun_small_cloud',
    unicode: '🌤',
    shortname: ':white_sun_small_cloud:',
    category: 'n',
    emoji_order: '1733',
  },
  { name: 'white_sun_cloud', unicode: '🌥', shortname: ':white_sun_cloud:', category: 'n', emoji_order: '1734' },
  {
    name: 'white_sun_rain_cloud',
    unicode: '🌦',
    shortname: ':white_sun_rain_cloud:',
    category: 'n',
    emoji_order: '1735',
  },
  { name: 'rain_cloud', unicode: '🌧', shortname: ':cloud_rain:', category: 'n', emoji_order: '1736' },
  { name: 'snow_cloud', unicode: '🌨', shortname: ':cloud_snow:', category: 'n', emoji_order: '1737' },
  { name: 'cloud_lightning', unicode: '🌩', shortname: ':cloud_lightning:', category: 'n', emoji_order: '1738' },
  { name: 'cloud_tornado', unicode: '🌪', shortname: ':cloud_tornado:', category: 'n', emoji_order: '1739' },
  { name: 'fog', unicode: '🌫', shortname: ':fog:', category: 'n', emoji_order: '1740' },
  { name: 'wind_blowing_face', unicode: '🌬', shortname: ':wind_blowing_face:', category: 'n', emoji_order: '1741' },
  { name: 'cyclone', unicode: '🌀', shortname: ':cyclone:', category: 's', emoji_order: '1742' },
  { name: 'rainbow', unicode: '🌈', shortname: ':rainbow:', category: 't', emoji_order: '1743' },
  { name: 'closed_umbrella', unicode: '🌂', shortname: ':closed_umbrella:', category: 'p', emoji_order: '1744' },
  { name: 'umbrella', unicode: '☂', shortname: ':umbrella2:', category: 'n', emoji_order: '1745' },
  { name: 'umbrella_with_rain_drops', unicode: '☔', shortname: ':umbrella:', category: 'n', emoji_order: '1746' },
  { name: 'beach_umbrella', unicode: '⛱', shortname: ':beach_umbrella:', category: 'o', emoji_order: '1747' },
  { name: 'zap', unicode: '⚡', shortname: ':zap:', category: 'n', emoji_order: '1748' },
  { name: 'snowflake', unicode: '❄', shortname: ':snowflake:', category: 'n', emoji_order: '1749' },
  { name: 'snowman', unicode: '☃', shortname: ':snowman2:', category: 'n', emoji_order: '1750' },
  { name: 'snowman_without_snow', unicode: '⛄', shortname: ':snowman:', category: 'n', emoji_order: '1751' },
  { name: 'comet', unicode: '☄', shortname: ':comet:', category: 'n', emoji_order: '1752' },
  { name: 'fire', unicode: '🔥', shortname: ':fire:', category: 'n', emoji_order: '1753' },
  { name: 'droplet', unicode: '💧', shortname: ':droplet:', category: 'n', emoji_order: '1754' },
  { name: 'ocean', unicode: '🌊', shortname: ':ocean:', category: 'n', emoji_order: '1755' },
  { name: 'jack_o_lantern', unicode: '🎃', shortname: ':jack_o_lantern:', category: 'n', emoji_order: '1756' },
  { name: 'christmas_tree', unicode: '🎄', shortname: ':christmas_tree:', category: 'n', emoji_order: '1757' },
  { name: 'fireworks', unicode: '🎆', shortname: ':fireworks:', category: 't', emoji_order: '1758' },
  { name: 'sparkler', unicode: '🎇', shortname: ':sparkler:', category: 't', emoji_order: '1759' },
  { name: 'sparkles', unicode: '✨', shortname: ':sparkles:', category: 'n', emoji_order: '1760' },
  { name: 'balloon', unicode: '🎈', shortname: ':balloon:', category: 'o', emoji_order: '1761' },
  { name: 'tada', unicode: '🎉', shortname: ':tada:', category: 'o', emoji_order: '1762' },
  { name: 'confetti_ball', unicode: '🎊', shortname: ':confetti_ball:', category: 'o', emoji_order: '1763' },
  { name: 'tanabata_tree', unicode: '🎋', shortname: ':tanabata_tree:', category: 'n', emoji_order: '1764' },
  { name: 'bamboo', unicode: '🎍', shortname: ':bamboo:', category: 'n', emoji_order: '1765' },
  { name: 'dolls', unicode: '🎎', shortname: ':dolls:', category: 'o', emoji_order: '1766' },
  { name: 'f', unicode: '🎏', shortname: ':flags:', category: 'o', emoji_order: '1767' },
  { name: 'wind_chime', unicode: '🎐', shortname: ':wind_chime:', category: 'o', emoji_order: '1768' },
  { name: 'rice_scene', unicode: '🎑', shortname: ':rice_scene:', category: 't', emoji_order: '1769' },
  { name: 'ribbon', unicode: '🎀', shortname: ':ribbon:', category: 'o', emoji_order: '1770' },
  { name: 'gift', unicode: '🎁', shortname: ':gift:', category: 'o', emoji_order: '1771' },
  { name: 'reminder_ribbon', unicode: '🎗', shortname: ':reminder_ribbon:', category: 'a', emoji_order: '1772' },
  { name: 'admission_tickets', unicode: '🎟', shortname: ':tickets:', category: 'a', emoji_order: '1773' },
  { name: 'ticket', unicode: '🎫', shortname: ':ticket:', category: 'a', emoji_order: '1774' },
  { name: 'medal', unicode: '🎖', shortname: ':military_medal:', category: 'a', emoji_order: '1775' },
  { name: 'trophy', unicode: '🏆', shortname: ':trophy:', category: 'a', emoji_order: '1776' },
  { name: 'sports_medal', unicode: '🏅', shortname: ':medal:', category: 'a', emoji_order: '1777' },
  { name: 'first_place', unicode: '🥇', shortname: ':first_place:', category: 'a', emoji_order: '1778' },
  { name: 'second_place', unicode: '🥈', shortname: ':second_place:', category: 'a', emoji_order: '1779' },
  { name: 'third_place', unicode: '🥉', shortname: ':third_place:', category: 'a', emoji_order: '1780' },
  { name: 'soccer', unicode: '⚽', shortname: ':soccer:', category: 'a', emoji_order: '1781' },
  { name: 'baseball', unicode: '⚾', shortname: ':baseball:', category: 'a', emoji_order: '1782' },
  { name: 'basketball', unicode: '🏀', shortname: ':basketball:', category: 'a', emoji_order: '1783' },
  { name: 'volleyball', unicode: '🏐', shortname: ':volleyball:', category: 'a', emoji_order: '1784' },
  { name: 'football', unicode: '🏈', shortname: ':football:', category: 'a', emoji_order: '1785' },
  { name: 'rugby_football', unicode: '🏉', shortname: ':rugby_football:', category: 'a', emoji_order: '1786' },
  { name: 'tennis', unicode: '🎾', shortname: ':tennis:', category: 'a', emoji_order: '1787' },
  { name: '8ball', unicode: '🎱', shortname: ':8ball:', category: 'a', emoji_order: '1788' },
  { name: 'bowling', unicode: '🎳', shortname: ':bowling:', category: 'a', emoji_order: '1789' },
  { name: 'cricket_bat_and_ball', unicode: '🏏', shortname: ':cricket_game:', category: 'a', emoji_order: '1790' },
  {
    name: 'field_hockey_stick_and_ball',
    unicode: '🏑',
    shortname: ':field_hockey:',
    category: 'a',
    emoji_order: '1791',
  },
  { name: 'ice_hockey_stick_and_puck', unicode: '🏒', shortname: ':hockey:', category: 'a', emoji_order: '1792' },
  { name: 'table_tennis_paddle_and_ball', unicode: '🏓', shortname: ':ping_pong:', category: 'a', emoji_order: '1793' },
  {
    name: 'badminton_racquet_and_shuttlecock',
    unicode: '🏸',
    shortname: ':badminton:',
    category: 'a',
    emoji_order: '1794',
  },
  { name: 'boxing_glove', unicode: '🥊', shortname: ':boxing_glove:', category: 'a', emoji_order: '1795' },
  {
    name: 'martial_arts_uniform',
    unicode: '🥋',
    shortname: ':martial_arts_uniform:',
    category: 'a',
    emoji_order: '1796',
  },
  { name: 'goal', unicode: '🥅', shortname: ':goal:', category: 'a', emoji_order: '1797' },
  { name: 'dart', unicode: '🎯', shortname: ':dart:', category: 'a', emoji_order: '1798' },
  { name: 'golf', unicode: '⛳', shortname: ':golf:', category: 'a', emoji_order: '1799' },
  { name: 'ice_skate', unicode: '⛸', shortname: ':ice_skate:', category: 'a', emoji_order: '1800' },
  {
    name: 'fishing_pole_and_fish',
    unicode: '🎣',
    shortname: ':fishing_pole_and_fish:',
    category: 'a',
    emoji_order: '1801',
  },
  {
    name: 'running_shirt_with_sash',
    unicode: '🎽',
    shortname: ':running_shirt_with_sash:',
    category: 'a',
    emoji_order: '1802',
  },
  { name: 'ski', unicode: '🎿', shortname: ':ski:', category: 'a', emoji_order: '1803' },
  { name: 'video_game', unicode: '🎮', shortname: ':video_game:', category: 'a', emoji_order: '1804' },
  { name: 'joystick', unicode: '🕹', shortname: ':joystick:', category: 'o', emoji_order: '1805' },
  { name: 'game_die', unicode: '🎲', shortname: ':game_die:', category: 'a', emoji_order: '1806' },
  { name: 'spades', unicode: '♠', shortname: ':spades:', category: 's', emoji_order: '1807' },
  { name: 'hearts', unicode: '♥', shortname: ':hearts:', category: 's', emoji_order: '1808' },
  { name: 'diamonds', unicode: '♦', shortname: ':diamonds:', category: 's', emoji_order: '1809' },
  { name: 'clubs', unicode: '♣', shortname: ':clubs:', category: 's', emoji_order: '1810' },
  { name: 'black_joker', unicode: '🃏', shortname: ':black_joker:', category: 's', emoji_order: '1811' },
  { name: 'mahjong', unicode: '🀄', shortname: ':mahjong:', category: 's', emoji_order: '1812' },
  {
    name: 'flower_playing_cards',
    unicode: '🎴',
    shortname: ':flower_playing_cards:',
    category: 's',
    emoji_order: '1813',
  },
  { name: 'mute', unicode: '🔇', shortname: ':mute:', category: 's', emoji_order: '1814' },
  { name: 'speaker', unicode: '🔈', shortname: ':speaker:', category: 's', emoji_order: '1815' },
  { name: 'sound', unicode: '🔉', shortname: ':sound:', category: 's', emoji_order: '1816' },
  { name: 'loud_sound', unicode: '🔊', shortname: ':loud_sound:', category: 's', emoji_order: '1817' },
  { name: 'loudspeaker', unicode: '📢', shortname: ':loudspeaker:', category: 's', emoji_order: '1818' },
  { name: 'mega', unicode: '📣', shortname: ':mega:', category: 's', emoji_order: '1819' },
  { name: 'postal_horn', unicode: '📯', shortname: ':postal_horn:', category: 'o', emoji_order: '1820' },
  { name: 'bell', unicode: '🔔', shortname: ':bell:', category: 's', emoji_order: '1821' },
  { name: 'no_bell', unicode: '🔕', shortname: ':no_bell:', category: 's', emoji_order: '1822' },
  { name: 'musical_score', unicode: '🎼', shortname: ':musical_score:', category: 'a', emoji_order: '1823' },
  { name: 'musical_note', unicode: '🎵', shortname: ':musical_note:', category: 's', emoji_order: '1824' },
  { name: 'notes', unicode: '🎶', shortname: ':notes:', category: 's', emoji_order: '1825' },
  { name: 'studio_microphone', unicode: '🎙', shortname: ':microphone2:', category: 'o', emoji_order: '1826' },
  { name: 'level_slider', unicode: '🎚', shortname: ':level_slider:', category: 'o', emoji_order: '1827' },
  { name: 'control_knobs', unicode: '🎛', shortname: ':control_knobs:', category: 'o', emoji_order: '1828' },
  { name: 'microphone', unicode: '🎤', shortname: ':microphone:', category: 'a', emoji_order: '1829' },
  { name: 'headphones', unicode: '🎧', shortname: ':headphones:', category: 'a', emoji_order: '1830' },
  { name: 'radio', unicode: '📻', shortname: ':radio:', category: 'o', emoji_order: '1831' },
  { name: 'saxophone', unicode: '🎷', shortname: ':saxophone:', category: 'a', emoji_order: '1832' },
  { name: 'guitar', unicode: '🎸', shortname: ':guitar:', category: 'a', emoji_order: '1833' },
  { name: 'musical_keyboard', unicode: '🎹', shortname: ':musical_keyboard:', category: 'a', emoji_order: '1834' },
  { name: 'trumpet', unicode: '🎺', shortname: ':trumpet:', category: 'a', emoji_order: '1835' },
  { name: 'violin', unicode: '🎻', shortname: ':violin:', category: 'a', emoji_order: '1836' },
  { name: 'drum', unicode: '🥁', shortname: ':drum:', category: 'a', emoji_order: '1837' },
  { name: 'iphone', unicode: '📱', shortname: ':iphone:', category: 'o', emoji_order: '1838' },
  { name: 'calling', unicode: '📲', shortname: ':calling:', category: 'o', emoji_order: '1839' },
  { name: 'telephone', unicode: '☎', shortname: ':telephone:', category: 'o', emoji_order: '1840' },
  { name: 'telephone_receiver', unicode: '📞', shortname: ':telephone_receiver:', category: 'o', emoji_order: '1841' },
  { name: 'pager', unicode: '📟', shortname: ':pager:', category: 'o', emoji_order: '1842' },
  { name: 'fax', unicode: '📠', shortname: ':fax:', category: 'o', emoji_order: '1843' },
  { name: 'battery', unicode: '🔋', shortname: ':battery:', category: 'o', emoji_order: '1844' },
  { name: 'electric_plug', unicode: '🔌', shortname: ':electric_plug:', category: 'o', emoji_order: '1845' },
  { name: 'computer', unicode: '💻', shortname: ':computer:', category: 'o', emoji_order: '1846' },
  { name: 'desktop_computer', unicode: '🖥', shortname: ':desktop:', category: 'o', emoji_order: '1847' },
  { name: 'printer', unicode: '🖨', shortname: ':printer:', category: 'o', emoji_order: '1848' },
  { name: 'keyboard', unicode: '⌨', shortname: ':keyboard:', category: 'o', emoji_order: '1849' },
  { name: 'three_button_mouse', unicode: '🖱', shortname: ':mouse_three_button:', category: 'o', emoji_order: '1850' },
  { name: 'trackball', unicode: '🖲', shortname: ':trackball:', category: 'o', emoji_order: '1851' },
  { name: 'minidisc', unicode: '💽', shortname: ':minidisc:', category: 'o', emoji_order: '1852' },
  { name: 'floppy_disk', unicode: '💾', shortname: ':floppy_disk:', category: 'o', emoji_order: '1853' },
  { name: 'cd', unicode: '💿', shortname: ':cd:', category: 'o', emoji_order: '1854' },
  { name: 'dvd', unicode: '📀', shortname: ':dvd:', category: 'o', emoji_order: '1855' },
  { name: 'movie_camera', unicode: '🎥', shortname: ':movie_camera:', category: 'o', emoji_order: '1856' },
  { name: 'film_frames', unicode: '🎞', shortname: ':film_frames:', category: 'o', emoji_order: '1857' },
  { name: 'film_projector', unicode: '📽', shortname: ':projector:', category: 'o', emoji_order: '1858' },
  { name: 'clapper', unicode: '🎬', shortname: ':clapper:', category: 'a', emoji_order: '1859' },
  { name: 'tv', unicode: '📺', shortname: ':tv:', category: 'o', emoji_order: '1860' },
  { name: 'camera', unicode: '📷', shortname: ':camera:', category: 'o', emoji_order: '1861' },
  { name: 'camera_with_flash', unicode: '📸', shortname: ':camera_with_flash:', category: 'o', emoji_order: '1862' },
  { name: 'video_camera', unicode: '📹', shortname: ':video_camera:', category: 'o', emoji_order: '1863' },
  { name: 'vhs', unicode: '📼', shortname: ':vhs:', category: 'o', emoji_order: '1864' },
  { name: 'mag', unicode: '🔍', shortname: ':mag:', category: 'o', emoji_order: '1865' },
  { name: 'mag_right', unicode: '🔎', shortname: ':mag_right:', category: 'o', emoji_order: '1866' },
  { name: 'microscope', unicode: '🔬', shortname: ':microscope:', category: 'o', emoji_order: '1867' },
  { name: 'telescope', unicode: '🔭', shortname: ':telescope:', category: 'o', emoji_order: '1868' },
  { name: 'satellite_antenna', unicode: '📡', shortname: ':satellite:', category: 'o', emoji_order: '1869' },
  { name: 'candle', unicode: '🕯', shortname: ':candle:', category: 'o', emoji_order: '1870' },
  { name: 'bulb', unicode: '💡', shortname: ':bulb:', category: 'o', emoji_order: '1871' },
  { name: 'flashlight', unicode: '🔦', shortname: ':flashlight:', category: 'o', emoji_order: '1872' },
  { name: 'izakaya_lantern', unicode: '🏮', shortname: ':izakaya_lantern:', category: 'o', emoji_order: '1873' },
  {
    name: 'notebook_with_decorative_cover',
    unicode: '📔',
    shortname: ':notebook_with_decorative_cover:',
    category: 'o',
    emoji_order: '1874',
  },
  { name: 'closed_book', unicode: '📕', shortname: ':closed_book:', category: 'o', emoji_order: '1875' },
  { name: 'book', unicode: '📖', shortname: ':book:', category: 'o', emoji_order: '1876' },
  { name: 'green_book', unicode: '📗', shortname: ':green_book:', category: 'o', emoji_order: '1877' },
  { name: 'blue_book', unicode: '📘', shortname: ':blue_book:', category: 'o', emoji_order: '1878' },
  { name: 'orange_book', unicode: '📙', shortname: ':orange_book:', category: 'o', emoji_order: '1879' },
  { name: 'books', unicode: '📚', shortname: ':books:', category: 'o', emoji_order: '1880' },
  { name: 'notebook', unicode: '📓', shortname: ':notebook:', category: 'o', emoji_order: '1881' },
  { name: 'ledger', unicode: '📒', shortname: ':ledger:', category: 'o', emoji_order: '1882' },
  { name: 'page_with_curl', unicode: '📃', shortname: ':page_with_curl:', category: 'o', emoji_order: '1883' },
  { name: 'scroll', unicode: '📜', shortname: ':scroll:', category: 'o', emoji_order: '1884' },
  { name: 'page_facing_up', unicode: '📄', shortname: ':page_facing_up:', category: 'o', emoji_order: '1885' },
  { name: 'newspaper', unicode: '📰', shortname: ':newspaper:', category: 'o', emoji_order: '1886' },
  { name: 'rolled_up_newspaper', unicode: '🗞', shortname: ':newspaper2:', category: 'o', emoji_order: '1887' },
  { name: 'bookmark_tabs', unicode: '📑', shortname: ':bookmark_tabs:', category: 'o', emoji_order: '1888' },
  { name: 'bookmark', unicode: '🔖', shortname: ':bookmark:', category: 'o', emoji_order: '1889' },
  { name: 'label', unicode: '🏷', shortname: ':label:', category: 'o', emoji_order: '1890' },
  { name: 'moneybag', unicode: '💰', shortname: ':moneybag:', category: 'o', emoji_order: '1891' },
  { name: 'yen', unicode: '💴', shortname: ':yen:', category: 'o', emoji_order: '1892' },
  { name: 'dollar', unicode: '💵', shortname: ':dollar:', category: 'o', emoji_order: '1893' },
  { name: 'euro', unicode: '💶', shortname: ':euro:', category: 'o', emoji_order: '1894' },
  { name: 'pound', unicode: '💷', shortname: ':pound:', category: 'o', emoji_order: '1895' },
  { name: 'money_with_wings', unicode: '💸', shortname: ':money_with_wings:', category: 'o', emoji_order: '1896' },
  { name: 'credit_card', unicode: '💳', shortname: ':credit_card:', category: 'o', emoji_order: '1897' },
  { name: 'chart', unicode: '💹', shortname: ':chart:', category: 's', emoji_order: '1898' },
  { name: 'currency_exchange', unicode: '💱', shortname: ':currency_exchange:', category: 's', emoji_order: '1899' },
  { name: 'heavy_dollar_sign', unicode: '💲', shortname: ':heavy_dollar_sign:', category: 's', emoji_order: '1900' },
  { name: 'envelope', unicode: '✉', shortname: ':envelope:', category: 'o', emoji_order: '1901' },
  { name: 'e-mail', unicode: '📧', shortname: ':e-mail:', category: 'o', emoji_order: '1902' },
  { name: 'incoming_envelope', unicode: '📨', shortname: ':incoming_envelope:', category: 'o', emoji_order: '1903' },
  {
    name: 'envelope_with_arrow',
    unicode: '📩',
    shortname: ':envelope_with_arrow:',
    category: 'o',
    emoji_order: '1904',
  },
  { name: 'outbox_tray', unicode: '📤', shortname: ':outbox_tray:', category: 'o', emoji_order: '1905' },
  { name: 'inbox_tray', unicode: '📥', shortname: ':inbox_tray:', category: 'o', emoji_order: '1906' },
  { name: 'package', unicode: '📦', shortname: ':package:', category: 'o', emoji_order: '1907' },
  { name: 'mailbox', unicode: '📫', shortname: ':mailbox:', category: 'o', emoji_order: '1908' },
  { name: 'mailbox_closed', unicode: '📪', shortname: ':mailbox_closed:', category: 'o', emoji_order: '1909' },
  { name: 'mailbox_with_mail', unicode: '📬', shortname: ':mailbox_with_mail:', category: 'o', emoji_order: '1910' },
  {
    name: 'mailbox_with_no_mail',
    unicode: '📭',
    shortname: ':mailbox_with_no_mail:',
    category: 'o',
    emoji_order: '1911',
  },
  { name: 'postbox', unicode: '📮', shortname: ':postbox:', category: 'o', emoji_order: '1912' },
  { name: 'ballot_box_with_ballot', unicode: '🗳', shortname: ':ballot_box:', category: 'o', emoji_order: '1913' },
  { name: 'pencil2', unicode: '✏', shortname: ':pencil2:', category: 'o', emoji_order: '1914' },
  { name: 'black_nib', unicode: '✒', shortname: ':black_nib:', category: 'o', emoji_order: '1915' },
  { name: 'lower_left_fountain_pen', unicode: '🖋', shortname: ':pen_fountain:', category: 'o', emoji_order: '1916' },
  { name: 'lower_left_ballpoint_pen', unicode: '🖊', shortname: ':pen_ballpoint:', category: 'o', emoji_order: '1917' },
  { name: 'lower_left_paintbrush', unicode: '🖌', shortname: ':paintbrush:', category: 'o', emoji_order: '1918' },
  { name: 'lower_left_crayon', unicode: '🖍', shortname: ':crayon:', category: 'o', emoji_order: '1919' },
  { name: 'memo', unicode: '📝', shortname: ':pencil:', category: 'o', emoji_order: '1920' },
  { name: 'briefcase', unicode: '💼', shortname: ':briefcase:', category: 'p', emoji_order: '1921' },
  { name: 'file_folder', unicode: '📁', shortname: ':file_folder:', category: 'o', emoji_order: '1922' },
  { name: 'open_file_folder', unicode: '📂', shortname: ':open_file_folder:', category: 'o', emoji_order: '1923' },
  { name: 'card_index_dividers', unicode: '🗂', shortname: ':dividers:', category: 'o', emoji_order: '1924' },
  { name: 'date', unicode: '📅', shortname: ':date:', category: 'o', emoji_order: '1925' },
  { name: 'calendar', unicode: '📆', shortname: ':calendar:', category: 'o', emoji_order: '1926' },
  { name: 'spiral_note_pad', unicode: '🗒', shortname: ':notepad_spiral:', category: 'o', emoji_order: '1927' },
  { name: 'spiral_calendar_pad', unicode: '🗓', shortname: ':calendar_spiral:', category: 'o', emoji_order: '1928' },
  { name: 'card_index', unicode: '📇', shortname: ':card_index:', category: 'o', emoji_order: '1929' },
  {
    name: 'chart_with_upwards_trend',
    unicode: '📈',
    shortname: ':chart_with_upwards_trend:',
    category: 'o',
    emoji_order: '1930',
  },
  {
    name: 'chart_with_downwards_trend',
    unicode: '📉',
    shortname: ':chart_with_downwards_trend:',
    category: 'o',
    emoji_order: '1931',
  },
  { name: 'bar_chart', unicode: '📊', shortname: ':bar_chart:', category: 'o', emoji_order: '1932' },
  { name: 'clipboard', unicode: '📋', shortname: ':clipboard:', category: 'o', emoji_order: '1933' },
  { name: 'pushpin', unicode: '📌', shortname: ':pushpin:', category: 'o', emoji_order: '1934' },
  { name: 'round_pushpin', unicode: '📍', shortname: ':round_pushpin:', category: 'o', emoji_order: '1935' },
  { name: 'paperclip', unicode: '📎', shortname: ':paperclip:', category: 'o', emoji_order: '1936' },
  { name: 'linked_paperclips', unicode: '🖇', shortname: ':paperclips:', category: 'o', emoji_order: '1937' },
  { name: 'straight_ruler', unicode: '📏', shortname: ':straight_ruler:', category: 'o', emoji_order: '1938' },
  { name: 'triangular_ruler', unicode: '📐', shortname: ':triangular_ruler:', category: 'o', emoji_order: '1939' },
  { name: 'scissors', unicode: '✂', shortname: ':scissors:', category: 'o', emoji_order: '1940' },
  { name: 'card_file_box', unicode: '🗃', shortname: ':card_box:', category: 'o', emoji_order: '1941' },
  { name: 'file_cabinet', unicode: '🗄', shortname: ':file_cabinet:', category: 'o', emoji_order: '1942' },
  { name: 'wastebasket', unicode: '🗑', shortname: ':wastebasket:', category: 'o', emoji_order: '1943' },
  { name: 'lock', unicode: '🔒', shortname: ':lock:', category: 'o', emoji_order: '1944' },
  { name: 'unlock', unicode: '🔓', shortname: ':unlock:', category: 'o', emoji_order: '1945' },
  { name: 'lock_with_ink_pen', unicode: '🔏', shortname: ':lock_with_ink_pen:', category: 'o', emoji_order: '1946' },
  {
    name: 'closed_lock_with_key',
    unicode: '🔐',
    shortname: ':closed_lock_with_key:',
    category: 'o',
    emoji_order: '1947',
  },
  { name: 'key', unicode: '🔑', shortname: ':key:', category: 'o', emoji_order: '1948' },
  { name: 'old_key', unicode: '🗝', shortname: ':key2:', category: 'o', emoji_order: '1949' },
  { name: 'hammer', unicode: '🔨', shortname: ':hammer:', category: 'o', emoji_order: '1950' },
  { name: 'pick', unicode: '⛏', shortname: ':pick:', category: 'o', emoji_order: '1951' },
  { name: 'hammer_and_pick', unicode: '⚒', shortname: ':hammer_pick:', category: 'o', emoji_order: '1952' },
  { name: 'hammer_and_wrench', unicode: '🛠', shortname: ':tools:', category: 'o', emoji_order: '1953' },
  { name: 'dagger_knife', unicode: '🗡', shortname: ':dagger:', category: 'o', emoji_order: '1954' },
  { name: 'crossed_swords', unicode: '⚔', shortname: ':crossed_swords:', category: 'o', emoji_order: '1955' },
  { name: 'gun', unicode: '🔫', shortname: ':gun:', category: 'o', emoji_order: '1956' },
  { name: 'bow_and_arrow', unicode: '🏹', shortname: ':bow_and_arrow:', category: 'a', emoji_order: '1957' },
  { name: 'shield', unicode: '🛡', shortname: ':shield:', category: 'o', emoji_order: '1958' },
  { name: 'wrench', unicode: '🔧', shortname: ':wrench:', category: 'o', emoji_order: '1959' },
  { name: 'nut_and_bolt', unicode: '🔩', shortname: ':nut_and_bolt:', category: 'o', emoji_order: '1960' },
  { name: 'gear', unicode: '⚙', shortname: ':gear:', category: 'o', emoji_order: '1961' },
  { name: 'compression', unicode: '🗜', shortname: ':compression:', category: 'o', emoji_order: '1962' },
  { name: 'alembic', unicode: '⚗', shortname: ':alembic:', category: 'o', emoji_order: '1963' },
  { name: 'scales', unicode: '⚖', shortname: ':scales:', category: 'o', emoji_order: '1964' },
  { name: 'link', unicode: '🔗', shortname: ':link:', category: 'o', emoji_order: '1965' },
  { name: 'chains', unicode: '⛓', shortname: ':chains:', category: 'o', emoji_order: '1966' },
  { name: 'syringe', unicode: '💉', shortname: ':syringe:', category: 'o', emoji_order: '1967' },
  { name: 'pill', unicode: '💊', shortname: ':pill:', category: 'o', emoji_order: '1968' },
  { name: 'smoking', unicode: '🚬', shortname: ':smoking:', category: 'o', emoji_order: '1969' },
  { name: 'coffin', unicode: '⚰', shortname: ':coffin:', category: 'o', emoji_order: '1970' },
  { name: 'funeral_urn', unicode: '⚱', shortname: ':urn:', category: 'o', emoji_order: '1971' },
  { name: 'moyai', unicode: '🗿', shortname: ':moyai:', category: 'o', emoji_order: '1972' },
  { name: 'oil_drum', unicode: '🛢', shortname: ':oil:', category: 'o', emoji_order: '1973' },
  { name: 'crystal_ball', unicode: '🔮', shortname: ':crystal_ball:', category: 'o', emoji_order: '1974' },
  { name: 'shopping_cart', unicode: '🛒', shortname: ':shopping_cart:', category: 'o', emoji_order: '1975' },
  { name: 'atm', unicode: '🏧', shortname: ':atm:', category: 's', emoji_order: '1976' },
  {
    name: 'put_litter_in_its_place',
    unicode: '🚮',
    shortname: ':put_litter_in_its_place:',
    category: 's',
    emoji_order: '1977',
  },
  { name: 'potable_water', unicode: '🚰', shortname: ':potable_water:', category: 's', emoji_order: '1978' },
  { name: 'wheelchair', unicode: '♿', shortname: ':wheelchair:', category: 's', emoji_order: '1979' },
  { name: 'mens', unicode: '🚹', shortname: ':mens:', category: 's', emoji_order: '1980' },
  { name: 'womens', unicode: '🚺', shortname: ':womens:', category: 's', emoji_order: '1981' },
  { name: 'restroom', unicode: '🚻', shortname: ':restroom:', category: 's', emoji_order: '1982' },
  { name: 'baby_symbol', unicode: '🚼', shortname: ':baby_symbol:', category: 's', emoji_order: '1983' },
  { name: 'wc', unicode: '🚾', shortname: ':wc:', category: 's', emoji_order: '1984' },
  { name: 'passport_control', unicode: '🛂', shortname: ':passport_control:', category: 's', emoji_order: '1985' },
  { name: 'customs', unicode: '🛃', shortname: ':customs:', category: 's', emoji_order: '1986' },
  { name: 'baggage_claim', unicode: '🛄', shortname: ':baggage_claim:', category: 's', emoji_order: '1987' },
  { name: 'left_luggage', unicode: '🛅', shortname: ':left_luggage:', category: 's', emoji_order: '1988' },
  { name: 'warning', unicode: '⚠', shortname: ':warning:', category: 's', emoji_order: '1989' },
  { name: 'children_crossing', unicode: '🚸', shortname: ':children_crossing:', category: 's', emoji_order: '1990' },
  { name: 'no_entry', unicode: '⛔', shortname: ':no_entry:', category: 's', emoji_order: '1991' },
  { name: 'no_entry_sign', unicode: '🚫', shortname: ':no_entry_sign:', category: 's', emoji_order: '1992' },
  { name: 'no_bicycles', unicode: '🚳', shortname: ':no_bicycles:', category: 's', emoji_order: '1993' },
  { name: 'no_smoking', unicode: '🚭', shortname: ':no_smoking:', category: 's', emoji_order: '1994' },
  { name: 'do_not_litter', unicode: '🚯', shortname: ':do_not_litter:', category: 's', emoji_order: '1995' },
  { name: 'non-potable_water', unicode: '🚱', shortname: ':non-potable_water:', category: 's', emoji_order: '1996' },
  { name: 'no_pedestrians', unicode: '🚷', shortname: ':no_pedestrians:', category: 's', emoji_order: '1997' },
  { name: 'no_mobile_phones', unicode: '📵', shortname: ':no_mobile_phones:', category: 's', emoji_order: '1998' },
  { name: 'underage', unicode: '🔞', shortname: ':underage:', category: 's', emoji_order: '1999' },
  { name: 'radioactive', unicode: '☢', shortname: ':radioactive:', category: 's', emoji_order: '2000' },
  { name: 'biohazard', unicode: '☣', shortname: ':biohazard:', category: 's', emoji_order: '2001' },
  { name: 'arrow_up', unicode: '⬆', shortname: ':arrow_up:', category: 's', emoji_order: '2002' },
  { name: 'arrow_upper_right', unicode: '↗', shortname: ':arrow_upper_right:', category: 's', emoji_order: '2003' },
  { name: 'arrow_right', unicode: '➡', shortname: ':arrow_right:', category: 's', emoji_order: '2004' },
  { name: 'arrow_lower_right', unicode: '↘', shortname: ':arrow_lower_right:', category: 's', emoji_order: '2005' },
  { name: 'arrow_down', unicode: '⬇', shortname: ':arrow_down:', category: 's', emoji_order: '2006' },
  { name: 'arrow_lower_left', unicode: '↙', shortname: ':arrow_lower_left:', category: 's', emoji_order: '2007' },
  { name: 'arrow_left', unicode: '⬅', shortname: ':arrow_left:', category: 's', emoji_order: '2008' },
  { name: 'arrow_upper_left', unicode: '↖', shortname: ':arrow_upper_left:', category: 's', emoji_order: '2009' },
  { name: 'arrow_up_down', unicode: '↕', shortname: ':arrow_up_down:', category: 's', emoji_order: '2010' },
  { name: 'left_right_arrow', unicode: '↔', shortname: ':left_right_arrow:', category: 's', emoji_order: '2011' },
  {
    name: 'leftwards_arrow_with_hook',
    unicode: '↩',
    shortname: ':leftwards_arrow_with_hook:',
    category: 's',
    emoji_order: '2012',
  },
  { name: 'arrow_right_hook', unicode: '↪', shortname: ':arrow_right_hook:', category: 's', emoji_order: '2013' },
  { name: 'arrow_heading_up', unicode: '⤴', shortname: ':arrow_heading_up:', category: 's', emoji_order: '2014' },
  { name: 'arrow_heading_down', unicode: '⤵', shortname: ':arrow_heading_down:', category: 's', emoji_order: '2015' },
  { name: 'arrows_clockwise', unicode: '🔃', shortname: ':arrows_clockwise:', category: 's', emoji_order: '2016' },
  {
    name: 'arrows_counterclockwise',
    unicode: '🔄',
    shortname: ':arrows_counterclockwise:',
    category: 's',
    emoji_order: '2017',
  },
  { name: 'back', unicode: '🔙', shortname: ':back:', category: 's', emoji_order: '2018' },
  { name: 'end', unicode: '🔚', shortname: ':end:', category: 's', emoji_order: '2019' },
  { name: 'on', unicode: '🔛', shortname: ':on:', category: 's', emoji_order: '2020' },
  { name: 'soon', unicode: '🔜', shortname: ':soon:', category: 's', emoji_order: '2021' },
  { name: 'top', unicode: '🔝', shortname: ':top:', category: 's', emoji_order: '2022' },
  { name: 'place_of_worship', unicode: '🛐', shortname: ':place_of_worship:', category: 's', emoji_order: '2023' },
  { name: 'atom_symbol', unicode: '⚛', shortname: ':atom:', category: 's', emoji_order: '2024' },
  { name: 'om_symbol', unicode: '🕉', shortname: ':om_symbol:', category: 's', emoji_order: '2025' },
  { name: 'star_of_david', unicode: '✡', shortname: ':star_of_david:', category: 's', emoji_order: '2026' },
  { name: 'wheel_of_dharma', unicode: '☸', shortname: ':wheel_of_dharma:', category: 's', emoji_order: '2027' },
  { name: 'yin_yang', unicode: '☯', shortname: ':yin_yang:', category: 's', emoji_order: '2028' },
  { name: 'latin_cross', unicode: '✝', shortname: ':cross:', category: 's', emoji_order: '2029' },
  { name: 'orthodox_cross', unicode: '☦', shortname: ':orthodox_cross:', category: 's', emoji_order: '2030' },
  { name: 'star_and_crescent', unicode: '☪', shortname: ':star_and_crescent:', category: 's', emoji_order: '2031' },
  { name: 'peace_symbol', unicode: '☮', shortname: ':peace:', category: 's', emoji_order: '2032' },
  { name: 'menorah_with_nine_branches', unicode: '🕎', shortname: ':menorah:', category: 's', emoji_order: '2033' },
  { name: 'six_pointed_star', unicode: '🔯', shortname: ':six_pointed_star:', category: 's', emoji_order: '2034' },
  { name: 'aries', unicode: '♈', shortname: ':aries:', category: 's', emoji_order: '2035' },
  { name: 'taurus', unicode: '♉', shortname: ':taurus:', category: 's', emoji_order: '2036' },
  { name: 'gemini', unicode: '♊', shortname: ':gemini:', category: 's', emoji_order: '2037' },
  { name: 'cancer', unicode: '♋', shortname: ':cancer:', category: 's', emoji_order: '2038' },
  { name: 'leo', unicode: '♌', shortname: ':leo:', category: 's', emoji_order: '2039' },
  { name: 'virgo', unicode: '♍', shortname: ':virgo:', category: 's', emoji_order: '2040' },
  { name: 'libra', unicode: '♎', shortname: ':libra:', category: 's', emoji_order: '2041' },
  { name: 'scorpius', unicode: '♏', shortname: ':scorpius:', category: 's', emoji_order: '2042' },
  { name: 'sagittarius', unicode: '♐', shortname: ':sagittarius:', category: 's', emoji_order: '2043' },
  { name: 'capricorn', unicode: '♑', shortname: ':capricorn:', category: 's', emoji_order: '2044' },
  { name: 'aquarius', unicode: '♒', shortname: ':aquarius:', category: 's', emoji_order: '2045' },
  { name: 'pisces', unicode: '♓', shortname: ':pisces:', category: 's', emoji_order: '2046' },
  { name: 'ophiuchus', unicode: '⛎', shortname: ':ophiuchus:', category: 's', emoji_order: '2047' },
  {
    name: 'twisted_rightwards_arrows',
    unicode: '🔀',
    shortname: ':twisted_rightwards_arrows:',
    category: 's',
    emoji_order: '2048',
  },
  { name: 'repeat', unicode: '🔁', shortname: ':repeat:', category: 's', emoji_order: '2049' },
  { name: 'repeat_one', unicode: '🔂', shortname: ':repeat_one:', category: 's', emoji_order: '2050' },
  { name: 'arrow_forward', unicode: '▶', shortname: ':arrow_forward:', category: 's', emoji_order: '2051' },
  { name: 'fast_forward', unicode: '⏩', shortname: ':fast_forward:', category: 's', emoji_order: '2052' },
  {
    name: 'black_right_pointing_double_triangle_with_vertical_bar',
    unicode: '⏭',
    shortname: ':track_next:',
    category: 's',
    emoji_order: '2053',
  },
  {
    name: 'black_right_pointing_triangle_with_double_vertical_bar',
    unicode: '⏯',
    shortname: ':play_pause:',
    category: 's',
    emoji_order: '2054',
  },
  { name: 'arrow_backward', unicode: '◀', shortname: ':arrow_backward:', category: 's', emoji_order: '2055' },
  { name: 'rewind', unicode: '⏪', shortname: ':rewind:', category: 's', emoji_order: '2056' },
  {
    name: 'black_left_pointing_double_triangle_with_vertical_bar',
    unicode: '⏮',
    shortname: ':track_previous:',
    category: 's',
    emoji_order: '2057',
  },
  { name: 'arrow_up_small', unicode: '🔼', shortname: ':arrow_up_small:', category: 's', emoji_order: '2058' },
  { name: 'arrow_double_up', unicode: '⏫', shortname: ':arrow_double_up:', category: 's', emoji_order: '2059' },
  { name: 'arrow_down_small', unicode: '🔽', shortname: ':arrow_down_small:', category: 's', emoji_order: '2060' },
  { name: 'arrow_double_down', unicode: '⏬', shortname: ':arrow_double_down:', category: 's', emoji_order: '2061' },
  { name: 'double_vertical_bar', unicode: '⏸', shortname: ':pause_button:', category: 's', emoji_order: '2062' },
  { name: 'black_square_for_stop', unicode: '⏹', shortname: ':stop_button:', category: 's', emoji_order: '2063' },
  { name: 'black_circle_for_record', unicode: '⏺', shortname: ':record_button:', category: 's', emoji_order: '2064' },
  { name: 'eject', unicode: '⏏', shortname: ':eject:', category: 's', emoji_order: '2065' },
  { name: 'cinema', unicode: '🎦', shortname: ':cinema:', category: 's', emoji_order: '2066' },
  { name: 'low_brightness', unicode: '🔅', shortname: ':low_brightness:', category: 's', emoji_order: '2067' },
  { name: 'high_brightness', unicode: '🔆', shortname: ':high_brightness:', category: 's', emoji_order: '2068' },
  { name: 'signal_strength', unicode: '📶', shortname: ':signal_strength:', category: 's', emoji_order: '2069' },
  { name: 'vibration_mode', unicode: '📳', shortname: ':vibration_mode:', category: 's', emoji_order: '2070' },
  { name: 'mobile_phone_off', unicode: '📴', shortname: ':mobile_phone_off:', category: 's', emoji_order: '2071' },
  { name: 'recycle', unicode: '♻', shortname: ':recycle:', category: 's', emoji_order: '2072' },
  { name: 'name_badge', unicode: '📛', shortname: ':name_badge:', category: 's', emoji_order: '2073' },
  { name: 'fleur_de_lis', unicode: '⚜', shortname: ':fleur-de-lis:', category: 's', emoji_order: '2074' },
  { name: 'beginner', unicode: '🔰', shortname: ':beginner:', category: 's', emoji_order: '2075' },
  { name: 'trident', unicode: '🔱', shortname: ':trident:', category: 's', emoji_order: '2076' },
  { name: 'o', unicode: '⭕', shortname: ':o:', category: 's', emoji_order: '2077' },
  { name: 'white_check_mark', unicode: '✅', shortname: ':white_check_mark:', category: 's', emoji_order: '2078' },
  {
    name: 'ballot_box_with_check',
    unicode: '☑',
    shortname: ':ballot_box_with_check:',
    category: 's',
    emoji_order: '2079',
  },
  { name: 'heavy_check_mark', unicode: '✔', shortname: ':heavy_check_mark:', category: 's', emoji_order: '2080' },
  {
    name: 'heavy_multiplication_x',
    unicode: '✖',
    shortname: ':heavy_multiplication_x:',
    category: 's',
    emoji_order: '2081',
  },
  { name: 'x', unicode: '❌', shortname: ':x:', category: 's', emoji_order: '2082' },
  {
    name: 'negative_squared_cross_mark',
    unicode: '❎',
    shortname: ':negative_squared_cross_mark:',
    category: 's',
    emoji_order: '2083',
  },
  { name: 'heavy_plus_sign', unicode: '➕', shortname: ':heavy_plus_sign:', category: 's', emoji_order: '2084' },
  { name: 'heavy_minus_sign', unicode: '➖', shortname: ':heavy_minus_sign:', category: 's', emoji_order: '2088' },
  {
    name: 'heavy_division_sign',
    unicode: '➗',
    shortname: ':heavy_division_sign:',
    category: 's',
    emoji_order: '2089',
  },
  { name: 'curly_loop', unicode: '➰', shortname: ':curly_loop:', category: 's', emoji_order: '2090' },
  { name: 'loop', unicode: '➿', shortname: ':loop:', category: 's', emoji_order: '2091' },
  {
    name: 'part_alternation_mark',
    unicode: '〽',
    shortname: ':part_alternation_mark:',
    category: 's',
    emoji_order: '2092',
  },
  {
    name: 'eight_spoked_asterisk',
    unicode: '✳',
    shortname: ':eight_spoked_asterisk:',
    category: 's',
    emoji_order: '2093',
  },
  {
    name: 'eight_pointed_black_star',
    unicode: '✴',
    shortname: ':eight_pointed_black_star:',
    category: 's',
    emoji_order: '2094',
  },
  { name: 'sparkle', unicode: '❇', shortname: ':sparkle:', category: 's', emoji_order: '2095' },
  { name: 'bangbang', unicode: '‼', shortname: ':bangbang:', category: 's', emoji_order: '2096' },
  { name: 'interrobang', unicode: '⁉', shortname: ':interrobang:', category: 's', emoji_order: '2097' },
  { name: 'question', unicode: '❓', shortname: ':question:', category: 's', emoji_order: '2098' },
  { name: 'grey_question', unicode: '❔', shortname: ':grey_question:', category: 's', emoji_order: '2099' },
  { name: 'grey_exclamation', unicode: '❕', shortname: ':grey_exclamation:', category: 's', emoji_order: '2100' },
  { name: 'exclamation', unicode: '❗', shortname: ':exclamation:', category: 's', emoji_order: '2101' },
  { name: 'wavy_dash', unicode: '〰', shortname: ':wavy_dash:', category: 's', emoji_order: '2102' },
  { name: 'copyright', unicode: '©', shortname: ':copyright:', category: 's', emoji_order: '2103' },
  { name: 'registered', unicode: '®', shortname: ':registered:', category: 's', emoji_order: '2104' },
  { name: 'tm', unicode: '™', shortname: ':tm:', category: 's', emoji_order: '2105' },
  { name: 'hash', unicode: '#️⃣', shortname: ':hash:', category: 's', emoji_order: '2106' },
  { name: 'keycap_star', unicode: '*️⃣', shortname: ':asterisk:', category: 's', emoji_order: '2107' },
  { name: 'zero', unicode: '0️⃣', shortname: ':zero:', category: 's', emoji_order: '2108' },
  { name: 'one', unicode: '1️⃣', shortname: ':one:', category: 's', emoji_order: '2109' },
  { name: 'two', unicode: '2️⃣', shortname: ':two:', category: 's', emoji_order: '2110' },
  { name: 'three', unicode: '3️⃣', shortname: ':three:', category: 's', emoji_order: '2111' },
  { name: 'four', unicode: '4️⃣', shortname: ':four:', category: 's', emoji_order: '2112' },
  { name: 'five', unicode: '5️⃣', shortname: ':five:', category: 's', emoji_order: '2113' },
  { name: 'six', unicode: '6️⃣', shortname: ':six:', category: 's', emoji_order: '2114' },
  { name: 'seven', unicode: '7️⃣', shortname: ':seven:', category: 's', emoji_order: '2115' },
  { name: 'eight', unicode: '8️⃣', shortname: ':eight:', category: 's', emoji_order: '2116' },
  { name: 'nine', unicode: '9️⃣', shortname: ':nine:', category: 's', emoji_order: '2117' },
  { name: 'keycap_ten', unicode: '🔟', shortname: ':keycap_ten:', category: 's', emoji_order: '2118' },
  { name: 'capital_abcd', unicode: '🔠', shortname: ':capital_abcd:', category: 's', emoji_order: '2120' },
  { name: 'abcd', unicode: '🔡', shortname: ':abcd:', category: 's', emoji_order: '2121' },
  { name: 's', unicode: '🔣', shortname: ':s:', category: 's', emoji_order: '2123' },
  { name: 'abc', unicode: '🔤', shortname: ':abc:', category: 's', emoji_order: '2124' },
  { name: 'a', unicode: '🅰', shortname: ':a:', category: 's', emoji_order: '2125' },
  { name: 'ab', unicode: '🆎', shortname: ':ab:', category: 's', emoji_order: '2126' },
  { name: 'b', unicode: '🅱', shortname: ':b:', category: 's', emoji_order: '2127' },
  { name: 'cl', unicode: '🆑', shortname: ':cl:', category: 's', emoji_order: '2128' },
  { name: 'cool', unicode: '🆒', shortname: ':cool:', category: 's', emoji_order: '2129' },
  { name: 'free', unicode: '🆓', shortname: ':free:', category: 's', emoji_order: '2130' },
  { name: 'information_source', unicode: 'ℹ', shortname: ':information_source:', category: 's', emoji_order: '2131' },
  { name: 'id', unicode: '🆔', shortname: ':id:', category: 's', emoji_order: '2132' },
  { name: 'm', unicode: 'Ⓜ', shortname: ':m:', category: 's', emoji_order: '2133' },
  { name: 'new', unicode: '🆕', shortname: ':new:', category: 's', emoji_order: '2134' },
  { name: 'ng', unicode: '🆖', shortname: ':ng:', category: 's', emoji_order: '2135' },
  { name: 'o2', unicode: '🅾', shortname: ':o2:', category: 's', emoji_order: '2136' },
  { name: 'ok', unicode: '🆗', shortname: ':ok:', category: 's', emoji_order: '2137' },
  { name: 'parking', unicode: '🅿', shortname: ':parking:', category: 's', emoji_order: '2138' },
  { name: 'sos', unicode: '🆘', shortname: ':sos:', category: 's', emoji_order: '2139' },
  { name: 'up', unicode: '🆙', shortname: ':up:', category: 's', emoji_order: '2140' },
  { name: 'vs', unicode: '🆚', shortname: ':vs:', category: 's', emoji_order: '2141' },
  { name: 'koko', unicode: '🈁', shortname: ':koko:', category: 's', emoji_order: '2142' },
  { name: 'sa', unicode: '🈂', shortname: ':sa:', category: 's', emoji_order: '2143' },
  { name: 'u6708', unicode: '🈷', shortname: ':u6708:', category: 's', emoji_order: '2144' },
  { name: 'u6709', unicode: '🈶', shortname: ':u6709:', category: 's', emoji_order: '2145' },
  { name: 'u6307', unicode: '🈯', shortname: ':u6307:', category: 's', emoji_order: '2146' },
  {
    name: 'ideograph_advantage',
    unicode: '🉐',
    shortname: ':ideograph_advantage:',
    category: 's',
    emoji_order: '2147',
  },
  { name: 'u5272', unicode: '🈹', shortname: ':u5272:', category: 's', emoji_order: '2148' },
  { name: 'u7121', unicode: '🈚', shortname: ':u7121:', category: 's', emoji_order: '2149' },
  { name: 'u7981', unicode: '🈲', shortname: ':u7981:', category: 's', emoji_order: '2150' },
  { name: 'accept', unicode: '🉑', shortname: ':accept:', category: 's', emoji_order: '2151' },
  { name: 'u7533', unicode: '🈸', shortname: ':u7533:', category: 's', emoji_order: '2152' },
  { name: 'u5408', unicode: '🈴', shortname: ':u5408:', category: 's', emoji_order: '2153' },
  { name: 'u7a7a', unicode: '🈳', shortname: ':u7a7a:', category: 's', emoji_order: '2154' },
  { name: 'congratulations', unicode: '㊗', shortname: ':congratulations:', category: 's', emoji_order: '2155' },
  { name: 'secret', unicode: '㊙', shortname: ':secret:', category: 's', emoji_order: '2156' },
  { name: 'u55b6', unicode: '🈺', shortname: ':u55b6:', category: 's', emoji_order: '2157' },
  { name: 'u6e80', unicode: '🈵', shortname: ':u6e80:', category: 's', emoji_order: '2158' },
  { name: 'black_small_square', unicode: '▪', shortname: ':black_small_square:', category: 's', emoji_order: '2159' },
  { name: 'white_small_square', unicode: '▫', shortname: ':white_small_square:', category: 's', emoji_order: '2160' },
  {
    name: 'white_medium_square',
    unicode: '◻',
    shortname: ':white_medium_square:',
    category: 's',
    emoji_order: '2161',
  },
  {
    name: 'black_medium_square',
    unicode: '◼',
    shortname: ':black_medium_square:',
    category: 's',
    emoji_order: '2162',
  },
  {
    name: 'white_medium_small_square',
    unicode: '◽',
    shortname: ':white_medium_small_square:',
    category: 's',
    emoji_order: '2163',
  },
  {
    name: 'black_medium_small_square',
    unicode: '◾',
    shortname: ':black_medium_small_square:',
    category: 's',
    emoji_order: '2164',
  },
  { name: 'black_large_square', unicode: '⬛', shortname: ':black_large_square:', category: 's', emoji_order: '2165' },
  { name: 'white_large_square', unicode: '⬜', shortname: ':white_large_square:', category: 's', emoji_order: '2166' },
  {
    name: 'large_orange_diamond',
    unicode: '🔶',
    shortname: ':large_orange_diamond:',
    category: 's',
    emoji_order: '2167',
  },
  { name: 'large_blue_diamond', unicode: '🔷', shortname: ':large_blue_diamond:', category: 's', emoji_order: '2168' },
  {
    name: 'small_orange_diamond',
    unicode: '🔸',
    shortname: ':small_orange_diamond:',
    category: 's',
    emoji_order: '2169',
  },
  { name: 'small_blue_diamond', unicode: '🔹', shortname: ':small_blue_diamond:', category: 's', emoji_order: '2170' },
  { name: 'small_red_triangle', unicode: '🔺', shortname: ':small_red_triangle:', category: 's', emoji_order: '2171' },
  {
    name: 'small_red_triangle_down',
    unicode: '🔻',
    shortname: ':small_red_triangle_down:',
    category: 's',
    emoji_order: '2172',
  },
  {
    name: 'diamond_shape_with_a_dot_inside',
    unicode: '💠',
    shortname: ':diamond_shape_with_a_dot_inside:',
    category: 's',
    emoji_order: '2173',
  },
  { name: 'radio_button', unicode: '🔘', shortname: ':radio_button:', category: 's', emoji_order: '2174' },
  {
    name: 'black_square_button',
    unicode: '🔲',
    shortname: ':black_square_button:',
    category: 's',
    emoji_order: '2175',
  },
  {
    name: 'white_square_button',
    unicode: '🔳',
    shortname: ':white_square_button:',
    category: 's',
    emoji_order: '2176',
  },
  { name: 'white_circle', unicode: '⚪', shortname: ':white_circle:', category: 's', emoji_order: '2177' },
  { name: 'black_circle', unicode: '⚫', shortname: ':black_circle:', category: 's', emoji_order: '2178' },
  { name: 'red_circle', unicode: '🔴', shortname: ':red_circle:', category: 's', emoji_order: '2179' },
  { name: 'large_blue_circle', unicode: '🔵', shortname: ':blue_circle:', category: 's', emoji_order: '2180' },
  { name: 'checkered_flag', unicode: '🏁', shortname: ':checkered_flag:', category: 't', emoji_order: '2181' },
  {
    name: 'triangular_flag_on_post',
    unicode: '🚩',
    shortname: ':triangular_flag_on_post:',
    category: 'o',
    emoji_order: '2182',
  },
  { name: 'crossed_flags', unicode: '🎌', shortname: ':crossed_flags:', category: 'o', emoji_order: '2183' },
  { name: 'waving_black_flag', unicode: '🏴', shortname: ':flag_black:', category: 'o', emoji_order: '2184' },
  { name: 'waving_white_flag', unicode: '🏳', shortname: ':flag_white:', category: 'o', emoji_order: '2185' },
  { name: 'flag-ac', unicode: '🇨🇦', shortname: ':flag_ac:', category: 'f', emoji_order: '2187' },
  { name: 'flag-ad', unicode: '🇦🇩', shortname: ':flag_ad:', category: 'f', emoji_order: '2188' },
  { name: 'flag-ae', unicode: '🇦🇪', shortname: ':flag_ae:', category: 'f', emoji_order: '2189' },
  { name: 'flag-af', unicode: '🇦🇫', shortname: ':flag_af:', category: 'f', emoji_order: '2190' },
  { name: 'flag-ag', unicode: '🇦🇬', shortname: ':flag_ag:', category: 'f', emoji_order: '2191' },
  { name: 'flag-ai', unicode: '🇦🇮', shortname: ':flag_ai:', category: 'f', emoji_order: '2192' },
  { name: 'flag-al', unicode: '🇦🇱', shortname: ':flag_al:', category: 'f', emoji_order: '2193' },
  { name: 'flag-am', unicode: '🇦🇲', shortname: ':flag_am:', category: 'f', emoji_order: '2194' },
  { name: 'flag-ao', unicode: '🇦🇴', shortname: ':flag-ao:', category: 'f', emoji_order: '2195' },
  { name: 'flag-aq', unicode: '🇦🇶', shortname: ':flag-aq:', category: 'f', emoji_order: '2196' },
  { name: 'flag-ar', unicode: '🇦🇷', shortname: ':flag-ar:', category: 'f', emoji_order: '2197' },
  { name: 'flag-as', unicode: '🇦🇸', shortname: ':flag-as:', category: 'f', emoji_order: '2198' },
  { name: 'flag-at', unicode: '🇦🇹', shortname: ':flag-at:', category: 'f', emoji_order: '2199' },
  { name: 'flag-au', unicode: '🇦🇺', shortname: ':flag-au:', category: 'f', emoji_order: '2200' },
  { name: 'flag-aw', unicode: '🇦🇼', shortname: ':flag-aw:', category: 'f', emoji_order: '2201' },
  { name: 'flag-ax', unicode: '🇦🇽', shortname: ':flag-ax:', category: 'f', emoji_order: '2202' },
  { name: 'flag-az', unicode: '🇦🇿', shortname: ':flag-az:', category: 'f', emoji_order: '2203' },
  { name: 'flag-ba', unicode: '🇧🇦', shortname: ':flag-ba:', category: 'f', emoji_order: '2204' },
  { name: 'flag-bb', unicode: '🇧🇧', shortname: ':flag-bb:', category: 'f', emoji_order: '2205' },
  { name: 'flag-bd', unicode: '🇧🇩', shortname: ':flag-bd:', category: 'f', emoji_order: '2206' },
  { name: 'flag-be', unicode: '🇧🇪', shortname: ':flag-be:', category: 'f', emoji_order: '2207' },
  { name: 'flag-bf', unicode: '🇧🇫', shortname: ':flag-bf:', category: 'f', emoji_order: '2208' },
  { name: 'flag-bg', unicode: '🇧🇬', shortname: ':flag-bg:', category: 'f', emoji_order: '2209' },
  { name: 'flag-bh', unicode: '🇧🇭', shortname: ':flag-bh:', category: 'f', emoji_order: '2210' },
  { name: 'flag-bi', unicode: '🇧🇮', shortname: ':flag-bi:', category: 'f', emoji_order: '2211' },
  { name: 'flag-bj', unicode: '🇧🇯', shortname: ':flag-bj:', category: 'f', emoji_order: '2212' },
  { name: 'flag-bl', unicode: '🇧🇱', shortname: ':flag-bl:', category: 'f', emoji_order: '2213' },
  { name: 'flag-bm', unicode: '🇧🇲', shortname: ':flag-bm:', category: 'f', emoji_order: '2214' },
  { name: 'flag-bn', unicode: '🇧🇳', shortname: ':flag-bn:', category: 'f', emoji_order: '2215' },
  { name: 'flag-bo', unicode: '🇧🇴', shortname: ':flag-bo:', category: 'f', emoji_order: '2216' },
  { name: 'flag-bq', unicode: '🇧🇶', shortname: ':flag-bq:', category: 'f', emoji_order: '2217' },
  { name: 'flag-br', unicode: '🇧🇷', shortname: ':flag-br:', category: 'f', emoji_order: '2218' },
  { name: 'flag-bs', unicode: '🇧🇸', shortname: ':flag-bs:', category: 'f', emoji_order: '2219' },
  { name: 'flag-bt', unicode: '🇧🇹', shortname: ':flag-bt:', category: 'f', emoji_order: '2220' },
  { name: 'flag-bv', unicode: '🇧🇻', shortname: ':flag-bv:', category: 'f', emoji_order: '2221' },
  { name: 'flag-bw', unicode: '🇧🇼', shortname: ':flag-bw:', category: 'f', emoji_order: '2222' },
  { name: 'flag-by', unicode: '🇧🇾', shortname: ':flag-by:', category: 'f', emoji_order: '2223' },
  { name: 'flag-bz', unicode: '🇧🇿', shortname: ':flag-bz:', category: 'f', emoji_order: '2224' },
  { name: 'flag-ca', unicode: '🇨🇦', shortname: ':flag-ca:', category: 'f', emoji_order: '2225' },
  { name: 'flag-cc', unicode: '🇨🇨', shortname: ':flag-cc:', category: 'f', emoji_order: '2226' },
  { name: 'flag-cd', unicode: '🇨🇩', shortname: ':flag-cd:', category: 'f', emoji_order: '2227' },
  { name: 'flag-cf', unicode: '🇨🇫', shortname: ':flag-cf:', category: 'f', emoji_order: '2228' },
  { name: 'flag-cg', unicode: '🇨🇬', shortname: ':flag-cg:', category: 'f', emoji_order: '2229' },
  { name: 'flag-ch', unicode: '🇨🇭', shortname: ':flag-ch:', category: 'f', emoji_order: '2230' },
  { name: 'flag-ci', unicode: '🇨🇮', shortname: ':flag-ci:', category: 'f', emoji_order: '2231' },
  { name: 'flag-ck', unicode: '🇨🇰', shortname: ':flag-ck:', category: 'f', emoji_order: '2232' },
  { name: 'flag-cl', unicode: '🇨🇱', shortname: ':flag-cl:', category: 'f', emoji_order: '2233' },
  { name: 'flag-cm', unicode: '🇨🇲', shortname: ':flag-cm:', category: 'f', emoji_order: '2234' },
  { name: 'flag-cn', unicode: '🇨🇳', shortname: ':flag-cn:', category: 'f', emoji_order: '2235' },
  { name: 'flag-co', unicode: '🇨🇴', shortname: ':flag-co:', category: 'f', emoji_order: '2236' },
  { name: 'flag-cp', unicode: '🇨🇵', shortname: ':flag-cp:', category: 'f', emoji_order: '2237' },
  { name: 'flag-cr', unicode: '🇨🇷', shortname: ':flag-cr:', category: 'f', emoji_order: '2238' },
  { name: 'flag-cu', unicode: '🇨🇺', shortname: ':flag-cu:', category: 'f', emoji_order: '2239' },
  { name: 'flag-cv', unicode: '🇨🇻', shortname: ':flag-cv:', category: 'f', emoji_order: '2240' },
  { name: 'flag-cw', unicode: '🇨🇼', shortname: ':flag-cw:', category: 'f', emoji_order: '2241' },
  { name: 'flag-cx', unicode: '🇨🇽', shortname: ':flag-cx:', category: 'f', emoji_order: '2242' },
  { name: 'flag-cy', unicode: '🇨🇾', shortname: ':flag-cy:', category: 'f', emoji_order: '2243' },
  { name: 'flag-cz', unicode: '🇨🇿', shortname: ':flag-cz:', category: 'f', emoji_order: '2244' },
  { name: 'flag-de', unicode: '🇩🇪', shortname: ':flag-de:', category: 'f', emoji_order: '2245' },
  { name: 'flag-dg', unicode: '🇩🇬', shortname: ':flag-dg:', category: 'f', emoji_order: '2246' },
  { name: 'flag-dj', unicode: '🇩🇯', shortname: ':flag-dj:', category: 'f', emoji_order: '2247' },
  { name: 'flag-dk', unicode: '🇩🇰', shortname: ':flag-dk:', category: 'f', emoji_order: '2248' },
  { name: 'flag-dm', unicode: '🇩🇲', shortname: ':flag-dm:', category: 'f', emoji_order: '2249' },
  { name: 'flag-do', unicode: '🇩🇴', shortname: ':flag-do:', category: 'f', emoji_order: '2250' },
  { name: 'flag-dz', unicode: '🇩🇿', shortname: ':flag-dz:', category: 'f', emoji_order: '2251' },
  { name: 'flag-ea', unicode: '🇪🇦', shortname: ':flag-ea:', category: 'f', emoji_order: '2252' },
  { name: 'flag-ec', unicode: '🇪🇨', shortname: ':flag-ec:', category: 'f', emoji_order: '2253' },
  { name: 'flag-ee', unicode: '🇪🇪', shortname: ':flag-ee:', category: 'f', emoji_order: '2254' },
  { name: 'flag-eg', unicode: '🇪🇬', shortname: ':flag-eg:', category: 'f', emoji_order: '2255' },
  { name: 'flag-eh', unicode: '🇪🇭', shortname: ':flag-eh:', category: 'f', emoji_order: '2256' },
  { name: 'flag-er', unicode: '🇪🇷', shortname: ':flag-er:', category: 'f', emoji_order: '2257' },
  { name: 'flag-es', unicode: '🇪🇸', shortname: ':flag-es:', category: 'f', emoji_order: '2258' },
  { name: 'flag-et', unicode: '🇪🇹', shortname: ':flag-et:', category: 'f', emoji_order: '2259' },
  { name: 'flag-eu', unicode: '🇪🇺', shortname: ':flag-eu:', category: 'f', emoji_order: '2260' },
  { name: 'flag-fi', unicode: '🇫🇮', shortname: ':flag-fi:', category: 'f', emoji_order: '2261' },
  { name: 'flag-fj', unicode: '🇫🇯', shortname: ':flag-fj:', category: 'f', emoji_order: '2262' },
  { name: 'flag-fk', unicode: '🇫🇰', shortname: ':flag-fk:', category: 'f', emoji_order: '2263' },
  { name: 'flag-fm', unicode: '🇫🇲', shortname: ':flag-fm:', category: 'f', emoji_order: '2264' },
  { name: 'flag-fo', unicode: '🇫🇴', shortname: ':flag-fo:', category: 'f', emoji_order: '2265' },
  { name: 'flag-fr', unicode: '🇫🇷', shortname: ':flag-fr:', category: 'f', emoji_order: '2266' },
  { name: 'flag-ga', unicode: '🇬🇦', shortname: ':flag-ga:', category: 'f', emoji_order: '2267' },
  { name: 'flag-gb', unicode: '🇬🇧', shortname: ':flag-gb:', category: 'f', emoji_order: '2268' },
  { name: 'flag-gd', unicode: '🇬🇩', shortname: ':flag-gd:', category: 'f', emoji_order: '2269' },
  { name: 'flag-ge', unicode: '🇬🇪', shortname: ':flag-ge:', category: 'f', emoji_order: '2270' },
  { name: 'flag-gf', unicode: '🇬🇫', shortname: ':flag-gf:', category: 'f', emoji_order: '2271' },
  { name: 'flag-gg', unicode: '🇬🇬', shortname: ':flag-gg:', category: 'f', emoji_order: '2272' },
  { name: 'flag-gh', unicode: '🇬🇭', shortname: ':flag-gh:', category: 'f', emoji_order: '2273' },
  { name: 'flag-gi', unicode: '🇬🇮', shortname: ':flag-gi:', category: 'f', emoji_order: '2274' },
  { name: 'flag-gl', unicode: '🇬🇱', shortname: ':flag-gl:', category: 'f', emoji_order: '2275' },
  { name: 'flag-gm', unicode: '🇬🇲', shortname: ':flag-gm:', category: 'f', emoji_order: '2276' },
  { name: 'flag-gn', unicode: '🇬🇳', shortname: ':flag-gn:', category: 'f', emoji_order: '2277' },
  { name: 'flag-gp', unicode: '🇬🇵', shortname: ':flag-gp:', category: 'f', emoji_order: '2278' },
  { name: 'flag-gq', unicode: '🇬🇶', shortname: ':flag-gq:', category: 'f', emoji_order: '2279' },
  { name: 'flag-gr', unicode: '🇬🇷', shortname: ':flag-gr:', category: 'f', emoji_order: '2280' },
  { name: 'flag-gs', unicode: '🇬🇸', shortname: ':flag-gs:', category: 'f', emoji_order: '2281' },
  { name: 'flag-gt', unicode: '🇬🇹', shortname: ':flag-gt:', category: 'f', emoji_order: '2282' },
  { name: 'flag-gu', unicode: '🇬🇺', shortname: ':flag-gu:', category: 'f', emoji_order: '2283' },
  { name: 'flag-gw', unicode: '🇬🇼', shortname: ':flag-gw:', category: 'f', emoji_order: '2284' },
  { name: 'flag-gy', unicode: '🇬🇾', shortname: ':flag-gy:', category: 'f', emoji_order: '2285' },
  { name: 'flag-hk', unicode: '🇭🇰', shortname: ':flag-hk:', category: 'f', emoji_order: '2286' },
  { name: 'flag-hm', unicode: '🇭🇲', shortname: ':flag-hm:', category: 'f', emoji_order: '2287' },
  { name: 'flag-hn', unicode: '🇭🇳', shortname: ':flag-hn:', category: 'f', emoji_order: '2288' },
  { name: 'flag-hr', unicode: '🇭🇷', shortname: ':flag-hr:', category: 'f', emoji_order: '2289' },
  { name: 'flag-ht', unicode: '🇭🇹', shortname: ':flag-ht:', category: 'f', emoji_order: '2290' },
  { name: 'flag-hu', unicode: '🇭🇺', shortname: ':flag-hu:', category: 'f', emoji_order: '2291' },
  { name: 'flag-ic', unicode: '🇮🇨', shortname: ':flag-ic:', category: 'f', emoji_order: '2292' },
  { name: 'flag-id', unicode: '🇮🇩', shortname: ':flag-id:', category: 'f', emoji_order: '2293' },
  { name: 'flag-ie', unicode: '🇮🇪', shortname: ':flag-ie:', category: 'f', emoji_order: '2294' },
  { name: 'flag-il', unicode: '🇮🇱', shortname: ':flag-il:', category: 'f', emoji_order: '2295' },
  { name: 'flag-im', unicode: '🇮🇲', shortname: ':flag-im:', category: 'f', emoji_order: '2296' },
  { name: 'flag-in', unicode: '🇮🇳', shortname: ':flag-in:', category: 'f', emoji_order: '2297' },
  { name: 'flag-io', unicode: '🇮🇴', shortname: ':flag-io:', category: 'f', emoji_order: '2298' },
  { name: 'flag-iq', unicode: '🇮🇶', shortname: ':flag-iq:', category: 'f', emoji_order: '2299' },
  { name: 'flag-ir', unicode: '🇮🇷', shortname: ':flag-ir:', category: 'f', emoji_order: '2300' },
  { name: 'flag-is', unicode: '🇮🇸', shortname: ':flag-is:', category: 'f', emoji_order: '2301' },
  { name: 'flag-it', unicode: '🇮🇹', shortname: ':flag-it:', category: 'f', emoji_order: '2302' },
  { name: 'flag-je', unicode: '🇯🇪', shortname: ':flag-je:', category: 'f', emoji_order: '2303' },
  { name: 'flag-jm', unicode: '🇯🇲', shortname: ':flag-jm:', category: 'f', emoji_order: '2304' },
  { name: 'flag-jo', unicode: '🇯🇴', shortname: ':flag-jo:', category: 'f', emoji_order: '2305' },
  { name: 'flag-jp', unicode: '🇯🇵', shortname: ':flag-jp:', category: 'f', emoji_order: '2306' },
  { name: 'flag-ke', unicode: '🇰🇪', shortname: ':flag-ke:', category: 'f', emoji_order: '2307' },
  { name: 'flag-kg', unicode: '🇰🇬', shortname: ':flag-kg:', category: 'f', emoji_order: '2308' },
  { name: 'flag-kh', unicode: '🇰🇭', shortname: ':flag-kh:', category: 'f', emoji_order: '2309' },
  { name: 'flag-ki', unicode: '🇰🇮', shortname: ':flag-ki:', category: 'f', emoji_order: '2310' },
  { name: 'flag-km', unicode: '🇰🇲', shortname: ':flag-km:', category: 'f', emoji_order: '2311' },
  { name: 'flag-kn', unicode: '🇰🇳', shortname: ':flag-kn:', category: 'f', emoji_order: '2312' },
  { name: 'flag-kp', unicode: '🇰🇵', shortname: ':flag-kp:', category: 'f', emoji_order: '2313' },
  { name: 'flag-kr', unicode: '🇰🇷', shortname: ':flag-kr:', category: 'f', emoji_order: '2314' },
  { name: 'flag-kw', unicode: '🇰🇼', shortname: ':flag-kw:', category: 'f', emoji_order: '2315' },
  { name: 'flag-ky', unicode: '🇰🇾', shortname: ':flag-ky:', category: 'f', emoji_order: '2316' },
  { name: 'flag-kz', unicode: '🇰🇿', shortname: ':flag-kz:', category: 'f', emoji_order: '2317' },
  { name: 'flag-la', unicode: '🇱🇦', shortname: ':flag-la:', category: 'f', emoji_order: '2318' },
  { name: 'flag-lb', unicode: '🇱🇧', shortname: ':flag-lb:', category: 'f', emoji_order: '2319' },
  { name: 'flag-lc', unicode: '🇱🇨', shortname: ':flag-lc:', category: 'f', emoji_order: '2320' },
  { name: 'flag-li', unicode: '🇱🇮', shortname: ':flag-li:', category: 'f', emoji_order: '2321' },
  { name: 'flag-lk', unicode: '🇱🇰', shortname: ':flag-lk:', category: 'f', emoji_order: '2322' },
  { name: 'flag-lr', unicode: '🇱🇷', shortname: ':flag-lr:', category: 'f', emoji_order: '2323' },
  { name: 'flag-ls', unicode: '🇱🇸', shortname: ':flag-ls:', category: 'f', emoji_order: '2324' },
  { name: 'flag-lt', unicode: '🇱🇹', shortname: ':flag-lt:', category: 'f', emoji_order: '2325' },
  { name: 'flag-lu', unicode: '🇱🇺', shortname: ':flag-lu:', category: 'f', emoji_order: '2326' },
  { name: 'flag-lv', unicode: '🇱🇻', shortname: ':flag-lv:', category: 'f', emoji_order: '2327' },
  { name: 'flag-ly', unicode: '🇱🇾', shortname: ':flag-ly:', category: 'f', emoji_order: '2328' },
  { name: 'flag-ma', unicode: '🇲🇦', shortname: ':flag-ma:', category: 'f', emoji_order: '2329' },
  { name: 'flag-mc', unicode: '🇲🇨', shortname: ':flag-mc:', category: 'f', emoji_order: '2330' },
  { name: 'flag-md', unicode: '🇲🇩', shortname: ':flag-md:', category: 'f', emoji_order: '2331' },
  { name: 'flag-me', unicode: '🇲🇪', shortname: ':flag-me:', category: 'f', emoji_order: '2332' },
  { name: 'flag-mf', unicode: '🇲🇫', shortname: ':flag-mf:', category: 'f', emoji_order: '2333' },
  { name: 'flag-mg', unicode: '🇲🇬', shortname: ':flag-mg:', category: 'f', emoji_order: '2334' },
  { name: 'flag-mh', unicode: '🇲🇭', shortname: ':flag-mh:', category: 'f', emoji_order: '2335' },
  { name: 'flag-mk', unicode: '🇲🇰', shortname: ':flag-mk:', category: 'f', emoji_order: '2336' },
  { name: 'flag-ml', unicode: '🇲🇱', shortname: ':flag-ml:', category: 'f', emoji_order: '2337' },
  { name: 'flag-mm', unicode: '🇲🇲', shortname: ':flag-mm:', category: 'f', emoji_order: '2338' },
  { name: 'flag-mn', unicode: '🇲🇳', shortname: ':flag-mn:', category: 'f', emoji_order: '2339' },
  { name: 'flag-mo', unicode: '🇲🇴', shortname: ':flag-mo:', category: 'f', emoji_order: '2340' },
  { name: 'flag-mp', unicode: '🇲🇵', shortname: ':flag-mp:', category: 'f', emoji_order: '2341' },
  { name: 'flag-mq', unicode: '🇲🇶', shortname: ':flag-mq:', category: 'f', emoji_order: '2342' },
  { name: 'flag-mr', unicode: '🇲🇷', shortname: ':flag-mr:', category: 'f', emoji_order: '2343' },
  { name: 'flag-ms', unicode: '🇲🇸', shortname: ':flag-ms:', category: 'f', emoji_order: '2344' },
  { name: 'flag-mt', unicode: '🇲🇹', shortname: ':flag-mt:', category: 'f', emoji_order: '2345' },
  { name: 'flag-mu', unicode: '🇲🇺', shortname: ':flag-mu:', category: 'f', emoji_order: '2346' },
  { name: 'flag-mv', unicode: '🇲🇻', shortname: ':flag-mv:', category: 'f', emoji_order: '2347' },
  { name: 'flag-mw', unicode: '🇲🇼', shortname: ':flag-mw:', category: 'f', emoji_order: '2348' },
  { name: 'flag-mx', unicode: '🇲🇽', shortname: ':flag-mx:', category: 'f', emoji_order: '2349' },
  { name: 'flag-my', unicode: '🇲🇾', shortname: ':flag-my:', category: 'f', emoji_order: '2350' },
  { name: 'flag-mz', unicode: '🇲🇿', shortname: ':flag-mz:', category: 'f', emoji_order: '2351' },
  { name: 'flag-na', unicode: '🇳🇦', shortname: ':flag-na:', category: 'f', emoji_order: '2352' },
  { name: 'flag-nc', unicode: '🇳🇨', shortname: ':flag-nc:', category: 'f', emoji_order: '2353' },
  { name: 'flag-ne', unicode: '🇳🇪', shortname: ':flag-ne:', category: 'f', emoji_order: '2354' },
  { name: 'flag-nf', unicode: '🇳🇫', shortname: ':flag-nf:', category: 'f', emoji_order: '2355' },
  { name: 'flag-ng', unicode: '🇳🇬', shortname: ':flag-ng:', category: 'f', emoji_order: '2356' },
  { name: 'flag-ni', unicode: '🇳🇮', shortname: ':flag-ni:', category: 'f', emoji_order: '2357' },
  { name: 'flag-nl', unicode: '🇳🇱', shortname: ':flag-nl:', category: 'f', emoji_order: '2358' },
  { name: 'flag-no', unicode: '🇳🇴', shortname: ':flag-no:', category: 'f', emoji_order: '2359' },
  { name: 'flag-np', unicode: '🇳🇵', shortname: ':flag-np:', category: 'f', emoji_order: '2360' },
  { name: 'flag-nr', unicode: '🇳🇷', shortname: ':flag-nr:', category: 'f', emoji_order: '2361' },
  { name: 'flag-nu', unicode: '🇳🇺', shortname: ':flag-nu:', category: 'f', emoji_order: '2362' },
  { name: 'flag-nz', unicode: '🇳🇿', shortname: ':flag-nz:', category: 'f', emoji_order: '2363' },
  { name: 'flag-om', unicode: '🇴🇲', shortname: ':flag-om:', category: 'f', emoji_order: '2364' },
  { name: 'flag-pa', unicode: '🇵🇦', shortname: ':flag-pa:', category: 'f', emoji_order: '2365' },
  { name: 'flag-pe', unicode: '🇵🇪', shortname: ':flag-pe:', category: 'f', emoji_order: '2366' },
  { name: 'flag-pf', unicode: '🇵🇫', shortname: ':flag-pf:', category: 'f', emoji_order: '2367' },
  { name: 'flag-pg', unicode: '🇵🇬', shortname: ':flag-pg:', category: 'f', emoji_order: '2368' },
  { name: 'flag-ph', unicode: '🇵🇭', shortname: ':flag-ph:', category: 'f', emoji_order: '2369' },
  { name: 'flag-pk', unicode: '🇵🇰', shortname: ':flag-pk:', category: 'f', emoji_order: '2370' },
  { name: 'flag-pl', unicode: '🇵🇱', shortname: ':flag-pl:', category: 'f', emoji_order: '2371' },
  { name: 'flag-pm', unicode: '🇵🇲', shortname: ':flag-pm:', category: 'f', emoji_order: '2372' },
  { name: 'flag-pn', unicode: '🇵🇳', shortname: ':flag-pn:', category: 'f', emoji_order: '2373' },
  { name: 'flag-pr', unicode: '🇵🇷', shortname: ':flag-pr:', category: 'f', emoji_order: '2374' },
  { name: 'flag-ps', unicode: '🇵🇸', shortname: ':flag-ps:', category: 'f', emoji_order: '2375' },
  { name: 'flag-pt', unicode: '🇵🇹', shortname: ':flag-pt:', category: 'f', emoji_order: '2376' },
  { name: 'flag-pw', unicode: '🇵🇼', shortname: ':flag-pw:', category: 'f', emoji_order: '2377' },
  { name: 'flag-py', unicode: '🇵🇾', shortname: ':flag-py:', category: 'f', emoji_order: '2378' },
  { name: 'flag-qa', unicode: '🇶🇦', shortname: ':flag-qa:', category: 'f', emoji_order: '2379' },
  { name: 'flag-re', unicode: '🇷🇪', shortname: ':flag-re:', category: 'f', emoji_order: '2380' },
  { name: 'flag-ro', unicode: '🇷🇴', shortname: ':flag-ro:', category: 'f', emoji_order: '2381' },
  { name: 'flag-rs', unicode: '🇷🇸', shortname: ':flag-rs:', category: 'f', emoji_order: '2382' },
  { name: 'flag-ru', unicode: '🇷🇺', shortname: ':flag-ru:', category: 'f', emoji_order: '2383' },
  { name: 'flag-rw', unicode: '🇷🇼', shortname: ':flag-rw:', category: 'f', emoji_order: '2384' },
  { name: 'flag-sa', unicode: '🇸🇦', shortname: ':flag-sa:', category: 'f', emoji_order: '2385' },
  { name: 'flag-sb', unicode: '🇸🇧', shortname: ':flag-sb:', category: 'f', emoji_order: '2386' },
  { name: 'flag-sc', unicode: '🇸🇨', shortname: ':flag-sc:', category: 'f', emoji_order: '2387' },
  { name: 'flag-sd', unicode: '🇸🇩', shortname: ':flag-sd:', category: 'f', emoji_order: '2388' },
  { name: 'flag-se', unicode: '🇸🇪', shortname: ':flag-se:', category: 'f', emoji_order: '2389' },
  { name: 'flag-sg', unicode: '🇸🇬', shortname: ':flag-sg:', category: 'f', emoji_order: '2390' },
  { name: 'flag-sh', unicode: '🇸🇭', shortname: ':flag-sh:', category: 'f', emoji_order: '2391' },
  { name: 'flag-si', unicode: '🇸🇮', shortname: ':flag-si:', category: 'f', emoji_order: '2392' },
  { name: 'flag-sj', unicode: '🇸🇯', shortname: ':flag-sj:', category: 'f', emoji_order: '2393' },
  { name: 'flag-sk', unicode: '🇸🇰', shortname: ':flag-sk:', category: 'f', emoji_order: '2394' },
  { name: 'flag-sl', unicode: '🇸🇱', shortname: ':flag-sl:', category: 'f', emoji_order: '2395' },
  { name: 'flag-sm', unicode: '🇸🇲', shortname: ':flag-sm:', category: 'f', emoji_order: '2396' },
  { name: 'flag-sn', unicode: '🇸🇳', shortname: ':flag-sn:', category: 'f', emoji_order: '2397' },
  { name: 'flag-so', unicode: '🇸🇴', shortname: ':flag-so:', category: 'f', emoji_order: '2398' },
  { name: 'flag-sr', unicode: '🇸🇷', shortname: ':flag-sr:', category: 'f', emoji_order: '2399' },
  { name: 'flag-ss', unicode: '🇸🇸', shortname: ':flag-ss:', category: 'f', emoji_order: '2400' },
  { name: 'flag-st', unicode: '🇸🇹', shortname: ':flag-st:', category: 'f', emoji_order: '2401' },
  { name: 'flag-sv', unicode: '🇸🇻', shortname: ':flag-sv:', category: 'f', emoji_order: '2402' },
  { name: 'flag-sx', unicode: '🇸🇽', shortname: ':flag-sx:', category: 'f', emoji_order: '2403' },
  { name: 'flag-sy', unicode: '🇸🇾', shortname: ':flag-sy:', category: 'f', emoji_order: '2404' },
  { name: 'flag-sz', unicode: '🇸🇿', shortname: ':flag-sz:', category: 'f', emoji_order: '2405' },
  { name: 'flag-ta', unicode: '🇹🇦', shortname: ':flag-ta:', category: 'f', emoji_order: '2406' },
  { name: 'flag-tc', unicode: '🇹🇨', shortname: ':flag-tc:', category: 'f', emoji_order: '2407' },
  { name: 'flag-td', unicode: '🇹🇩', shortname: ':flag-td:', category: 'f', emoji_order: '2408' },
  { name: 'flag-tf', unicode: '🇹🇫', shortname: ':flag-tf:', category: 'f', emoji_order: '2409' },
  { name: 'flag-tg', unicode: '🇹🇬', shortname: ':flag-tg:', category: 'f', emoji_order: '2410' },
  { name: 'flag-th', unicode: '🇹🇭', shortname: ':flag-th:', category: 'f', emoji_order: '2411' },
  { name: 'flag-tj', unicode: '🇹🇯', shortname: ':flag-tj:', category: 'f', emoji_order: '2412' },
  { name: 'flag-tk', unicode: '🇹🇰', shortname: ':flag-tk:', category: 'f', emoji_order: '2413' },
  { name: 'flag-tl', unicode: '🇹🇱', shortname: ':flag-tl:', category: 'f', emoji_order: '2414' },
  { name: 'flag-tm', unicode: '🇹🇲', shortname: ':flag-tm:', category: 'f', emoji_order: '2415' },
  { name: 'flag-tn', unicode: '🇹🇳', shortname: ':flag-tn:', category: 'f', emoji_order: '2416' },
  { name: 'flag-to', unicode: '🇹🇴', shortname: ':flag-to:', category: 'f', emoji_order: '2417' },
  { name: 'flag-tr', unicode: '🇹🇷', shortname: ':flag-tr:', category: 'f', emoji_order: '2418' },
  { name: 'flag-tt', unicode: '🇹🇹', shortname: ':flag-tt:', category: 'f', emoji_order: '2419' },
  { name: 'flag-tv', unicode: '🇹🇻', shortname: ':flag-tv:', category: 'f', emoji_order: '2420' },
  { name: 'flag-tw', unicode: '🇹🇼', shortname: ':flag-tw:', category: 'f', emoji_order: '2421' },
  { name: 'flag-tz', unicode: '🇹🇿', shortname: ':flag-tz:', category: 'f', emoji_order: '2422' },
  { name: 'flag-ua', unicode: '🇺🇦', shortname: ':flag-ua:', category: 'f', emoji_order: '2423' },
  { name: 'flag-ug', unicode: '🇺🇬', shortname: ':flag-ug:', category: 'f', emoji_order: '2424' },
  { name: 'flag-um', unicode: '🇺🇲', shortname: ':flag-um:', category: 'f', emoji_order: '2425' },
  { name: 'flag-us', unicode: '🇺🇸', shortname: ':flag-us:', category: 'f', emoji_order: '2427' },
  { name: 'flag-uy', unicode: '🇺🇾', shortname: ':flag-uy:', category: 'f', emoji_order: '2428' },
  { name: 'flag-uz', unicode: '🇺🇿', shortname: ':flag-uz:', category: 'f', emoji_order: '2429' },
  { name: 'flag-va', unicode: '🇻🇦', shortname: ':flag-va:', category: 'f', emoji_order: '2430' },
  { name: 'flag-vc', unicode: '🇻🇨', shortname: ':flag-vc:', category: 'f', emoji_order: '2431' },
  { name: 'flag-ve', unicode: '🇻🇪', shortname: ':flag-ve:', category: 'f', emoji_order: '2432' },
  { name: 'flag-vg', unicode: '🇻🇬', shortname: ':flag-vg:', category: 'f', emoji_order: '2433' },
  { name: 'flag-vi', unicode: '🇻🇮', shortname: ':flag-vi:', category: 'f', emoji_order: '2434' },
  { name: 'flag-vn', unicode: '🇻🇳', shortname: ':flag-vn:', category: 'f', emoji_order: '2435' },
  { name: 'flag-vu', unicode: '🇻🇺', shortname: ':flag_vu:', category: 'f', emoji_order: '2436' },
  { name: 'flag-wf', unicode: '🇼🇫', shortname: ':flag_wf:', category: 'f', emoji_order: '2437' },
  { name: 'flag-ws', unicode: '🇼🇸', shortname: ':flag_ws:', category: 'f', emoji_order: '2438' },
  { name: 'flag-xk', unicode: '🇽🇰', shortname: ':flag_xk:', category: 'f', emoji_order: '2439' },
  { name: 'flag-ye', unicode: '🇾🇪', shortname: ':flag_ye:', category: 'f', emoji_order: '2440' },
  { name: 'flag-yt', unicode: '🇾🇹', shortname: ':flag_yt:', category: 'f', emoji_order: '2441' },
  { name: 'flag-za', unicode: '🇿🇦', shortname: ':flag_za:', category: 'f', emoji_order: '2442' },
  { name: 'flag-zm', unicode: '🇿🇲', shortname: ':flag_zm:', category: 'f', emoji_order: '2443' },
  { name: 'flag-zw', unicode: '🇿🇼', shortname: ':flag_zw:', category: 'f', emoji_order: '2444' },
  { name: 'speech', unicode: '😀', shortname: ':speech:', category: 'p', emoji_order: '1' },
];
var a = {};
r.forEach(function (e) {
  (e.shortname = ':{emojiListObject.name}:'), (a[e.name] = e);
});
const n = a,
  t = ((i = { default: () => Quill }), (c = {}), o.d(c, i), c);
var i, c;
function m(e, o) {
  (null == o || o > e.length) && (o = e.length);
  for (var r = 0, a = Array(o); r < o; r++) a[r] = e[r];
  return a;
}
function s(e) {
  return (
    (s =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
              ? 'symbol'
              : typeof e;
          }),
    s(e)
  );
}
function d() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (e) {}
  return (d = function () {
    return !!e;
  })();
}
function u() {
  return (
    (u =
      'undefined' != typeof Reflect && Reflect.get
        ? Reflect.get.bind()
        : function (e, o, r) {
            var a = (function (e, o) {
              for (; !{}.hasOwnProperty.call(e, o) && null !== (e = g(e)); );
              return e;
            })(e, o);
            if (a) {
              var n = Object.getOwnPropertyDescriptor(a, o);
              return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
            }
          }),
    u.apply(null, arguments)
  );
}
function g(e) {
  return (
    (g = Object.setPrototypeOf
      ? Object.getPrototypeOf.bind()
      : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }),
    g(e)
  );
}
function _(e, o) {
  return (
    (_ = Object.setPrototypeOf
      ? Object.setPrototypeOf.bind()
      : function (e, o) {
          return (e.__proto__ = o), e;
        }),
    _(e, o)
  );
}
function h(e, o, r) {
  return (
    (o = l(o)) in e
      ? Object.defineProperty(e, o, { value: r, enumerable: !0, configurable: !0, writable: !0 })
      : (e[o] = r),
    e
  );
}
function l(e) {
  var o = (function (e) {
    if ('object' != s(e) || !e) return e;
    var o = e[Symbol.toPrimitive];
    if (void 0 !== o) {
      var r = o.call(e, 'string');
      if ('object' != s(r)) return r;
      throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return String(e);
  })(e);
  return 'symbol' == s(o) ? o : o + '';
}
var y = t.default.import('blots/embed'),
  f = (function () {
    function e() {
      return (
        (function (e, o) {
          if (!(e instanceof o)) throw new TypeError('Cannot call a class as a function');
        })(this, e),
        (function (e, o, r) {
          return (
            (o = g(o)),
            (function (e, o) {
              if (o && ('object' == s(o) || 'function' == typeof o)) return o;
              if (void 0 !== o) throw new TypeError('Derived constructors may only return object or undefined');
              return (function (e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              })(e);
            })(e, d() ? Reflect.construct(o, r || [], g(e).constructor) : o.apply(e, r))
          );
        })(this, e, arguments)
      );
    }
    return (
      (function (e, o) {
        if ('function' != typeof o && null !== o)
          throw new TypeError('Super expression must either be null or a function');
        (e.prototype = Object.create(o && o.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })),
          Object.defineProperty(e, 'prototype', { writable: !1 }),
          o && _(e, o);
      })(e, y),
      (o = e),
      (r = [
        {
          key: 'create',
          value: function (o) {
            var r,
              a,
              t = ((r = this),
              'function' == typeof (a = u(g(e), 'create', r))
                ? function (e) {
                    return a.apply(r, e);
                  }
                : a)([]);
            if ('object' === s(o)) e.buildSpan(o, t);
            else if ('string' == typeof o) {
              var i = n[o];
              i && e.buildSpan(i, t);
            }
            return t;
          },
        },
        {
          key: 'value',
          value: function (e) {
            return e.dataset.name;
          },
        },
        {
          key: 'buildSpan',
          value: function (o, r) {
            r.setAttribute('data-name', o.name);
            var a,
              n = document.createElement('span');
            n.classList.add(this.emojiClass),
              n.classList.add(this.emojiPrefix + o.name),
              (n.innerText = String.fromCodePoint.apply(
                String,
                (function (e) {
                  if (Array.isArray(e)) return m(e);
                })((a = e.parseUnicode(o.unicode))) ||
                  (function (e) {
                    if (('undefined' != typeof Symbol && null != e[Symbol.iterator]) || null != e['@@iterator'])
                      return Array.from(e);
                  })(a) ||
                  (function (e, o) {
                    if (e) {
                      if ('string' == typeof e) return m(e, o);
                      var r = {}.toString.call(e).slice(8, -1);
                      return (
                        'Object' === r && e.constructor && (r = e.constructor.name),
                        'Map' === r || 'Set' === r
                          ? Array.from(e)
                          : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                            ? m(e, o)
                            : void 0
                      );
                    }
                  })(a) ||
                  (function () {
                    throw new TypeError(
                      'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
                    );
                  })(),
              )),
              r.appendChild(n);
          },
        },
        {
          key: 'parseUnicode',
          value: function (e) {
            return e.split('-').map(function (e) {
              return parseInt(e, 16);
            });
          },
        },
      ]),
      r &&
        (function (e, o) {
          for (var r = 0; r < o.length; r++) {
            var a = o[r];
            (a.enumerable = a.enumerable || !1),
              (a.configurable = !0),
              'value' in a && (a.writable = !0),
              Object.defineProperty(e, l(a.key), a);
          }
        })(o, r),
      Object.defineProperty(o, 'prototype', { writable: !1 }),
      o
    );
    var o, r;
  })();
h(f, 'blotName', 'emoji'),
  h(f, 'className', 'ql-emojiblot'),
  h(f, 'tagName', 'span'),
  h(f, 'emojiClass', 'ap'),
  h(f, 'emojiPrefix', 'ap-');
const j = f;
function p(e) {
  return Array.isArray ? Array.isArray(e) : '[object Array]' === C(e);
}
function b(e) {
  return 'string' == typeof e;
}
function w(e) {
  return 'number' == typeof e;
}
function k(e) {
  return 'object' == typeof e;
}
function v(e) {
  return null != e;
}
function x(e) {
  return !e.trim().length;
}
function C(e) {
  return null == e ? (void 0 === e ? '[object Undefined]' : '[object Null]') : Object.prototype.toString.call(e);
}
const E = Object.prototype.hasOwnProperty;
class A {
  constructor(e) {
    (this._keys = []), (this._keyMap = {});
    let o = 0;
    e.forEach(e => {
      let r = q(e);
      this._keys.push(r), (this._keyMap[r.id] = r), (o += r.weight);
    }),
      this._keys.forEach(e => {
        e.weight /= o;
      });
  }
  get(e) {
    return this._keyMap[e];
  }
  keys() {
    return this._keys;
  }
  toJSON() {
    return JSON.stringify(this._keys);
  }
}
function q(e) {
  let o = null,
    r = null,
    a = null,
    n = 1,
    t = null;
  if (b(e) || p(e)) (a = e), (o = S(e)), (r = B(e));
  else {
    if (!E.call(e, 'name')) throw new Error('Missing name property in key');
    const i = e.name;
    if (((a = i), E.call(e, 'weight') && ((n = e.weight), n <= 0)))
      throw new Error((e => `Property 'weight' in key '${e}' must be a positive integer`)(i));
    (o = S(i)), (r = B(i)), (t = e.getFn);
  }
  return { path: o, id: r, weight: n, src: a, getFn: t };
}
function S(e) {
  return p(e) ? e : e.split('.');
}
function B(e) {
  return p(e) ? e.join('.') : e;
}
var M = {
  isCaseSensitive: !1,
  ignoreDiacritics: !1,
  includeScore: !1,
  keys: [],
  shouldSort: !0,
  sortFn: (e, o) => (e.score === o.score ? (e.idx < o.idx ? -1 : 1) : e.score < o.score ? -1 : 1),
  includeMatches: !1,
  findAllMatches: !1,
  minMatchCharLength: 1,
  location: 0,
  threshold: 0.6,
  distance: 100,
  useExtendedSearch: !1,
  getFn: function (e, o) {
    let r = [],
      a = !1;
    const n = (e, o, t) => {
      if (v(e))
        if (o[t]) {
          const i = e[o[t]];
          if (!v(i)) return;
          if (
            t === o.length - 1 &&
            (b(i) ||
              w(i) ||
              (function (e) {
                return (
                  !0 === e ||
                  !1 === e ||
                  ((function (e) {
                    return k(e) && null !== e;
                  })(e) &&
                    '[object Boolean]' == C(e))
                );
              })(i))
          )
            r.push(
              (function (e) {
                return null == e
                  ? ''
                  : (function (e) {
                      if ('string' == typeof e) return e;
                      let o = e + '';
                      return '0' == o && 1 / e == -1 / 0 ? '-0' : o;
                    })(e);
              })(i),
            );
          else if (p(i)) {
            a = !0;
            for (let e = 0, r = i.length; e < r; e += 1) n(i[e], o, t + 1);
          } else o.length && n(i, o, t + 1);
        } else r.push(e);
    };
    return n(e, b(o) ? o.split('.') : o, 0), a ? r : r[0];
  },
  ignoreLocation: !1,
  ignoreFieldNorm: !1,
  fieldNormWeight: 1,
};
const L = /[^ ]+/g;
class D {
  constructor({ getFn: e = M.getFn, fieldNormWeight: o = M.fieldNormWeight } = {}) {
    (this.norm = (function (e = 1, o = 3) {
      const r = new Map(),
        a = Math.pow(10, o);
      return {
        get(o) {
          const n = o.match(L).length;
          if (r.has(n)) return r.get(n);
          const t = 1 / Math.pow(n, 0.5 * e),
            i = parseFloat(Math.round(t * a) / a);
          return r.set(n, i), i;
        },
        clear() {
          r.clear();
        },
      };
    })(o, 3)),
      (this.getFn = e),
      (this.isCreated = !1),
      this.setIndexRecords();
  }
  setSources(e = []) {
    this.docs = e;
  }
  setIndexRecords(e = []) {
    this.records = e;
  }
  setKeys(e = []) {
    (this.keys = e),
      (this._keysMap = {}),
      e.forEach((e, o) => {
        this._keysMap[e.id] = o;
      });
  }
  create() {
    !this.isCreated &&
      this.docs.length &&
      ((this.isCreated = !0),
      b(this.docs[0])
        ? this.docs.forEach((e, o) => {
            this._addString(e, o);
          })
        : this.docs.forEach((e, o) => {
            this._addObject(e, o);
          }),
      this.norm.clear());
  }
  add(e) {
    const o = this.size();
    b(e) ? this._addString(e, o) : this._addObject(e, o);
  }
  removeAt(e) {
    this.records.splice(e, 1);
    for (let o = e, r = this.size(); o < r; o += 1) this.records[o].i -= 1;
  }
  getValueForItemAtKeyId(e, o) {
    return e[this._keysMap[o]];
  }
  size() {
    return this.records.length;
  }
  _addString(e, o) {
    if (!v(e) || x(e)) return;
    let r = { v: e, i: o, n: this.norm.get(e) };
    this.records.push(r);
  }
  _addObject(e, o) {
    let r = { i: o, $: {} };
    this.keys.forEach((o, a) => {
      let n = o.getFn ? o.getFn(e) : this.getFn(e, o.path);
      if (v(n))
        if (p(n)) {
          let e = [];
          const o = [{ nestedArrIndex: -1, value: n }];
          for (; o.length; ) {
            const { nestedArrIndex: r, value: a } = o.pop();
            if (v(a))
              if (b(a) && !x(a)) {
                let o = { v: a, i: r, n: this.norm.get(a) };
                e.push(o);
              } else
                p(a) &&
                  a.forEach((e, r) => {
                    o.push({ nestedArrIndex: r, value: e });
                  });
          }
          r.$[a] = e;
        } else if (b(n) && !x(n)) {
          let e = { v: n, n: this.norm.get(n) };
          r.$[a] = e;
        }
    }),
      this.records.push(r);
  }
  toJSON() {
    return { keys: this.keys, records: this.records };
  }
}
function F(e, o, { getFn: r = M.getFn, fieldNormWeight: a = M.fieldNormWeight } = {}) {
  const n = new D({ getFn: r, fieldNormWeight: a });
  return n.setKeys(e.map(q)), n.setSources(o), n.create(), n;
}
function O(
  e,
  {
    errors: o = 0,
    currentLocation: r = 0,
    expectedLocation: a = 0,
    distance: n = M.distance,
    ignoreLocation: t = M.ignoreLocation,
  } = {},
) {
  const i = o / e.length;
  if (t) return i;
  const c = Math.abs(a - r);
  return n ? i + c / n : c ? 1 : i;
}
const z = 32;
function I(e) {
  let o = {};
  for (let r = 0, a = e.length; r < a; r += 1) {
    const n = e.charAt(r);
    o[n] = (o[n] || 0) | (1 << (a - r - 1));
  }
  return o;
}
const P = String.prototype.normalize
  ? e =>
      e
        .normalize('NFD')
        .replace(
          /[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]/g,
          '',
        )
  : e => e;
class T {
  constructor(
    e,
    {
      location: o = M.location,
      threshold: r = M.threshold,
      distance: a = M.distance,
      includeMatches: n = M.includeMatches,
      findAllMatches: t = M.findAllMatches,
      minMatchCharLength: i = M.minMatchCharLength,
      isCaseSensitive: c = M.isCaseSensitive,
      ignoreDiacritics: m = M.ignoreDiacritics,
      ignoreLocation: s = M.ignoreLocation,
    } = {},
  ) {
    if (
      ((this.options = {
        location: o,
        threshold: r,
        distance: a,
        includeMatches: n,
        findAllMatches: t,
        minMatchCharLength: i,
        isCaseSensitive: c,
        ignoreDiacritics: m,
        ignoreLocation: s,
      }),
      (e = c ? e : e.toLowerCase()),
      (e = m ? P(e) : e),
      (this.pattern = e),
      (this.chunks = []),
      !this.pattern.length)
    )
      return;
    const d = (e, o) => {
        this.chunks.push({ pattern: e, alphabet: I(e), startIndex: o });
      },
      u = this.pattern.length;
    if (u > z) {
      let e = 0;
      const o = u % z,
        r = u - o;
      for (; e < r; ) d(this.pattern.substr(e, z), e), (e += z);
      if (o) {
        const e = u - z;
        d(this.pattern.substr(e), e);
      }
    } else d(this.pattern, 0);
  }
  searchIn(e) {
    const { isCaseSensitive: o, ignoreDiacritics: r, includeMatches: a } = this.options;
    if (((e = o ? e : e.toLowerCase()), (e = r ? P(e) : e), this.pattern === e)) {
      let o = { isMatch: !0, score: 0 };
      return a && (o.indices = [[0, e.length - 1]]), o;
    }
    const {
      location: n,
      distance: t,
      threshold: i,
      findAllMatches: c,
      minMatchCharLength: m,
      ignoreLocation: s,
    } = this.options;
    let d = [],
      u = 0,
      g = !1;
    this.chunks.forEach(({ pattern: o, alphabet: r, startIndex: _ }) => {
      const {
        isMatch: h,
        score: l,
        indices: y,
      } = (function (
        e,
        o,
        r,
        {
          location: a = M.location,
          distance: n = M.distance,
          threshold: t = M.threshold,
          findAllMatches: i = M.findAllMatches,
          minMatchCharLength: c = M.minMatchCharLength,
          includeMatches: m = M.includeMatches,
          ignoreLocation: s = M.ignoreLocation,
        } = {},
      ) {
        if (o.length > z) throw new Error('Pattern length exceeds max of 32.');
        const d = o.length,
          u = e.length,
          g = Math.max(0, Math.min(a, u));
        let _ = t,
          h = g;
        const l = c > 1 || m,
          y = l ? Array(u) : [];
        let f;
        for (; (f = e.indexOf(o, h)) > -1; ) {
          let e = O(o, { currentLocation: f, expectedLocation: g, distance: n, ignoreLocation: s });
          if (((_ = Math.min(e, _)), (h = f + d), l)) {
            let e = 0;
            for (; e < d; ) (y[f + e] = 1), (e += 1);
          }
        }
        h = -1;
        let j = [],
          p = 1,
          b = d + u;
        const w = 1 << (d - 1);
        for (let a = 0; a < d; a += 1) {
          let t = 0,
            c = b;
          for (; t < c; )
            O(o, { errors: a, currentLocation: g + c, expectedLocation: g, distance: n, ignoreLocation: s }) <= _
              ? (t = c)
              : (b = c),
              (c = Math.floor((b - t) / 2 + t));
          b = c;
          let m = Math.max(1, g - c + 1),
            f = i ? u : Math.min(g + c, u) + d,
            k = Array(f + 2);
          k[f + 1] = (1 << a) - 1;
          for (let t = f; t >= m; t -= 1) {
            let i = t - 1,
              c = r[e.charAt(i)];
            if (
              (l && (y[i] = +!!c),
              (k[t] = ((k[t + 1] << 1) | 1) & c),
              a && (k[t] |= ((j[t + 1] | j[t]) << 1) | 1 | j[t + 1]),
              k[t] & w &&
                ((p = O(o, { errors: a, currentLocation: i, expectedLocation: g, distance: n, ignoreLocation: s })),
                p <= _))
            ) {
              if (((_ = p), (h = i), h <= g)) break;
              m = Math.max(1, 2 * g - h);
            }
          }
          if (O(o, { errors: a + 1, currentLocation: g, expectedLocation: g, distance: n, ignoreLocation: s }) > _)
            break;
          j = k;
        }
        const k = { isMatch: h >= 0, score: Math.max(0.001, p) };
        if (l) {
          const e = (function (e = [], o = M.minMatchCharLength) {
            let r = [],
              a = -1,
              n = -1,
              t = 0;
            for (let i = e.length; t < i; t += 1) {
              let i = e[t];
              i && -1 === a ? (a = t) : i || -1 === a || ((n = t - 1), n - a + 1 >= o && r.push([a, n]), (a = -1));
            }
            return e[t - 1] && t - a >= o && r.push([a, t - 1]), r;
          })(y, c);
          e.length ? m && (k.indices = e) : (k.isMatch = !1);
        }
        return k;
      })(e, o, r, {
        location: n + _,
        distance: t,
        threshold: i,
        findAllMatches: c,
        minMatchCharLength: m,
        includeMatches: a,
        ignoreLocation: s,
      });
      h && (g = !0), (u += l), h && y && (d = [...d, ...y]);
    });
    let _ = { isMatch: g, score: g ? u / this.chunks.length : 1 };
    return g && a && (_.indices = d), _;
  }
}
class R {
  constructor(e) {
    this.pattern = e;
  }
  static isMultiMatch(e) {
    return N(e, this.multiRegex);
  }
  static isSingleMatch(e) {
    return N(e, this.singleRegex);
  }
  search() {}
}
function N(e, o) {
  const r = e.match(o);
  return r ? r[1] : null;
}
class $ extends R {
  constructor(
    e,
    {
      location: o = M.location,
      threshold: r = M.threshold,
      distance: a = M.distance,
      includeMatches: n = M.includeMatches,
      findAllMatches: t = M.findAllMatches,
      minMatchCharLength: i = M.minMatchCharLength,
      isCaseSensitive: c = M.isCaseSensitive,
      ignoreDiacritics: m = M.ignoreDiacritics,
      ignoreLocation: s = M.ignoreLocation,
    } = {},
  ) {
    super(e),
      (this._bitapSearch = new T(e, {
        location: o,
        threshold: r,
        distance: a,
        includeMatches: n,
        findAllMatches: t,
        minMatchCharLength: i,
        isCaseSensitive: c,
        ignoreDiacritics: m,
        ignoreLocation: s,
      }));
  }
  static get type() {
    return 'fuzzy';
  }
  static get multiRegex() {
    return /^"(.*)"$/;
  }
  static get singleRegex() {
    return /^(.*)$/;
  }
  search(e) {
    return this._bitapSearch.searchIn(e);
  }
}
class W extends R {
  constructor(e) {
    super(e);
  }
  static get type() {
    return 'include';
  }
  static get multiRegex() {
    return /^'"(.*)"$/;
  }
  static get singleRegex() {
    return /^'(.*)$/;
  }
  search(e) {
    let o,
      r = 0;
    const a = [],
      n = this.pattern.length;
    for (; (o = e.indexOf(this.pattern, r)) > -1; ) (r = o + n), a.push([o, r - 1]);
    const t = !!a.length;
    return { isMatch: t, score: t ? 0 : 1, indices: a };
  }
}
const H = [
    class extends R {
      constructor(e) {
        super(e);
      }
      static get type() {
        return 'exact';
      }
      static get multiRegex() {
        return /^="(.*)"$/;
      }
      static get singleRegex() {
        return /^=(.*)$/;
      }
      search(e) {
        const o = e === this.pattern;
        return { isMatch: o, score: o ? 0 : 1, indices: [0, this.pattern.length - 1] };
      }
    },
    W,
    class extends R {
      constructor(e) {
        super(e);
      }
      static get type() {
        return 'prefix-exact';
      }
      static get multiRegex() {
        return /^\^"(.*)"$/;
      }
      static get singleRegex() {
        return /^\^(.*)$/;
      }
      search(e) {
        const o = e.startsWith(this.pattern);
        return { isMatch: o, score: o ? 0 : 1, indices: [0, this.pattern.length - 1] };
      }
    },
    class extends R {
      constructor(e) {
        super(e);
      }
      static get type() {
        return 'inverse-prefix-exact';
      }
      static get multiRegex() {
        return /^!\^"(.*)"$/;
      }
      static get singleRegex() {
        return /^!\^(.*)$/;
      }
      search(e) {
        const o = !e.startsWith(this.pattern);
        return { isMatch: o, score: o ? 0 : 1, indices: [0, e.length - 1] };
      }
    },
    class extends R {
      constructor(e) {
        super(e);
      }
      static get type() {
        return 'inverse-suffix-exact';
      }
      static get multiRegex() {
        return /^!"(.*)"\$$/;
      }
      static get singleRegex() {
        return /^!(.*)\$$/;
      }
      search(e) {
        const o = !e.endsWith(this.pattern);
        return { isMatch: o, score: o ? 0 : 1, indices: [0, e.length - 1] };
      }
    },
    class extends R {
      constructor(e) {
        super(e);
      }
      static get type() {
        return 'suffix-exact';
      }
      static get multiRegex() {
        return /^"(.*)"\$$/;
      }
      static get singleRegex() {
        return /^(.*)\$$/;
      }
      search(e) {
        const o = e.endsWith(this.pattern);
        return { isMatch: o, score: o ? 0 : 1, indices: [e.length - this.pattern.length, e.length - 1] };
      }
    },
    class extends R {
      constructor(e) {
        super(e);
      }
      static get type() {
        return 'inverse-exact';
      }
      static get multiRegex() {
        return /^!"(.*)"$/;
      }
      static get singleRegex() {
        return /^!(.*)$/;
      }
      search(e) {
        const o = -1 === e.indexOf(this.pattern);
        return { isMatch: o, score: o ? 0 : 1, indices: [0, e.length - 1] };
      }
    },
    $,
  ],
  U = H.length,
  K = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/,
  J = new Set([$.type, W.type]),
  V = [];
function Z(e, o) {
  for (let r = 0, a = V.length; r < a; r += 1) {
    let a = V[r];
    if (a.condition(e, o)) return new a(e, o);
  }
  return new T(e, o);
}
const Q = '$and',
  G = '$path',
  X = e => !(!e[Q] && !e.$or),
  Y = e => ({ [Q]: Object.keys(e).map(o => ({ [o]: e[o] })) });
function ee(e, o, { auto: r = !0 } = {}) {
  const a = e => {
    let n = Object.keys(e);
    const t = (e => !!e[G])(e);
    if (!t && n.length > 1 && !X(e)) return a(Y(e));
    if ((e => !p(e) && k(e) && !X(e))(e)) {
      const a = t ? e[G] : n[0],
        i = t ? e.$val : e[a];
      if (!b(i)) throw new Error((e => `Invalid value for key ${e}`)(a));
      const c = { keyId: B(a), pattern: i };
      return r && (c.searcher = Z(i, o)), c;
    }
    let i = { children: [], operator: n[0] };
    return (
      n.forEach(o => {
        const r = e[o];
        p(r) &&
          r.forEach(e => {
            i.children.push(a(e));
          });
      }),
      i
    );
  };
  return X(e) || (e = Y(e)), a(e);
}
function oe(e, o) {
  const r = e.matches;
  (o.matches = []),
    v(r) &&
      r.forEach(e => {
        if (!v(e.indices) || !e.indices.length) return;
        const { indices: r, value: a } = e;
        let n = { indices: r, value: a };
        e.key && (n.key = e.key.src), e.idx > -1 && (n.refIndex = e.idx), o.matches.push(n);
      });
}
function re(e, o) {
  o.score = e.score;
}
class ae {
  constructor(e, o = {}, r) {
    (this.options = { ...M, ...o }),
      this.options.useExtendedSearch,
      (this._keyStore = new A(this.options.keys)),
      this.setCollection(e, r);
  }
  setCollection(e, o) {
    if (((this._docs = e), o && !(o instanceof D))) throw new Error("Incorrect 'index' type");
    this._myIndex =
      o ||
      F(this.options.keys, this._docs, { getFn: this.options.getFn, fieldNormWeight: this.options.fieldNormWeight });
  }
  add(e) {
    v(e) && (this._docs.push(e), this._myIndex.add(e));
  }
  remove(e = () => !1) {
    const o = [];
    for (let r = 0, a = this._docs.length; r < a; r += 1) {
      const n = this._docs[r];
      e(n, r) && (this.removeAt(r), (r -= 1), (a -= 1), o.push(n));
    }
    return o;
  }
  removeAt(e) {
    this._docs.splice(e, 1), this._myIndex.removeAt(e);
  }
  getIndex() {
    return this._myIndex;
  }
  search(e, { limit: o = -1 } = {}) {
    const { includeMatches: r, includeScore: a, shouldSort: n, sortFn: t, ignoreFieldNorm: i } = this.options;
    let c = b(e) ? (b(this._docs[0]) ? this._searchStringList(e) : this._searchObjectList(e)) : this._searchLogical(e);
    return (
      (function (e, { ignoreFieldNorm: o = M.ignoreFieldNorm }) {
        e.forEach(e => {
          let r = 1;
          e.matches.forEach(({ key: e, norm: a, score: n }) => {
            const t = e ? e.weight : null;
            r *= Math.pow(0 === n && t ? Number.EPSILON : n, (t || 1) * (o ? 1 : a));
          }),
            (e.score = r);
        });
      })(c, { ignoreFieldNorm: i }),
      n && c.sort(t),
      w(o) && o > -1 && (c = c.slice(0, o)),
      (function (e, o, { includeMatches: r = M.includeMatches, includeScore: a = M.includeScore } = {}) {
        const n = [];
        return (
          r && n.push(oe),
          a && n.push(re),
          e.map(e => {
            const { idx: r } = e,
              a = { item: o[r], refIndex: r };
            return (
              n.length &&
                n.forEach(o => {
                  o(e, a);
                }),
              a
            );
          })
        );
      })(c, this._docs, { includeMatches: r, includeScore: a })
    );
  }
  _searchStringList(e) {
    const o = Z(e, this.options),
      { records: r } = this._myIndex,
      a = [];
    return (
      r.forEach(({ v: e, i: r, n }) => {
        if (!v(e)) return;
        const { isMatch: t, score: i, indices: c } = o.searchIn(e);
        t && a.push({ item: e, idx: r, matches: [{ score: i, value: e, norm: n, indices: c }] });
      }),
      a
    );
  }
  _searchLogical(e) {
    const o = ee(e, this.options),
      r = (e, o, a) => {
        if (!e.children) {
          const { keyId: r, searcher: n } = e,
            t = this._findMatches({
              key: this._keyStore.get(r),
              value: this._myIndex.getValueForItemAtKeyId(o, r),
              searcher: n,
            });
          return t && t.length ? [{ idx: a, item: o, matches: t }] : [];
        }
        const n = [];
        for (let t = 0, i = e.children.length; t < i; t += 1) {
          const i = e.children[t],
            c = r(i, o, a);
          if (c.length) n.push(...c);
          else if (e.operator === Q) return [];
        }
        return n;
      },
      a = this._myIndex.records,
      n = {},
      t = [];
    return (
      a.forEach(({ $: e, i: a }) => {
        if (v(e)) {
          let i = r(o, e, a);
          i.length &&
            (n[a] || ((n[a] = { idx: a, item: e, matches: [] }), t.push(n[a])),
            i.forEach(({ matches: e }) => {
              n[a].matches.push(...e);
            }));
        }
      }),
      t
    );
  }
  _searchObjectList(e) {
    const o = Z(e, this.options),
      { keys: r, records: a } = this._myIndex,
      n = [];
    return (
      a.forEach(({ $: e, i: a }) => {
        if (!v(e)) return;
        let t = [];
        r.forEach((r, a) => {
          t.push(...this._findMatches({ key: r, value: e[a], searcher: o }));
        }),
          t.length && n.push({ idx: a, item: e, matches: t });
      }),
      n
    );
  }
  _findMatches({ key: e, value: o, searcher: r }) {
    if (!v(o)) return [];
    let a = [];
    if (p(o))
      o.forEach(({ v: o, i: n, n: t }) => {
        if (!v(o)) return;
        const { isMatch: i, score: c, indices: m } = r.searchIn(o);
        i && a.push({ score: c, key: e, value: o, idx: n, norm: t, indices: m });
      });
    else {
      const { v: n, n: t } = o,
        { isMatch: i, score: c, indices: m } = r.searchIn(n);
      i && a.push({ score: c, key: e, value: n, norm: t, indices: m });
    }
    return a;
  }
}
function ne(e) {
  return (
    (ne =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
              ? 'symbol'
              : typeof e;
          }),
    ne(e)
  );
}
function te(e) {
  var o = (function (e) {
    if ('object' != ne(e) || !e) return e;
    var o = e[Symbol.toPrimitive];
    if (void 0 !== o) {
      var r = o.call(e, 'string');
      if ('object' != ne(r)) return r;
      throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return String(e);
  })(e);
  return 'symbol' == ne(o) ? o : o + '';
}
function ie() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (e) {}
  return (ie = function () {
    return !!e;
  })();
}
function ce(e) {
  return (
    (ce = Object.setPrototypeOf
      ? Object.getPrototypeOf.bind()
      : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }),
    ce(e)
  );
}
function me(e, o) {
  return (
    (me = Object.setPrototypeOf
      ? Object.setPrototypeOf.bind()
      : function (e, o) {
          return (e.__proto__ = o), e;
        }),
    me(e, o)
  );
}
(ae.version = '7.1.0'),
  (ae.createIndex = F),
  (ae.parseIndex = function (e, { getFn: o = M.getFn, fieldNormWeight: r = M.fieldNormWeight } = {}) {
    const { keys: a, records: n } = e,
      t = new D({ getFn: o, fieldNormWeight: r });
    return t.setKeys(a), t.setIndexRecords(n), t;
  }),
  (ae.config = M),
  (ae.parseQuery = ee),
  (function (...e) {
    V.push(...e);
  })(
    class {
      constructor(
        e,
        {
          isCaseSensitive: o = M.isCaseSensitive,
          ignoreDiacritics: r = M.ignoreDiacritics,
          includeMatches: a = M.includeMatches,
          minMatchCharLength: n = M.minMatchCharLength,
          ignoreLocation: t = M.ignoreLocation,
          findAllMatches: i = M.findAllMatches,
          location: c = M.location,
          threshold: m = M.threshold,
          distance: s = M.distance,
        } = {},
      ) {
        (this.query = null),
          (this.options = {
            isCaseSensitive: o,
            ignoreDiacritics: r,
            includeMatches: a,
            minMatchCharLength: n,
            findAllMatches: i,
            ignoreLocation: t,
            location: c,
            threshold: m,
            distance: s,
          }),
          (e = o ? e : e.toLowerCase()),
          (e = r ? P(e) : e),
          (this.pattern = e),
          (this.query = (function (e, o = {}) {
            return e.split('|').map(e => {
              let r = e
                  .trim()
                  .split(K)
                  .filter(e => e && !!e.trim()),
                a = [];
              for (let e = 0, n = r.length; e < n; e += 1) {
                const n = r[e];
                let t = !1,
                  i = -1;
                for (; !t && ++i < U; ) {
                  const e = H[i];
                  let r = e.isMultiMatch(n);
                  r && (a.push(new e(r, o)), (t = !0));
                }
                if (!t)
                  for (i = -1; ++i < U; ) {
                    const e = H[i];
                    let r = e.isSingleMatch(n);
                    if (r) {
                      a.push(new e(r, o));
                      break;
                    }
                  }
              }
              return a;
            });
          })(this.pattern, this.options));
      }
      static condition(e, o) {
        return o.useExtendedSearch;
      }
      searchIn(e) {
        const o = this.query;
        if (!o) return { isMatch: !1, score: 1 };
        const { includeMatches: r, isCaseSensitive: a, ignoreDiacritics: n } = this.options;
        (e = a ? e : e.toLowerCase()), (e = n ? P(e) : e);
        let t = 0,
          i = [],
          c = 0;
        for (let a = 0, n = o.length; a < n; a += 1) {
          const n = o[a];
          (i.length = 0), (t = 0);
          for (let o = 0, a = n.length; o < a; o += 1) {
            const a = n[o],
              { isMatch: m, indices: s, score: d } = a.search(e);
            if (!m) {
              (c = 0), (t = 0), (i.length = 0);
              break;
            }
            if (((t += 1), (c += d), r)) {
              const e = a.constructor.type;
              J.has(e) ? (i = [...i, ...s]) : i.push(s);
            }
          }
          if (t) {
            let e = { isMatch: !0, score: c / t };
            return r && (e.indices = i), e;
          }
        }
        return { isMatch: !1, score: 1 };
      }
    },
  );
var se = t.default.import('core/module'),
  de = (function () {
    function e(o, r) {
      var a;
      return (
        (function (e, o) {
          if (!(e instanceof o)) throw new TypeError('Cannot call a class as a function');
        })(this, e),
        ((a = (function (e, o, r) {
          return (
            (o = ce(o)),
            (function (e, o) {
              if (o && ('object' == ne(o) || 'function' == typeof o)) return o;
              if (void 0 !== o) throw new TypeError('Derived constructors may only return object or undefined');
              return (function (e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              })(e);
            })(e, ie() ? Reflect.construct(o, r || [], ce(e).constructor) : o.apply(e, r))
          );
        })(this, e, [o, r])).emojiList = r.emojiList),
        (a.fuse = new ae(r.emojiList, r.fuse)),
        (a.quill = o),
        (a.onClose = r.onClose),
        (a.onOpen = r.onOpen),
        (a.container = document.createElement('ul')),
        a.container.classList.add('emoji_completions'),
        a.quill.container.appendChild(a.container),
        (a.container.style.position = 'absolute'),
        (a.container.style.display = 'none'),
        (a.onSelectionChange = a.maybeUnfocus.bind(a)),
        (a.onTextChange = a.update.bind(a)),
        (a.open = !1),
        (a.atIndex = null),
        (a.focusedButton = null),
        (a.isWhiteSpace = function (e) {
          var o = !1;
          return /\s/.test(e) && (o = !0), o;
        }),
        o.keyboard.addBinding({ key: 186, shiftKey: !0 }, a.triggerPicker.bind(a)),
        o.keyboard.addBinding({ key: 59, shiftKey: !0 }, a.triggerPicker.bind(a)),
        o.keyboard.addBinding({ key: 39, collapsed: !0 }, a.handleArrow.bind(a)),
        o.keyboard.addBinding({ key: 40, collapsed: !0 }, a.handleArrow.bind(a)),
        a
      );
    }
    return (
      (function (e, o) {
        if ('function' != typeof o && null !== o)
          throw new TypeError('Super expression must either be null or a function');
        (e.prototype = Object.create(o && o.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })),
          Object.defineProperty(e, 'prototype', { writable: !1 }),
          o && me(e, o);
      })(e, se),
      (o = e),
      (r = [
        {
          key: 'triggerPicker',
          value: function (e, o) {
            if (this.open) return !0;
            e.length > 0 && this.quill.deleteText(e.index, e.length, t.default.sources.USER),
              this.quill.insertText(e.index, ':', 'emoji-shortname', t.default.sources.USER);
            var r = this.quill.getBounds(e.index);
            this.quill.setSelection(e.index + 1, t.default.sources.SILENT),
              (this.atIndex = e.index),
              r.left + 250 > this.quill.container.offsetWidth
                ? (this.container.style.left = r.left - 250 + 'px')
                : (this.container.style.left = r.left + 'px'),
              (this.container.style.top = r.top + r.height + 'px'),
              (this.open = !0),
              this.quill.on('text-change', this.onTextChange),
              this.quill.once('selection-change', this.onSelectionChange),
              this.onOpen && this.onOpen();
          },
        },
        {
          key: 'handleArrow',
          value: function () {
            if (!this.open) return !0;
            this.buttons[0].classList.remove('emoji-active'),
              this.buttons[0].focus(),
              this.buttons.length > 1 && this.buttons[1].focus();
          },
        },
        {
          key: 'update',
          value: function () {
            var e = this.quill.getSelection().index;
            if (this.atIndex >= e) return this.close(null);
            this.query = this.quill.getText(this.atIndex + 1, e - this.atIndex - 1);
            try {
              if (event && this.isWhiteSpace(this.query)) return void this.close(null);
            } catch (e) {
              console.warn(e);
            }
            this.query = this.query.trim();
            var o = this.fuse.search(this.query);
            o.sort(function (e, o) {
              return e.emoji_order - o.emoji_order;
            }),
              this.query.length < this.options.fuse.minMatchCharLength || 0 === o.length
                ? (this.container.style.display = 'none')
                : (o.length > 15 && (o = o.slice(0, 15)), this.renderCompletions(o));
          },
        },
        {
          key: 'maybeUnfocus',
          value: function () {
            this.container.querySelector('*:focus') || this.close(null);
          },
        },
        {
          key: 'renderCompletions',
          value: function (e) {
            var o = this;
            try {
              if (event) {
                if ('Enter' === event.key || 13 === event.keyCode)
                  return this.close(e[0], 1), void (this.container.style.display = 'none');
                if ('Tab' === event.key || 9 === event.keyCode)
                  return (
                    this.quill.disable(), this.buttons[0].classList.remove('emoji-active'), void this.buttons[1].focus()
                  );
              }
            } catch (e) {
              console.warn(e);
            }
            for (; this.container.firstChild; ) this.container.removeChild(this.container.firstChild);
            var r = Array(e.length);
            if (
              ((this.buttons = r),
              e.forEach(function (e, a) {
                var n = ue(
                  'li',
                  {},
                  ue(
                    'button',
                    { type: 'button' },
                    ue('span', { className: 'button-emoji ap', innerHTML: e.unicode }),
                    ue('span', { className: 'unmatched' }, e.shortname),
                  ),
                );
                o.container.appendChild(n),
                  (r[a] = n.firstChild),
                  r[a].addEventListener(
                    'keydown',
                    (function (e, a) {
                      return function (n) {
                        if ('ArrowRight' === n.key || 39 === n.keyCode)
                          n.preventDefault(), r[Math.min(r.length - 1, e + 1)].focus();
                        else if ('Tab' === n.key || 9 === n.keyCode) {
                          if ((n.preventDefault(), e + 1 === r.length)) return void r[0].focus();
                          r[Math.min(r.length - 1, e + 1)].focus();
                        } else
                          'ArrowLeft' === n.key || 37 === n.keyCode
                            ? (n.preventDefault(), r[Math.max(0, e - 1)].focus())
                            : 'ArrowDown' === n.key || 40 === n.keyCode
                              ? (n.preventDefault(), r[Math.min(r.length - 1, e + 1)].focus())
                              : 'ArrowUp' === n.key || 38 === n.keyCode
                                ? (n.preventDefault(), r[Math.max(0, e - 1)].focus())
                                : ('Enter' !== n.key &&
                                    13 !== n.keyCode &&
                                    ' ' !== n.key &&
                                    32 !== n.keyCode &&
                                    'Tab' !== n.key &&
                                    9 !== n.keyCode) ||
                                  (n.preventDefault(), o.quill.enable(), o.close(a));
                      };
                    })(a, e),
                  ),
                  r[a].addEventListener('mousedown', function () {
                    return o.close(e);
                  }),
                  r[a].addEventListener('focus', function () {
                    return (o.focusedButton = a);
                  }),
                  r[a].addEventListener('unfocus', function () {
                    return (o.focusedButton = null);
                  });
              }),
              (this.container.style.display = 'block'),
              this.quill.container.classList.contains('top-emoji'))
            ) {
              var a,
                n = this.container.querySelectorAll('li');
              for (a = 0; a < n.length; a++) n[a].style.display = 'block';
              var t = window.innerHeight;
              this.quill.container.getBoundingClientRect().top > t / 2 &&
                this.container.offsetHeight > 0 &&
                (this.container.style.top = '-' + this.container.offsetHeight + 'px');
            }
            r[0].classList.add('emoji-active');
          },
        },
        {
          key: 'close',
          value: function (e) {
            var o = this,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
            for (this.quill.enable(), this.container.style.display = 'none'; this.container.firstChild; )
              this.container.removeChild(this.container.firstChild);
            this.quill.off('selection-change', this.onSelectionChange),
              this.quill.off('text-change', this.onTextChange),
              e &&
                (this.quill.deleteText(this.atIndex, this.query.length + 1 + r, t.default.sources.USER),
                this.quill.insertText(this.atIndex, e.unicode, t.default.sources.USER),
                setTimeout(function () {
                  return o.quill.setSelection(o.atIndex + 1);
                }, 0)),
              this.quill.focus(),
              (this.open = !1),
              this.onClose && this.onClose(e);
          },
        },
      ]),
      r &&
        (function (e, o) {
          for (var r = 0; r < o.length; r++) {
            var a = o[r];
            (a.enumerable = a.enumerable || !1),
              (a.configurable = !0),
              'value' in a && (a.writable = !0),
              Object.defineProperty(e, te(a.key), a);
          }
        })(o.prototype, r),
      Object.defineProperty(o, 'prototype', { writable: !1 }),
      o
    );
    var o, r;
  })();
function ue(e, o) {
  var r = document.createElement(e);
  Object.keys(o).forEach(function (e) {
    return (r[e] = o[e]);
  });
  for (var a = arguments.length, n = new Array(a > 2 ? a - 2 : 0), t = 2; t < a; t++) n[t - 2] = arguments[t];
  return (
    n.forEach(function (e) {
      'string' == typeof e && (e = document.createTextNode(e)), r.appendChild(e);
    }),
    r
  );
}
de.DEFAULTS = {
  emojiList: r,
  fuse: {
    shouldSort: !0,
    threshold: 0.1,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 1,
    keys: ['shortname'],
  },
};
const ge = de;
function _e(e) {
  return (
    (_e =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
              ? 'symbol'
              : typeof e;
          }),
    _e(e)
  );
}
function he(e) {
  var o = (function (e) {
    if ('object' != _e(e) || !e) return e;
    var o = e[Symbol.toPrimitive];
    if (void 0 !== o) {
      var r = o.call(e, 'string');
      if ('object' != _e(r)) return r;
      throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return String(e);
  })(e);
  return 'symbol' == _e(o) ? o : o + '';
}
function le() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (e) {}
  return (le = function () {
    return !!e;
  })();
}
function ye(e) {
  return (
    (ye = Object.setPrototypeOf
      ? Object.getPrototypeOf.bind()
      : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }),
    ye(e)
  );
}
function fe(e, o) {
  return (
    (fe = Object.setPrototypeOf
      ? Object.setPrototypeOf.bind()
      : function (e, o) {
          return (e.__proto__ = o), e;
        }),
    fe(e, o)
  );
}
var je = t.default.import('core/module'),
  pe = (function () {
    function e(o, r) {
      var a;
      !(function (e, o) {
        if (!(e instanceof o)) throw new TypeError('Cannot call a class as a function');
      })(this, e),
        ((a = (function (e, o, r) {
          return (
            (o = ye(o)),
            (function (e, o) {
              if (o && ('object' == _e(o) || 'function' == typeof o)) return o;
              if (void 0 !== o) throw new TypeError('Derived constructors may only return object or undefined');
              return (function (e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              })(e);
            })(e, le() ? Reflect.construct(o, r || [], ye(e).constructor) : o.apply(e, r))
          );
        })(this, e, [o, r])).quill = o),
        (a.toolbar = o.getModule('toolbar')),
        void 0 !== a.toolbar && a.toolbar.addHandler('emoji', a.checkPaletteExists);
      var n = document.getElementsByClassName('ql-emoji');
      return (
        n &&
          [].slice.call(n).forEach(function (e) {
            e.innerHTML = r.buttonIcon;
          }),
        a
      );
    }
    return (
      (function (e, o) {
        if ('function' != typeof o && null !== o)
          throw new TypeError('Super expression must either be null or a function');
        (e.prototype = Object.create(o && o.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })),
          Object.defineProperty(e, 'prototype', { writable: !1 }),
          o && fe(e, o);
      })(e, je),
      (o = e),
      (r = [
        {
          key: 'checkPaletteExists',
          value: function () {
            var e, o;
            (e = this.quill),
              (o = document.getElementById('emoji-palette'))
                ? o.remove()
                : (function (e) {
                    var o = 250,
                      r = document.createElement('div'),
                      a = e.getSelection(),
                      n = e.getBounds(a.index),
                      t = e.container.getBoundingClientRect(),
                      i = (n.left + n.right) / 2,
                      c = (n.top + n.bottom) / 2,
                      m = t.left + i + o <= document.documentElement.clientWidth ? i : t.left - o,
                      s =
                        t.top + c + o + 10 <= document.documentElement.clientHeight
                          ? c + 10
                          : t.top + c - o - 10 >= 0
                            ? c - o - 10
                            : document.documentElement.clientHeight - o - t.top;
                    e.container.appendChild(r),
                      (r.id = 'emoji-palette'),
                      (r.style.left = ''.concat(m, 'px')),
                      (r.style.top = ''.concat(s, 'px'));
                    var d = document.createElement('div');
                    (d.id = 'tab-toolbar'), r.appendChild(d);
                    var u = document.createElement('div');
                    (u.id = 'tab-panel'), r.appendChild(u);
                    var g = document.createElement('ul');
                    if ((d.appendChild(g), null === document.getElementById('emoji-close-div'))) {
                      var _ = document.createElement('div');
                      (_.id = 'emoji-close-div'),
                        _.addEventListener('click', be, !1),
                        document.getElementsByTagName('body')[0].appendChild(_);
                    } else document.getElementById('emoji-close-div').style.display = 'block';
                    [
                      { type: 'p', name: 'people', content: '<div class="i-people"></div>' },
                      { type: 'n', name: 'nature', content: '<div class="i-nature"></div>' },
                      { type: 'd', name: 'food', content: '<div class="i-food"></div>' },
                      { type: 's', name: 'symbols', content: '<div class="i-symbols"></div>' },
                      { type: 'a', name: 'activity', content: '<div class="i-activity"></div>' },
                      { type: 't', name: 'travel', content: '<div class="i-travel"></div>' },
                      { type: 'o', name: 'objects', content: '<div class="i-objects"></div>' },
                      { type: 'f', name: 'flags', content: '<div class="i-flags"></div>' },
                    ].map(function (o) {
                      var r = document.createElement('li');
                      r.classList.add('emoji-tab'),
                        r.classList.add('filter-' + o.name),
                        (r.innerHTML = o.content),
                        (r.dataset.filter = o.type),
                        g.appendChild(r);
                      var a = document.querySelector('.filter-' + o.name);
                      a.addEventListener('click', function () {
                        var o = document.querySelector('.active');
                        o && o.classList.remove('active'),
                          a.classList.toggle('active'),
                          (function (e, o, r) {
                            for (; o.firstChild; ) o.removeChild(o.firstChild);
                            we(e.dataset.filter, o, r);
                          })(a, u, e);
                      });
                    }),
                      (function (e, o) {
                        we('p', e, o), document.querySelector('.filter-people').classList.add('active');
                      })(u, e);
                  })(e),
              this.quill.on('text-change', function (e, o, r) {
                'user' === r && be();
              });
          },
        },
      ]) &&
        (function (e, o) {
          for (var r = 0; r < o.length; r++) {
            var a = o[r];
            (a.enumerable = a.enumerable || !1),
              (a.configurable = !0),
              'value' in a && (a.writable = !0),
              Object.defineProperty(e, he(a.key), a);
          }
        })(o.prototype, r),
      Object.defineProperty(o, 'prototype', { writable: !1 }),
      o
    );
    var o, r;
  })();
function be() {
  var e = document.getElementById('emoji-palette');
  (document.getElementById('emoji-close-div').style.display = 'none'), e && e.remove();
}
function we(e, o, a) {
  var n = new ae(r, {
    shouldSort: !0,
    matchAllTokens: !0,
    threshold: 0.3,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 3,
    keys: ['category'],
  }).search(e);
  n.sort(function (e, o) {
    return e.item.emoji_order - o.item.emoji_order;
  }),
    a.focus(),
    n.map(function (e) {
      var r = e.item,
        n = document.createElement('span'),
        i = document.createTextNode(r.shortname);
      n.appendChild(i), n.classList.add('bem'), n.classList.add('bem-' + r.name), n.classList.add('ap');
      var c = '' + r.unicode;
      (n.innerHTML = c + ' '), o.appendChild(n);
      var m = document.querySelector('.bem-' + r.name);
      m &&
        m.addEventListener('click', function () {
          var e = a.getSelection(!0);
          !(function (e, o) {
            var r = document.createElement(e);
            Object.keys(o).forEach(function (e) {
              return (r[e] = o[e]);
            });
            for (var a = arguments.length, n = new Array(a > 2 ? a - 2 : 0), t = 2; t < a; t++) n[t - 2] = arguments[t];
            n.forEach(function (e) {
              'string' == typeof e && (e = document.createTextNode(e)), r.appendChild(e);
            });
          })('span', { className: 'ico', innerHTML: r.unicode + ' ' }),
            a.insertText(e.index, r.unicode, t.default.sources.USER),
            setTimeout(function () {
              return a.setSelection(e.index + 1);
            }, 0),
            be();
        });
    });
}
pe.DEFAULTS = {
  buttonIcon:
    '<svg viewbox="0 0 18 18"><circle class="ql-fill" cx="7" cy="7" r="1"></circle><circle class="ql-fill" cx="11" cy="7" r="1"></circle><path class="ql-stroke" d="M7,10a2,2,0,0,0,4,0H7Z"></path><circle class="ql-stroke" cx="9" cy="9" r="6"></circle></svg>',
};
const ke = pe;
function ve(e) {
  return (
    (ve =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
              ? 'symbol'
              : typeof e;
          }),
    ve(e)
  );
}
function xe(e) {
  var o = (function (e) {
    if ('object' != ve(e) || !e) return e;
    var o = e[Symbol.toPrimitive];
    if (void 0 !== o) {
      var r = o.call(e, 'string');
      if ('object' != ve(r)) return r;
      throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return String(e);
  })(e);
  return 'symbol' == ve(o) ? o : o + '';
}
function Ce() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (e) {}
  return (Ce = function () {
    return !!e;
  })();
}
function Ee(e) {
  return (
    (Ee = Object.setPrototypeOf
      ? Object.getPrototypeOf.bind()
      : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }),
    Ee(e)
  );
}
function Ae(e, o) {
  return (
    (Ae = Object.setPrototypeOf
      ? Object.setPrototypeOf.bind()
      : function (e, o) {
          return (e.__proto__ = o), e;
        }),
    Ae(e, o)
  );
}
var qe = t.default.import('core/module'),
  Se = (function () {
    function e(o, r) {
      var a;
      return (
        (function (e, o) {
          if (!(e instanceof o)) throw new TypeError('Cannot call a class as a function');
        })(this, e),
        ((a = (function (e, o, r) {
          return (
            (o = Ee(o)),
            (function (e, o) {
              if (o && ('object' == ve(o) || 'function' == typeof o)) return o;
              if (void 0 !== o) throw new TypeError('Derived constructors may only return object or undefined');
              return (function (e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              })(e);
            })(e, Ce() ? Reflect.construct(o, r || [], Ee(e).constructor) : o.apply(e, r))
          );
        })(this, e, [o, r])).quill = o),
        (a.container = document.createElement('button')),
        (a.container.type = 'button'),
        a.container.classList.add('textarea-emoji-control'),
        a.container.classList.add('ql-list'),
        (a.container.innerHTML = r.buttonIcon),
        a.quill.container.parentElement.querySelector('.ql-toolbar > .ql-formats:last-child').appendChild(a.container),
        a.container.addEventListener('click', a.checkEmojiBoxExist.bind(a), !1),
        a
      );
    }
    return (
      (function (e, o) {
        if ('function' != typeof o && null !== o)
          throw new TypeError('Super expression must either be null or a function');
        (e.prototype = Object.create(o && o.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })),
          Object.defineProperty(e, 'prototype', { writable: !1 }),
          o && Ae(e, o);
      })(e, qe),
      (o = e),
      (r = [
        {
          key: 'checkEmojiBoxExist',
          value: function () {
            var e = document.getElementById('textarea-emoji');
            if (e) e.remove();
            else {
              var o = document.createElement('div');
              (o.id = 'textarea-emoji'), this.quill.container.parentElement.querySelector('.ql-toolbar').appendChild(o);
              var r = document.createElement('div');
              (r.id = 'tab-toolbar'), o.appendChild(r);
              var a = document.createElement('ul');
              r.appendChild(a);
              var n = document.createElement('div');
              (n.id = 'tab-panel'), o.appendChild(n);
              var t = this.quill;
              [
                { type: 'p', name: 'people', content: '<div class="i-people"></div>' },
                { type: 'n', name: 'nature', content: '<div class="i-nature"></div>' },
                { type: 'd', name: 'food', content: '<div class="i-food"></div>' },
                { type: 's', name: 'symbols', content: '<div class="i-symbols"></div>' },
                { type: 'a', name: 'activity', content: '<div class="i-activity"></div>' },
                { type: 't', name: 'travel', content: '<div class="i-travel"></div>' },
                { type: 'o', name: 'objects', content: '<div class="i-objects"></div>' },
                { type: 'f', name: 'flags', content: '<div class="i-flags"></div>' },
              ].map(function (e) {
                var o = document.createElement('li');
                o.classList.add('emoji-tab'), o.classList.add('filter-' + e.name);
                var r = e.content;
                (o.innerHTML = r), (o.dataset.filter = e.type), a.appendChild(o);
                var i = document.querySelector('.filter-' + e.name);
                i.addEventListener('click', function () {
                  var e = document.getElementById('textarea-emoji'),
                    o = e && e.querySelector('.active');
                  for (o && o.classList.remove('active'), i.classList.toggle('active'); n.firstChild; )
                    n.removeChild(n.firstChild);
                  Be(i.dataset.filter, n, t);
                });
              });
              var i = window.innerHeight;
              this.quill.container.getBoundingClientRect().top > i / 2 && (o.style.top = '-250px'),
                (function (e, o) {
                  Be('p', e, o), document.querySelector('.filter-people').classList.add('active');
                })(n, this.quill);
            }
          },
        },
      ]) &&
        (function (e, o) {
          for (var r = 0; r < o.length; r++) {
            var a = o[r];
            (a.enumerable = a.enumerable || !1),
              (a.configurable = !0),
              'value' in a && (a.writable = !0),
              Object.defineProperty(e, xe(a.key), a);
          }
        })(o.prototype, r),
      Object.defineProperty(o, 'prototype', { writable: !1 }),
      o
    );
    var o, r;
  })();
function Be(e, o, a) {
  var n = new ae(r, {
    shouldSort: !0,
    matchAllTokens: !0,
    threshold: 0.3,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 3,
    keys: ['category'],
  }).search(e);
  n.sort(function (e, o) {
    return e.emoji_order - o.emoji_order;
  }),
    a.focus(),
    n.map(function (e) {
      var r = e.item,
        n = document.createElement('span'),
        i = document.createTextNode(r.shortname);
      n.appendChild(i),
        n.classList.add('bem'),
        n.classList.add('bem-' + r.name),
        n.classList.add('ap'),
        (n.innerText = r.unicode),
        o.appendChild(n);
      var c = document.querySelector('.bem-' + r.name);
      c &&
        c.addEventListener('click', function () {
          var e = a.getSelection(!0);
          a.insertText(e.index, r.unicode, t.default.sources.USER),
            (e.index += 1),
            setTimeout(function () {
              return a.setSelection(e.index + 1);
            }, 0);
        });
    });
}
Se.DEFAULTS = {
  buttonIcon:
    '<svg viewbox="0 0 18 18"><circle class="ql-fill" cx="7" cy="7" r="1"></circle><circle class="ql-fill" cx="11" cy="7" r="1"></circle><path class="ql-stroke" d="M7,10a2,2,0,0,0,4,0H7Z"></path><circle class="ql-stroke" cx="9" cy="9" r="6"></circle></svg>',
};
const Me = Se;
export { j as EmojiBlot, ge as ShortNameEmoji, Me as TextAreaEmoji, ke as ToolbarEmoji };
//# sourceMappingURL=quill-emoji.js.map
